<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div :data-theme="!charge_error && !charge_success && (themeCheckout.theme || 'light')
    " :data-theme_color="themeCheckout.theme_color || '#00E4A0'">
    <!-- att -->
    <div v-show="preload" class="carregando">
      <div>
        <img src="@/assets/img/_logo.svg" alt="logo-loading" class="logo-loading" />
        <span class="loading-carregando"></span>
      </div>
    </div>
    <div>
      <template v-if="themeCheckout.top_thumb && !charge_error && !charge_success">
        <Escassez v-if="
          themeCheckout.scarcity == 'on' &&
          (product_type == 'COMMON'
            ? product.status == 'APPROVED'
            : product.product.status == 'APPROVED')
        " style="min-height: 100px" :class="{ 'is-stick': !isMobile }" :mobile="isMobile"
          :dados="themeCheckout.scarcity == 'on' ? escassez : {}" :product_id="product.product_id || product.id" />
        <div class="container banner-container banner-top" :class="{
          has_escassez:
            themeCheckout.scarcity == 'on' &&
            (product_type == 'COMMON'
              ? product.status == 'APPROVED'
              : product.product.status == 'APPROVED'),
        }">
          <img :src="themeCheckout.top_thumb" alt="top-thumb" class="banner" />
        </div>
      </template>
      <Navbar v-else :logo="themeCheckout.logotipo" :escassez="themeCheckout.scarcity == 'on' &&
        (product_type == 'COMMON'
          ? product.status == 'APPROVED'
          : product.product.status == 'APPROVED')
        " :mobile="isMobile" :dados_escassez="themeCheckout.scarcity == 'on' ? escassez : {}"
        :product_id="product.product_id || product.id" :theme="themeCheckout.theme" />
      <!-- Body -->
      <b-container class="gray">
        <b-row style="position: relative" :class="{
          'justify-content-center': charge_success || charge_error,
          'padding-checkout': !themeCheckout.top_thumb && !isMobile,
          'padding-checkout mobile': isMobile,
          thumb: themeCheckout.top_thumb,
          escassez:
            themeCheckout.scarcity == 'on' &&
            (product_type == 'COMMON'
              ? product.status == 'APPROVED'
              : product.product.status == 'APPROVED'),
        }">
          <!-- Purchase Form -->
          <b-col cols="12" md="8" order="3" order-md="1" class="pr-md-0">
            <b-overlay :show="loading" rounded="sm">
              <div v-if="!charge_error && !charge_success" class="Checkout" data-anima="top">
                <a v-if="isMobile && etapa_atual > 1" href="#" class="btn-voltar-step" @click.prevent="previous_step">
                  <img src="@/assets/img/icon/arrow.svg" alt="icon-arrow" />
                  Voltar
                </a>
                <b-form v-show="!isMobile || (!address_step && !last_step)" data-anima="top" data-vv-scope="pessoal">
                  <template>
                    <!-- Linguagens -->
                    <Locales />

                    <div class="Checkout-title">
                      <span class="Checkout-title-number">01</span>
                      <!-- Dados Pessoais -->
                      {{ $t("checkout.dados_pessoais.title") }}
                    </div>

                    <b-row>
                      <!-- Name -->
                      <b-col cols="12">
                        <b-form-group :label="$t('checkout.dados_pessoais.nome')" label-for="name">
                          <b-form-input id="name" v-model="data.name" data-test="name" type="text" maxlength="150"
                            @input="debounceSave" :placeholder="$t('checkout.dados_pessoais.nome_holder')
                              " name="name" :state="submit ? !errors.has('pessoal.name') : null"
                            v-validate="'required'" v-on:keyup.native="validateForm" :disabled="data.isValidToken"
                            v-on:blur="trackEvent"></b-form-input>

                          <b-form-invalid-feedback :state="submit ? !errors.has('pessoal.name') : null">
                            {{ $t("checkout.dados_pessoais.feedbacks.nome") }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <!-- E-mail -->
                      <b-col cols="12">
                        <b-form-group :label="$t('checkout.dados_pessoais.email')" label-for="email">
                          <b-form-input id="email" data-test="email" v-model="data.email" @input="debounceSave"
                            :placeholder="$t('checkout.dados_pessoais.email_holder')
                              " type="text" name="email" ref="email" :state="submit ? !errors.has('pessoal.email') : null
                                " v-validate="'required|email'" v-on:keyup.native="validateForm"
                            :disabled="data.isValidToken" v-on:blur="trackEvent"></b-form-input>
                          <b-form-invalid-feedback :state="submit ? !errors.has('pessoal.email') : null
                            ">
                            {{ $t("checkout.dados_pessoais.feedbacks.email") }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <!-- Confirmação de email -->
                      <b-col cols="12" v-if="confirmation_email">
                        <b-form-group :label="$t('checkout.dados_pessoais.confirmation_email')
                          " label-for="confirmation_email">
                          <b-form-input autocomplete="off" id="confirmation_email" data-test="confirmation_email"
                            v-model="data.confirmation_email" @input="debounceSave" :placeholder="$t(
                              'checkout.dados_pessoais.confirmation_email_holder'
                            )
                              " type="text" :state="submit ? !errors.has('pessoal.confirmation_email') : null"
                            v-validate="'required|email|confirmed:email'" name="confirmation_email"
                            v-on:keyup.native="validateForm" :disabled="data.isValidToken"
                            v-on:blur="trackEvent"></b-form-input>
                          <b-form-invalid-feedback :state="submit ? !errors.has('pessoal.confirmation_email') : null">
                            {{
                              $t(
                                "checkout.dados_pessoais.feedbacks.confirmation_email"
                              )
                            }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <!-- Telephone / Documents -->
                    <b-row>
                      <!-- Telephone -->
                      <b-col cols="12" md="12" lg="7">
                        <b-form-group :label="$t('checkout.dados_pessoais.telefone')" label-for="cellphone">
                          <VuePhoneNumberInput :disabled="data.isValidToken" :default-country-code="countryGlobal"
                            :translations="$i18n.locale == 'pt'
                              ? translations_pt
                              : translations_en
                              " :error="submit && !results_tel.isValid ? true : null"
                            :color="themeCheckout.theme === 'light' ? '#000000' : '#f7f7f7'"
                            :valid-color="themeCheckout.theme === 'light' ? '#000000' : '#f7f7f7'" error-color="#ff0c37"
                            size="lg" :preferred-countries="[
                              'BR',
                              'PT',
                              'US',
                              'FR',
                              'ES',
                            ]" ref="telinput" :required="true" :countries-height="50" :border-radius="5"
                            v-model="yourValue" @input="debounceSave" @phone-number-blur="() => {
                              blurInputPhone();
                              trackEvent({
                                currentTarget: {
                                  name: 'phone_number',
                                  value: results_tel,
                                },
                              });
                            }
                              " @update="(event) => {
                                if (results_tel.countryCode !== event.countryCode && results_tel.countryCode !== undefined) {
                                  trackEvent({
                                    currentTarget: {
                                      name: 'phone_ddd',
                                      value: results_tel,
                                    },
                                  });
                                }
                                results_tel = event;
                                const phone = event.formatNational?.indexOf(')') > -1 ? event.formatNational : event.phoneNumber;
                                results_tel.isValid = event.countryCode === 'BR' && (phone?.length == 14 || phone?.length == 15) && phone?.indexOf(')') > -1
                                  ? true
                                  : event.countryCode !== 'BR' && phone?.length > 0 ? true : false;
                              }
                                " data-test="cellphone" />
                          <b-form-invalid-feedback class="mt-3" :state="submit && !results_tel.isValid ? false : null">
                            {{
                              $t("checkout.dados_pessoais.feedbacks.celular")
                            }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>

                      <!-- CPF / CNPJ -->
                      <b-col v-if="countryGlobal === 'BR'" cols="12" lg="5" md="12">
                        <b-form-group :label="$t('checkout.dados_pessoais.document')" label-for="cpf_cnpj">
                          <b-form-input id="cpf_cnpj" data-test="cpf_cnpj" v-model="data.document" @input="debounceSave"
                            :placeholder="$t('checkout.dados_pessoais.document_holder')
                              " type="text" name="document" v-validate="'required|cpf_cnpj'"
                            v-mask="['###.###.###-##', '##.###.###/####-##']" v-on:keyup.native="validateForm"
                            :disabled="data.isValidToken" v-on:blur="trackEvent"
                            :state="submit ? !errors.has('pessoal.document') : null"></b-form-input>
                          <b-form-invalid-feedback :state="submit ? !errors.has('pessoal.document') : null
                            ">
                            Preencha seu CPF ou CNPJ.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <!-- RFC Document Number -->
                      <b-col v-if="countryGlobal === 'MXTTT'" cols="12" lg="5" md="12">
                        <b-form-group label="Número RFC" label-for="document">
                          <b-form-input id="document" data-test="document" v-model="data.document" @input="debounceSave"
                            placeholder="Número RFC" type="text" v-mask="['XXXXXXXXXXXXXXXXXXXXXXXXX']" name="document"
                            v-validate="'required'" v-on:keyup.native="validateForm" :disabled="data.isValidToken"
                            v-on:blur="trackEvent"></b-form-input>
                          <b-form-invalid-feedback :state="submit ? !errors.has('pessoal.document') : null
                            ">
                            Rellena tu documento.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <!-- CI Document Number -->
                      <b-col v-if="countryGlobal === 'UYTTT'" cols="12" lg="5" md="12">
                        <b-form-group label="Número CI" label-for="document">
                          <b-form-input id="document" data-test="document" v-model="data.document" @input="debounceSave"
                            placeholder="Número CI" type="text" name="document" v-validate="'required'"
                            v-on:keyup.native="validateForm" :disabled="data.isValidToken"
                            v-on:blur="trackEvent"></b-form-input>
                          <b-form-invalid-feedback :state="submit ? !errors.has('pessoal.document') : null
                            ">
                            Rellena tu documento.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <!-- CUIT/CUIL/DNI Document Number -->
                      <b-col v-if="countryGlobal === 'ARTTT'" cols="12" lg="5" md="12">
                        <b-form-group label="CUIT/CUIL o DNI" label-for="document">
                          <b-form-input id="document" data-test="document" v-model="data.document" @input="debounceSave"
                            placeholder="CUIT/CUIL o DNI" type="text" name="document" v-mask="['#####################']"
                            v-validate="'required'" v-on:keyup.native="validateForm" :disabled="data.isValidToken"
                            v-on:blur="trackEvent"></b-form-input>
                          <b-form-invalid-feedback :state="submit ? !errors.has('pessoal.document') : null
                            ">
                            Rellena tu documento.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <!-- Añadir RUT Document Number -->
                      <b-col v-if="countryGlobal === 'CLTTT'" cols="12" lg="5" md="12">
                        <b-form-group label="Añadir RUT" label-for="document">
                          <b-form-input id="document" data-test="document" v-model="data.document" @input="debounceSave"
                            placeholder="Añadir RUT" type="text" name="document" v-mask="['#####################']"
                            v-validate="'required'" v-on:keyup.native="validateForm" :disabled="data.isValidToken"
                            v-on:blur="trackEvent"></b-form-input>
                          <b-form-invalid-feedback :state="submit ? !errors.has('pessoal.document') : null
                            ">
                            Rellena tu documento.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <!-- State USA -->
                      <b-col v-if="countryGlobal === 'USTTT'" cols="12" lg="8" md="12">
                        <b-form-group label="State" label-for="document">
                          <b-form-select id="document" data-test="document" :value="null" v-model="data.document"
                            @input="debounceSave" placeholder="Select your state" v-validate="'required'"
                            name="document" v-on:keyup.native="validateForm" :disabled="data.isValidToken"
                            :options="optionsStateUS"></b-form-select>
                          <b-form-invalid-feedback :state="submit ? !errors.has('pessoal.document') : null
                            ">
                            Fill in your state.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <!-- Mobile Button Next Step -->
                    <template v-if="
                      isMobile &&
                      (themeCheckout.step_checkout === 'default' ||
                        !themeCheckout.step_checkout)
                    ">
                      <b-row class="mt-3 justify-content-end">
                        <b-col cols="12">
                          <b-button v-if="etapa_total == 3" class="col-12 btn-green" :disabled="loading" type="button"
                            variant="primary" @click="nextStep('address', 'pessoal')">
                            {{ $t("checkout.mobile.proxima_etapa") }}
                          </b-button>
                          <b-button v-else class="col-12 btn-green" :disabled="loading" type="button" variant="primary"
                            @click="nextStep('pagamento', 'pessoal')">
                            {{ $t("checkout.mobile.proxima_etapa") }}
                          </b-button>
                        </b-col>
                      </b-row>
                    </template>
                  </template>
                </b-form>

                <b-form v-show="!isMobile ||
                  (address_step && !last_step) ||
                  themeCheckout.step_checkout == 'one_step'
                  " data-vv-scope="address" data-anima="top" style="z-index: -1; position: relative">
                  <template v-if="countryGlobal === 'BR'">
                    <!-- Address -->
                    <template v-if="showAddress()">
                      {{ hasAddress() }}
                      <div class="Checkout-title mt-4">
                        <span class="Checkout-title-number">02</span>
                        Endereço
                      </div>

                      <b-row>
                        <!-- Zipcode -->
                        <b-col cols="12" lg="4" md="12">
                          <b-form-group label="CEP" label-for="zipcode">
                            <b-form-input data-test="zipcode" id="zipcode" v-model="data.zipcode" @input="debounceSave"
                              placeholder="CEP" type="text" name="zipcode" :state="submit ? !errors.has('address.zipcode') : null
                                " v-mask="['#####-###']" v-validate="'required'" @keyup="getCEP('charge')"
                              v-on:keyup.native="validateForm" v-on:blur="trackEvent"></b-form-input>
                            <b-form-invalid-feedback :state="submit ? !errors.has('address.zipcode') : null
                              ">
                              Preencha seu CEP.
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- Street -->
                        <b-col cols="12" lg="5" md="12">
                          <b-form-group label="Logradouro" label-for="street">
                            <b-form-input data-test="street" data-street-group="true" id="street" v-model="data.street"
                              @input="debounceSave" placeholder="Digite o Logradouro" type="text" name="street" :state="submit ? !errors.has('address.street') : null
                                " v-validate="'required'" v-on:keyup.native="validateForm"
                              v-on:blur="trackEvent"></b-form-input>
                            <b-form-invalid-feedback :state="submit ? !errors.has('address.street') : null
                              ">
                              Preencha seu logradouro.
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- Number -->
                        <b-col cols="12" lg="3" md="12">
                          <b-form-group label="Número" label-for="number">
                            <b-form-input data-test="number" id="number-address" v-model="data.number"
                              @input="debounceSave" placeholder="Número" type="number" name="number" :state="submit ? !errors.has('address.number') : null
                                " v-validate="'required|numeric'" v-on:keyup.native="validateForm"
                              v-on:blur="trackEvent"></b-form-input>
                            <b-form-invalid-feedback :state="submit ? !errors.has('address.number') : null
                              ">
                              Preencha corretamente o número.
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <!-- City -->
                        <b-col cols="12" md="6">
                          <b-form-group label="Cidade" label-for="city">
                            <b-form-input data-test="city" data-street-group="true" id="city" v-model="data.city"
                              @input="debounceSave" placeholder="Cidade" type="text" name="city" :state="submit ? !errors.has('address.city') : null
                                " v-validate="'required'" v-on:keyup.native="validateForm"
                              v-on:blur="trackEvent"></b-form-input>
                            <b-form-invalid-feedback :state="submit ? !errors.has('address.city') : null
                              ">
                              Preencha sua cidade.
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- Neighborhood -->
                        <b-col cols="12" md="6">
                          <b-form-group label="Bairro" label-for="neighborhood">
                            <b-form-input data-test="neighborhood" data-street-group="true" id="neighborhood"
                              v-model="data.neighborhood" @input="debounceSave" placeholder="Bairro" type="text"
                              name="neighborhood" :state="submit
                                ? !errors.has('address.neighborhood')
                                : null
                                " v-validate="'required'" v-on:keyup.native="validateForm"
                              v-on:blur="trackEvent"></b-form-input>
                            <b-form-invalid-feedback :state="submit
                              ? !errors.has('address.neighborhood')
                              : null
                              ">
                              Preencha seu bairro.
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <!-- Complement -->
                        <b-col cols="12" lg="7" md="12">
                          <b-form-group label="Complemento" label-for="complement">
                            <b-form-input data-test="complement" id="complement" @input="debounceSave"
                              v-model="data.complement" placeholder="Complemento do Endereço" type="text"
                              name="complement" v-on:blur="trackEvent"></b-form-input>
                          </b-form-group>
                        </b-col>
                        <!-- State -->
                        <b-col cols="12" lg="5" md="12">
                          <b-form-group label="Estado" label-for="state">
                            <b-form-select data-test="state" data-street-group="true" id="state" v-model="data.state"
                              @input="debounceSave && validateForm" type="text" name="state" :state="submit ? !errors.has('address.state') : null
                                " v-validate="'required'" class="mb-3">
                              <b-form-select-option disabled :value="null">Selecione um Estado</b-form-select-option>
                              <b-form-select-option value="AC">Acre</b-form-select-option>
                              <b-form-select-option value="AL">Alagoas</b-form-select-option>
                              <b-form-select-option value="AP">Amapá</b-form-select-option>
                              <b-form-select-option value="AM">Amazonas</b-form-select-option>
                              <b-form-select-option value="BA">Bahia</b-form-select-option>
                              <b-form-select-option value="CE">Ceará</b-form-select-option>
                              <b-form-select-option value="DF">Distrito Federal</b-form-select-option>
                              <b-form-select-option value="ES">Espírito Santo</b-form-select-option>
                              <b-form-select-option value="GO">Goiás</b-form-select-option>
                              <b-form-select-option value="MA">Maranhão</b-form-select-option>
                              <b-form-select-option value="MT">Mato Grosso</b-form-select-option>
                              <b-form-select-option value="MS">Mato Grosso do Sul</b-form-select-option>
                              <b-form-select-option value="MG">Minas Gerais</b-form-select-option>
                              <b-form-select-option value="PA">Pará</b-form-select-option>
                              <b-form-select-option value="PB">Paraíba</b-form-select-option>
                              <b-form-select-option value="PR">Paraná</b-form-select-option>
                              <b-form-select-option value="PE">Pernambuco</b-form-select-option>
                              <b-form-select-option value="PI">Piauí</b-form-select-option>
                              <b-form-select-option value="RJ">Rio de Janeiro</b-form-select-option>
                              <b-form-select-option value="RN">Rio Grande do Norte</b-form-select-option>
                              <b-form-select-option value="RS">Rio Grande do Sul</b-form-select-option>
                              <b-form-select-option value="RO">Rondônia</b-form-select-option>
                              <b-form-select-option value="RR">Roraima</b-form-select-option>
                              <b-form-select-option value="SC">Santa Catarina</b-form-select-option>
                              <b-form-select-option value="SP">São Paulo</b-form-select-option>
                              <b-form-select-option value="SE">Sergipe</b-form-select-option>
                              <b-form-select-option value="TO">Tocantins</b-form-select-option>
                            </b-form-select>
                            <b-form-invalid-feedback :state="submit ? !errors.has('address.state') : null
                              ">
                              Selecione seu estado.
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- Delivery Address Checkbox-->
                        <b-col v-if="is_produto_fisico" cols="12" class="mt-2" data-anima="top">
                          <b-form-checkbox v-model="data.billing_shipping_same_address" name="check-button" switch
                            @change="changeEnderecoEntrega">
                            Endereço
                            {{ data.is_gift ? "do presente" : "de entrega" }} é
                            o mesmo da cobrança
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                    </template>

                    <!-- Delivery Address -->
                    <template v-if="
                      !data.billing_shipping_same_address && is_produto_fisico
                    ">
                      <div data-anima="top">
                        <div class="Checkout-title mt-4">
                          <span class="Checkout-title-number">📦</span>
                          {{
                            data.is_gift
                              ? "Para onde devemos enviar o presente"
                              : "Endereço de Entrega"
                          }}
                        </div>
                        <b-row>
                          <!-- Shipping Zipcode -->
                          <b-col cols="12" lg="4" md="12">
                            <b-form-group label="CEP" label-for="shipping_zipcode">
                              <b-form-input data-test="shipping_zipcode" id="shipping_zipcode"
                                v-model="shipping.address.zipcode" @input="debounceSave" placeholder="CEP" type="text"
                                name="shipping_zipcode" :state="submit
                                  ? !errors.has('address.shipping_zipcode')
                                  : null
                                  " v-mask="['#####-###']" v-validate="'required'" @keyup="getCEP('shipping')"
                                v-on:keyup.native="validateForm" v-on:blur="trackEvent"></b-form-input>
                              <b-form-invalid-feedback :state="submit
                                ? !errors.has('address.shipping_zipcode')
                                : null
                                ">
                                Preencha o CEP de entrega.
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                          <!-- Shipping Street -->
                          <b-col cols="12" lg="5" md="12">
                            <b-form-group label="Logradouro" label-for="shipping_street">
                              <b-form-input id="shipping_street" v-model="shipping.address.street"
                                data-test="shipping_street" data-street-group="true" @input="debounceSave"
                                placeholder="Digite o Logradouro" type="text" name="shipping_street" :state="submit
                                  ? !errors.has('address.shipping_street')
                                  : null
                                  " v-validate="'required'" v-on:keyup.native="validateForm"
                                v-on:blur="trackEvent"></b-form-input>
                              <b-form-invalid-feedback :state="submit
                                ? !errors.has('address.shipping_street')
                                : null
                                ">
                                Preencha o logradouro.
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                          <!-- Shipping Number -->
                          <b-col cols="12" lg="3" md="12">
                            <b-form-group label="Número" label-for="shipping_number">
                              <b-form-input id="number-address-shipping" v-model="shipping.address.number"
                                data-test="shipping_number" @input="debounceSave" placeholder="Número" type="text"
                                name="shipping_number" :state="submit
                                  ? !errors.has('address.shipping_number')
                                  : null
                                  " v-validate="'required|numeric'" v-on:keyup.native="validateForm"
                                v-on:blur="trackEvent"></b-form-input>
                              <b-form-invalid-feedback :state="submit
                                ? !errors.has('address.shipping_number')
                                : null
                                ">
                                Preencha corretamente o número.
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <!-- Shipping City -->
                          <b-col cols="12" md="6">
                            <b-form-group label="Cidade" label-for="shipping_city">
                              <b-form-input id="shipping_city" v-model="shipping.address.city" data-test="shipping_city"
                                data-street-group="true" @input="debounceSave" placeholder="Cidade" type="text"
                                name="shipping_city" :state="submit
                                  ? !errors.has('address.shipping_city')
                                  : null
                                  " v-validate="'required'" v-on:keyup.native="validateForm"
                                v-on:blur="trackEvent"></b-form-input>
                              <b-form-invalid-feedback :state="submit
                                ? !errors.has('address.shipping_city')
                                : null
                                ">
                                Preencha a cidade.
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                          <!-- Shipping Neighborhood -->
                          <b-col cols="12" md="6">
                            <b-form-group label="Bairro" label-for="shipping_neighborhood">
                              <b-form-input id="shipping_neighborhood" v-model="shipping.address.neighborhood"
                                data-test="shipping_neighborhood" data-street-group="true" @input="debounceSave"
                                placeholder="Bairro" type="text" name="shipping_neighborhood" :state="submit
                                  ? !errors.has(
                                    'address.shipping_neighborhood'
                                  )
                                  : null
                                  " v-validate="'required'" v-on:keyup.native="validateForm"
                                v-on:blur="trackEvent"></b-form-input>
                              <b-form-invalid-feedback :state="submit
                                ? !errors.has(
                                  'address.shipping_neighborhood'
                                )
                                : null
                                ">
                                Preencha o bairro.
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <!-- Shipping Complement -->
                          <b-col cols="12" lg="7" md="12">
                            <b-form-group label="Complemento" label-for="shipping_complement">
                              <b-form-input data-test="shipping_complement" id="shipping_complement"
                                @input="debounceSave" v-model="shipping.address.complement"
                                placeholder="Complemento do Endereço" type="text" name="shipping_complement"
                                v-on:blur="trackEvent"></b-form-input>
                            </b-form-group>
                          </b-col>
                          <!-- Shipping State -->
                          <b-col cols="12" lg="5" md="12">
                            <b-form-group label="Estado" label-for="shipping_state">
                              <b-form-input id="shipping_state" v-model="shipping.address.state"
                                data-test="shipping_state" data-street-group="true" @input="debounceSave"
                                placeholder="Estado" type="text" name="shipping_state" :state="submit
                                  ? !errors.has('address.shipping_state')
                                  : null
                                  " v-validate="'required'" v-on:keyup.native="validateForm"
                                v-on:blur="trackEvent"></b-form-input>
                              <b-form-invalid-feedback :state="submit
                                ? !errors.has('address.shipping_state')
                                : null
                                ">
                                Preencha o estado.
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </div>
                    </template>
                    <!-- Shipping Options -->
                    <div v-if="data.zipcode && data.has_shipping_fee" data-anima="top" class="opcoes-frete">
                      <legend>Selecione o Frete</legend>
                      <!-- Loading -->
                      <div v-if="loading_frete">
                        <b-spinner label="Loading..."></b-spinner>
                      </div>
                      <b-form-group v-if="
                        options_shipping.length &&
                        data.has_shipping_fee &&
                        !loading_frete
                      " v-slot="{ ariaDescribedby }">
                        <b-dropdown-divider v-for="frete in options_shipping" :key="frete.id" class="frete-item">
                          <b-form-radio v-model="shipping.service_id" name="frete" :aria-describedby="ariaDescribedby"
                            :value="frete.id" @change="changeFrete(frete, $event)">
                            <div class="infos-frete">
                              <img :src="frete.company.picture" />
                              <div class="info-envio">
                                <span>
                                  {{ frete.name }}
                                </span>
                                <span v-if="frete.delivery_range">
                                  {{ frete.delivery_range.min }} à
                                  {{ frete.delivery_range.max }} dias úteis
                                </span>
                                <span class="frete-valor">
                                  {{ filterCurrency(currency_id) }}
                                  {{ formatMoney(+frete.price, $i18n.locale) }}
                                </span>
                              </div>
                            </div>
                          </b-form-radio>
                        </b-dropdown-divider>
                      </b-form-group>
                    </div>
                    <!-- Mobile Button Next Step -->
                    <template v-if="
                      isMobile &&
                      (themeCheckout.step_checkout == 'default' ||
                        !themeCheckout.step_checkout)
                    ">
                      <b-row class="mt-2 justify-content-end">
                        <b-col cols="12">
                          <b-button data-test="nextstep" class="col-12 btn-green" :disabled="loading" type="button"
                            variant="primary" @click="nextStep('pagamento', 'address')">Próxima etapa
                          </b-button>
                        </b-col>
                      </b-row>
                    </template>
                  </template>
                </b-form>

                <b-form v-show="!isMobile ||
                  (last_step && !address_step) ||
                  themeCheckout.step_checkout == 'one_step'
                  " data-vv-scope="pay" data-anima="bottom" style="z-index: -1; position: relative">
                  <template>
                    <!-- Title of Payment Mehtod -->
                    <div class="Checkout-title mt-4">
                      <span class="Checkout-title-number">
                        0{{ $i18n.locale == "pt" ? etapa_total : 2 }}
                      </span>
                      <!-- Pagamento -->
                      {{ $t("checkout.pagamento.title") }}
                    </div>
                    <!-- Payment Methods -->
                    <b-tabs content-class="mt-3" active-nav-item-class="tab-active mb-2 mb-md-0" :no-nav-style="true"
                      nav-class="nav_pagamento">
                      <b-tab v-if="payment_methods.includes('CREDIT_CARD')" data-test="creditcard"
                        title-link-class="tab-nav-icon CREDIT_CARD" active @click="showBtn('CREDIT_CARD')">
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          <p>
                            {{
                              $t("checkout.pagamento.metodos.cartao_credito")
                            }}
                          </p>
                        </template>

                        <!-- DOIS CARTÕES APENAS SE FOR  'TRANSACTION' -->
                        <b-nav pills class="cartoes-btn" small v-if="
                          // baseado no tipo do produto COMMON
                          (product_type == 'COMMON' &&
                            product.method.includes('TWO_CREDIT_CARDS') &&
                            // tipo de produto for  TRANSACTION
                            product.type == 'TRANSACTION') ||
                          // baseado no tipo do produto PROPOSAL
                          (product_type == 'PROPOSAL' &&
                            product.product.method.includes(
                              'TWO_CREDIT_CARDS'
                            ) &&
                            // tipo de produto for  TRANSACTION
                            product.product.type == 'TRANSACTION')
                        ">
                          <b-nav-item data-test="1cartao" :active="method == 'CREDIT_CARD'" @click="addCard1">
                            <font-awesome-icon icon="credit-card" class="icon mr-2" />
                            {{
                              $t("checkout.pagamento.metodos.um_cartao.title")
                            }}
                          </b-nav-item>
                          <b-nav-item data-test="2cartoes" :active="method == 'TWO_CREDIT_CARDS'" @click="addCard2">
                            <font-awesome-icon icon="credit-card" class="icon mr-1" /><font-awesome-icon
                              icon="credit-card" class="icon mr-2" />
                            {{
                              $t(
                                "checkout.pagamento.metodos.dois_cartoes.title"
                              )
                            }}
                          </b-nav-item>
                        </b-nav>

                        <b-row v-if="
                          method == 'CREDIT_CARD' ||
                          method == 'TWO_CREDIT_CARDS'
                        " data-anima="top">
                          <!-- Cartao 01 -->
                          <b-col cols="12" :md="mdFormCard" data-anima="top" id="dados-card">
                            <span v-if="method == 'TWO_CREDIT_CARDS'" class="card-tag">
                              {{
                                $t(
                                  "checkout.pagamento.metodos.dois_cartoes.flag"
                                )
                              }}
                              01
                            </span>
                            <b-form-group v-if="method == 'TWO_CREDIT_CARDS'" :label="$t(
                              'checkout.pagamento.metodos.dois_cartoes.valor'
                            )
                              " label-for="card_amount">
                              <b-form-input data-test="cardamount1" id="card_amount" v-model="data.cards[0].amount"
                                @input="firstCard" type="text" :placeholder="`${filterCurrency(currency_id)} 100,00`
                                  " name="card_amount" v-validate="'required'" :state="submit
                                    ? formatValueToValidation(
                                      data.cards[0].amount
                                    )
                                    : null
                                    " v-on:blur="trackEvent"></b-form-input>
                              <b-form-invalid-feedback :state="submit
                                ? formatValueToValidation(
                                  data.cards[0].amount
                                )
                                : null
                                ">
                                {{
                                  $t(
                                    "checkout.pagamento.feedbacks.valor_cartao"
                                  )
                                }}
                              </b-form-invalid-feedback>
                            </b-form-group>

                            <template v-if="gateway !== 'stripe'">
                              <b-form-group :label="$t(
                                'checkout.pagamento.metodos.um_cartao.numero'
                              )
                                " label-for="card_number">
                                <b-form-input data-test="cardnumber1" id="card_number" v-model="data.cards[0].number"
                                  type="text" :placeholder="$t(
                                    'checkout.pagamento.metodos.um_cartao.numero_holder'
                                  )
                                    " name="card_number" :state="submit
                                      ? !(
                                        errors.has('pay.card_number') ||
                                        card_number_error
                                      ) : null
                                      " v-validate="'required'" v-mask="generateCardNumberMask" v-on:focus="focusInput"
                                  v-on:blur="(event) => {
                                    blurInput(event);
                                    trackEvent(event);
                                  }
                                    " data-ref="cardNumber"></b-form-input>
                                <b-form-invalid-feedback :state="submit ? !(
                                  errors.has('pay.card_number') ||
                                  card_number_error
                                ) : null
                                  ">
                                  {{
                                    $t(
                                      "checkout.pagamento.feedbacks.numero_cartao"
                                    )
                                  }}
                                </b-form-invalid-feedback>
                              </b-form-group>

                              <b-form-group :label="$t(
                                'checkout.pagamento.metodos.um_cartao.titular'
                              )
                                " label-for="card_holder_name">
                                <b-form-input data-test="cardname1" id="card_holder_name"
                                  v-model="data.cards[0].holder_name" type="text" :placeholder="$t(
                                    'checkout.pagamento.metodos.um_cartao.titular_holder'
                                  )
                                    " name="card_holder_name" :state="submit ? !errors.has('pay.card_holder_name') : null
                                      " v-validate="'required'" v-on:focus="focusInput" v-on:blur="(event) => {
                                        blurInput(event);
                                        trackEvent(event);
                                      }
                                        " data-ref="cardName"></b-form-input>
                                <b-form-invalid-feedback :state="submit ? !errors.has('pay.card_holder_name') : null
                                  ">
                                  {{
                                    $t(
                                      "checkout.pagamento.feedbacks.titular_cartao"
                                    )
                                  }}
                                </b-form-invalid-feedback>
                              </b-form-group>

                              <b-row>
                                <b-col cols="12" md="8">
                                  <b-row>
                                    <b-col cols="12" md="6">
                                      <b-form-group :label="$t(
                                        'checkout.pagamento.metodos.um_cartao.mes'
                                      )
                                        " label-for="card_month">
                                        <b-form-select data-test="cardmonth1" v-model="data.cards[0].month" class="mb-3"
                                          id="card_month" name="card_month" v-validate="'required'" :state="submit ? !errors.has('pay.card_month') : null
                                            " v-on:change="(value) =>
                                              trackEvent({
                                                currentTarget: {
                                                  name: 'card_month',
                                                  value,
                                                },
                                              })
                                              ">
                                          <b-form-select-option value="">
                                            {{
                                              $t(
                                                "checkout.pagamento.metodos.um_cartao.mes"
                                              )
                                            }}
                                          </b-form-select-option>
                                          <b-form-select-option v-for="n in 12" :key="n" :value="n < 10 ? '0' + n : n"
                                            :disabled="n < minCardMonth">
                                            {{ 10 > n ? "0" + n : n }}
                                          </b-form-select-option>
                                        </b-form-select>
                                        <b-form-invalid-feedback :state="submit ? !errors.has(
                                          'pay.credit_card.card_month'
                                        ) : null
                                          ">
                                          {{
                                            $t(
                                              "checkout.pagamento.feedbacks.mes_cartao"
                                            )
                                          }}
                                        </b-form-invalid-feedback>
                                      </b-form-group>
                                    </b-col>

                                    <b-col cols="12" md="6">
                                      <b-form-group :label="$t(
                                        'checkout.pagamento.metodos.um_cartao.ano'
                                      )
                                        " label-for="card_year">
                                        <b-form-select id="card_year" v-model="data.cards[0].year" data-test="cardyear1"
                                          class="mb-3" name="card_year" v-validate="'required'" :state="submit ? !errors.has('pay.card_year') : null
                                            " v-on:change="(value) =>
                                              trackEvent({
                                                currentTarget: {
                                                  name: 'card_year',
                                                  value,
                                                },
                                              })
                                              ">
                                          <b-form-select-option value="">
                                            {{
                                              $t(
                                                "checkout.pagamento.metodos.um_cartao.ano"
                                              )
                                            }}
                                          </b-form-select-option>
                                          <b-form-select-option v-for="(n, $index) in 12" :key="n"
                                            :value="$index + minCardYear">
                                            {{ $index + minCardYear }}
                                          </b-form-select-option>
                                        </b-form-select>
                                        <b-form-invalid-feedback :state="submit ? !errors.has(
                                          'pay.credit_card.card_year'
                                        ) : null
                                          ">
                                          {{
                                            $t(
                                              "checkout.pagamento.feedbacks.ano_cartao"
                                            )
                                          }}
                                        </b-form-invalid-feedback>
                                      </b-form-group>
                                    </b-col>
                                  </b-row>
                                </b-col>

                                <b-col cols="12" md="4">
                                  <b-form-group :label="$t(
                                    'checkout.pagamento.metodos.um_cartao.CVV'
                                  )
                                    " label-for="card_cvv">
                                    <b-form-input id="card_cvv" v-model="data.cards[0].cvv" data-test="cardcvv1"
                                      type="text" name="card_cvv" :state="submit ? !errors.has('pay.card_cvv') : null
                                        " v-validate="'required'" maxlength="4" v-mask="'####'"
                                      v-on:focus="flipCard(true)" v-on:blur="(event) => {
                                        flipCard(false);
                                        trackEvent(event);
                                      }
                                        "></b-form-input>
                                    <b-form-invalid-feedback :state="submit ? !errors.has('pay.card_cvv') : null
                                      ">
                                      {{
                                        $t(
                                          "checkout.pagamento.feedbacks.cvv_cartao"
                                        )
                                      }}
                                    </b-form-invalid-feedback>
                                  </b-form-group>
                                </b-col>
                              </b-row>

                            </template>
                            <template v-else>
                              <div class="container p-2 rounded-lg my-4" :class="{
                                'stripe-input-light': themeCheckout.theme === 'light',
                                'stripe-input-dark': themeCheckout.theme !== 'light'
                              }">
                                <div class="row py-2">
                                  <div class="col-12 txt-center">
                                    <section>
                                      <div id="card-stripe" class="stripe-card" ref="card-stripe"></div>
                                    </section>
                                  </div>
                                </div>
                              </div>
                            </template>
                          </b-col>

                          <b-col v-if="gateway !== 'stripe'" cols="12" md="6" data-anima="top" id="_card">
                            <!-- Credit Card -->
                            <card v-if="method == 'CREDIT_CARD'" ref="card" :card_number="data.cards[0].number"
                              :card_holder_name="data.cards[0].holder_name" :card_month="String(data.cards[0].month)"
                              :card_year="String(data.cards[0].year)" :card_cvv="data.cards[0].cvv" />

                            <!-- Cartao 02 -->
                            <template v-if="method == 'TWO_CREDIT_CARDS'">
                              <span class="card-tag">Cartão 02</span>
                              <b-form-group :label="$t(
                                'checkout.pagamento.metodos.dois_cartoes.valor'
                              )
                                " label-for="card_amount">
                                <b-form-input id="card_amount" v-model="data.cards[1].amount" data-test="cardamount2"
                                  @input="secoundCard" type="text" :placeholder="`${filterCurrency(currency_id)} 100,00`
                                    " name="card_amount" :state="submit
                                      ? formatValueToValidation(
                                        data.cards[1].amount
                                      )
                                      : null
                                      " v-validate="'required'"></b-form-input>
                                <b-form-invalid-feedback :state="submit
                                  ? formatValueToValidation(
                                    data.cards[1].amount
                                  )
                                  : null
                                  ">
                                  {{
                                    $t(
                                      "checkout.pagamento.feedbacks.valor_cartao"
                                    )
                                  }}
                                </b-form-invalid-feedback>
                              </b-form-group>

                              <b-form-group :label="$t(
                                'checkout.pagamento.metodos.um_cartao.numero'
                              )
                                " label-for="card_number">
                                <b-form-input id="card_number" v-model="data.cards[1].number" data-test="cardnumber2"
                                  type="text" :placeholder="$t(
                                    'checkout.pagamento.metodos.um_cartao.numero_holder'
                                  )
                                    " name="partial_card_number" :state="submit
                                      ? !(
                                        errors.has(
                                          'pay.partial_card_number'
                                        ) || card_number_error
                                      )
                                      : null
                                      " v-validate="'required'" v-mask="generateCardNumberMask"></b-form-input>
                                <b-form-invalid-feedback :state="submit
                                  ? !(
                                    errors.has(
                                      'pay.partial_card_number'
                                    ) || card_number_error
                                  )
                                  : null
                                  ">
                                  {{
                                    $t(
                                      "checkout.pagamento.feedbacks.numero_cartao"
                                    )
                                  }}
                                </b-form-invalid-feedback>
                              </b-form-group>

                              <b-form-group :label="$t(
                                'checkout.pagamento.metodos.um_cartao.titular'
                              )
                                " label-for="card_holder_name">
                                <b-form-input id="card_holder_name" v-model="data.cards[1].holder_name"
                                  data-test="cardname2" type="text" :placeholder="$t(
                                    'checkout.pagamento.metodos.um_cartao.titular_holder'
                                  )
                                    " name="partial_card_holder_name" :state="submit
                                      ? !errors.has(
                                        'pay.partial_card_holder_name'
                                      )
                                      : null
                                      " v-validate="'required'"></b-form-input>
                                <b-form-invalid-feedback :state="submit
                                  ? !errors.has(
                                    'pay.partial_card_holder_name'
                                  )
                                  : null
                                  ">
                                  {{
                                    $t(
                                      "checkout.pagamento.feedbacks.titular_cartao"
                                    )
                                  }}
                                </b-form-invalid-feedback>
                              </b-form-group>

                              <b-row>
                                <b-col cols="12" md="8">
                                  <b-row>
                                    <b-col cols="12" md="6">
                                      <b-form-group :label="$t(
                                        'checkout.pagamento.metodos.um_cartao.mes'
                                      )
                                        " label-for="card_month">
                                        <b-form-select data-test="cardmonth2" v-model="data.cards[1].month" class="mb-3"
                                          id="card_month" name="partial_card_month" v-validate="'required'" :state="submit
                                            ? !errors.has(
                                              'pay.partial_card_month'
                                            )
                                            : null
                                            ">
                                          <b-form-select-option value="">
                                            {{
                                              $t(
                                                "checkout.pagamento.metodos.um_cartao.mes"
                                              )
                                            }}
                                          </b-form-select-option>
                                          <b-form-select-option v-for="n in 12" :key="n" :value="n < 10 ? '0' + n : n"
                                            :disabled="n < minCardMonth">
                                            {{ 10 > n ? "0" + n : n }}
                                          </b-form-select-option>
                                        </b-form-select>
                                        <b-form-invalid-feedback :state="submit
                                          ? !errors.has(
                                            'pay.partial_card_month'
                                          )
                                          : null
                                          ">
                                          {{
                                            $t(
                                              "checkout.pagamento.feedbacks.mes_cartao"
                                            )
                                          }}
                                        </b-form-invalid-feedback>
                                      </b-form-group>
                                    </b-col>

                                    <b-col cols="12" md="6">
                                      <b-form-group :label="$t(
                                        'checkout.pagamento.metodos.um_cartao.ano'
                                      )
                                        " label-for="card_year">
                                        <b-form-select id="card_year" v-model="data.cards[1].year" data-test="cardyear2"
                                          class="mb-3" name="partial_card_year" v-validate="'required'" :state="submit
                                            ? !errors.has(
                                              'pay.partial_card_year'
                                            )
                                            : null
                                            ">
                                          <b-form-select-option value="">
                                            {{
                                              $t(
                                                "checkout.pagamento.metodos.um_cartao.ano"
                                              )
                                            }}
                                          </b-form-select-option>
                                          <b-form-select-option v-for="(n, $index) in 12" :key="n"
                                            :value="$index + minCardYear">
                                            {{ $index + minCardYear }}
                                          </b-form-select-option>
                                        </b-form-select>
                                        <b-form-invalid-feedback :state="submit
                                          ? !errors.has(
                                            'pay.partial_card_year'
                                          )
                                          : null
                                          ">
                                          {{
                                            $t(
                                              "checkout.pagamento.feedbacks.ano_cartao"
                                            )
                                          }}
                                        </b-form-invalid-feedback>
                                      </b-form-group>
                                    </b-col>
                                  </b-row>
                                </b-col>

                                <b-col cols="12" md="4">
                                  <b-form-group :label="$t(
                                    'checkout.pagamento.metodos.um_cartao.CVV'
                                  )
                                    " label-for="card_cvv">
                                    <b-form-input id="card_cvv" v-model="data.cards[1].cvv" data-test="cardcvv2"
                                      type="text" name="partial_card_cvv" :state="submit
                                        ? !errors.has('pay.partial_card_cvv')
                                        : null
                                        " v-validate="'required'" maxlength="4" v-mask="'####'"></b-form-input>
                                    <b-form-invalid-feedback :state="submit
                                      ? !errors.has('pay.partial_card_cvv')
                                      : null
                                      ">
                                      {{
                                        $t(
                                          "checkout.pagamento.feedbacks.cvv_cartao"
                                        )
                                      }}
                                    </b-form-invalid-feedback>
                                  </b-form-group>
                                </b-col>
                              </b-row>
                            </template>
                          </b-col>
                        </b-row>
                      </b-tab>

                      <b-tab v-if="payment_methods.includes('DEBITCARD')" data-test="creditcard"
                        title-link-class="tab-nav-icon DEBITCARD" active @click="showBtn('DEBITCARD')">
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          <p>
                            {{ $t("checkout.pagamento.metodos.cartao_debito") }}
                          </p>
                        </template>

                        <!-- DOIS CARTÕES APENAS SE FOR  'TRANSACTION' -->

                        <b-row data-anima="top">
                          <!-- Cartao 01 -->
                          <b-col cols="12" md="6" data-anima="top" id="dados-card">
                            <b-form-group :label="$t(
                              'checkout.pagamento.metodos.um_cartao.numero'
                            )
                              " label-for="card_number">
                              <b-form-input data-test="cardnumber1" id="card_number" v-model="data.cards[0].number"
                                type="text" :placeholder="$t(
                                  'checkout.pagamento.metodos.um_cartao.numero_holder'
                                )
                                  " name="card_number" :state="submit
                                    ? !(
                                      errors.has('pay.card_number') ||
                                      card_number_error
                                    )
                                    : null
                                    " v-validate="'required'" v-mask="generateCardNumberMask" v-on:focus="focusInput"
                                v-on:blur="blurInput" data-ref="cardNumber"></b-form-input>
                              <b-form-invalid-feedback :state="submit
                                ? !(
                                  errors.has('pay.card_number') ||
                                  card_number_error
                                )
                                : null
                                ">
                                {{
                                  $t(
                                    "checkout.pagamento.feedbacks.numero_cartao"
                                  )
                                }}
                              </b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group :label="$t(
                              'checkout.pagamento.metodos.um_cartao.titular'
                            )
                              " label-for="card_holder_name">
                              <b-form-input data-test="cardname1" id="card_holder_name"
                                v-model="data.cards[0].holder_name" type="text" :placeholder="$t(
                                  'checkout.pagamento.metodos.um_cartao.titular_holder'
                                )
                                  " name="card_holder_name" :state="submit
                                    ? !errors.has('pay.card_holder_name')
                                    : null
                                    " v-validate="'required'" v-on:focus="focusInput" v-on:blur="blurInput"
                                data-ref="cardName"></b-form-input>
                              <b-form-invalid-feedback :state="submit
                                ? !errors.has('pay.card_holder_name')
                                : null
                                ">
                                {{
                                  $t(
                                    "checkout.pagamento.feedbacks.titular_cartao"
                                  )
                                }}
                              </b-form-invalid-feedback>
                            </b-form-group>

                            <b-row>
                              <b-col cols="12" md="8">
                                <b-row>
                                  <b-col cols="12" md="6">
                                    <b-form-group :label="$t(
                                      'checkout.pagamento.metodos.um_cartao.mes'
                                    )
                                      " label-for="card_month">
                                      <b-form-select data-test="cardmonth1" v-model="data.cards[0].month" class="mb-3"
                                        id="card_month" name="card_month" v-validate="'required'" :state="submit
                                          ? !errors.has('pay.card_month')
                                          : null
                                          ">
                                        <b-form-select-option value="">
                                          {{
                                            $t(
                                              "checkout.pagamento.metodos.um_cartao.mes"
                                            )
                                          }}
                                        </b-form-select-option>
                                        <b-form-select-option v-for="n in 12" :key="n" :value="n < 10 ? '0' + n : n"
                                          :disabled="n < minCardMonth">
                                          {{ 10 > n ? "0" + n : n }}
                                        </b-form-select-option>
                                      </b-form-select>
                                      <b-form-invalid-feedback :state="submit
                                        ? !errors.has(
                                          'pay.credit_card.card_month'
                                        )
                                        : null
                                        ">
                                        {{
                                          $t(
                                            "checkout.pagamento.feedbacks.mes_cartao"
                                          )
                                        }}
                                      </b-form-invalid-feedback>
                                    </b-form-group>
                                  </b-col>

                                  <b-col cols="12" md="6">
                                    <b-form-group :label="$t(
                                      'checkout.pagamento.metodos.um_cartao.ano'
                                    )
                                      " label-for="card_year">
                                      <b-form-select id="card_year" v-model="data.cards[0].year" data-test="cardyear1"
                                        class="mb-3" name="card_year" v-validate="'required'" :state="submit
                                          ? !errors.has('pay.card_year')
                                          : null
                                          ">
                                        <b-form-select-option value="">
                                          {{
                                            $t(
                                              "checkout.pagamento.metodos.um_cartao.ano"
                                            )
                                          }}
                                        </b-form-select-option>
                                        <b-form-select-option v-for="(n, $index) in 12" :key="n"
                                          :value="$index + minCardYear">
                                          {{ $index + minCardYear }}
                                        </b-form-select-option>
                                      </b-form-select>
                                      <b-form-invalid-feedback :state="submit
                                        ? !errors.has(
                                          'pay.credit_card.card_year'
                                        )
                                        : null
                                        ">
                                        {{
                                          $t(
                                            "checkout.pagamento.feedbacks.ano_cartao"
                                          )
                                        }}
                                      </b-form-invalid-feedback>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                              </b-col>

                              <b-col cols="12" md="4">
                                <b-form-group :label="$t(
                                  'checkout.pagamento.metodos.um_cartao.CVV'
                                )
                                  " label-for="card_cvv">
                                  <b-form-input id="card_cvv" v-model="data.cards[0].cvv" data-test="cardcvv1"
                                    type="text" name="card_cvv" :state="submit
                                      ? !errors.has('pay.card_cvv')
                                      : null
                                      " v-validate="'required'" maxlength="4" v-mask="'####'"
                                    v-on:focus="flipCard(true)" v-on:blur="flipCard(false)"></b-form-input>
                                  <b-form-invalid-feedback :state="submit
                                    ? !errors.has('pay.card_cvv')
                                    : null
                                    ">
                                    {{
                                      $t(
                                        "checkout.pagamento.feedbacks.cvv_cartao"
                                      )
                                    }}
                                  </b-form-invalid-feedback>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-col>

                          <b-col cols="12" md="6" data-anima="top" id="_card">
                            <!-- Credit Card -->
                            <card v-if="method == 'DEBITCARD'" ref="card" :card_number="data.cards[0].number"
                              :card_holder_name="data.cards[0].holder_name" :card_month="String(data.cards[0].month)"
                              :card_year="String(data.cards[0].year)" :card_cvv="data.cards[0].cvv" />
                          </b-col>
                        </b-row>
                      </b-tab>

                      <b-tab v-if="payment_methods.includes('PIX')" data-test="pix" title-link-class="tab-nav-icon PIX"
                        @click="showBtn('PIX')">
                        <template v-slot:title>
                          <font-awesome-icon icon="qrcode" class="icon" />
                          Pix
                        </template>
                        <div data-anima="top">
                          <!-- <InfoPix
                            :main_color="themeCheckout.theme_color || '#00E4A0'"
                          /> -->
                        </div>
                      </b-tab>

                      <b-tab v-if="payment_methods.includes('SAFETYPAY-CASH')" data-test="SAFETYPAY-CASH"
                        title-link-class="tab-nav-icon SAFETYPAY-CASH" @click="showBtn('SAFETYPAY-CASH')">
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          SAFETYPAY-CASH
                        </template>
                      </b-tab>

                      <b-tab v-if="payment_methods.includes('EFECTY')" data-test="EFECTY"
                        title-link-class="tab-nav-icon EFECTY" @click="showBtn('EFECTY')">
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          EFECTY
                        </template>
                      </b-tab>

                      <b-tab v-if="payment_methods.includes('PAGOFACIL')" data-test="PAGOFACIL"
                        title-link-class="tab-nav-icon PAGOFACIL" @click="showBtn('PAGOFACIL')">
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          PAGOFACIL
                        </template>
                      </b-tab>

                      <b-tab v-if="payment_methods.includes('RAPIPAGO')" data-test="RAPIPAGO"
                        title-link-class="tab-nav-icon RAPIPAGO" @click="showBtn('RAPIPAGO')">
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          RAPIPAGO
                        </template>
                      </b-tab>

                      <b-tab v-if="payment_methods.includes('PAGOSNET')" data-test="PAGOSNET"
                        title-link-class="tab-nav-icon PAGOSNET" @click="showBtn('PAGOSNET')">
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          PAGOSNET
                        </template>
                      </b-tab>

                      <b-tab v-if="payment_methods.includes('EFT')" data-test="EFT" title-link-class="tab-nav-icon EFT"
                        @click="showBtn('EFT')">
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          EFT
                        </template>

                        <b-col cols="12" lg="8" md="12">
                          <b-form-group label="Banco" label-for="bank">
                            <b-form-select id="bank" data-test="bank" v-model="bank_type"
                              placeholder="Seleccione su banco" value-field="code" text-field="name" name="bank"
                              :options="external_banks"></b-form-select>
                          </b-form-group>
                        </b-col>
                      </b-tab>

                      <b-tab v-if="payment_methods.includes('MULTICAJA')" data-test="MULTICAJA"
                        title-link-class="tab-nav-icon MULTICAJA" @click="showBtn('MULTICAJA')">
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          MULTICAJA
                        </template>
                      </b-tab>

                      <b-tab v-if="payment_methods.includes('SENCILLITO')" data-test="SENCILLITO"
                        title-link-class="tab-nav-icon SENCILLITO" @click="showBtn('SENCILLITO')">
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          SENCILLITO
                        </template>
                      </b-tab>

                      <b-tab v-if="payment_methods.includes('SERVIPAG')" data-test="SERVIPAG"
                        title-link-class="tab-nav-icon SERVIPAG" @click="showBtn('SERVIPAG')">
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          SERVIPAG
                        </template>
                      </b-tab>

                      <b-tab v-if="payment_methods.includes('WEBPAY')" data-test="WEBPAY"
                        title-link-class="tab-nav-icon WEBPAY" @click="showBtn('WEBPAY')">
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          WEBPAY
                        </template>
                      </b-tab>

                      <b-tab v-if="payment_methods.includes('SPEI')" data-test="SPEI"
                        title-link-class="tab-nav-icon SPEI" @click="showBtn('SPEI')">
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          SPEI
                        </template>
                      </b-tab>

                      <b-tab v-if="payment_methods.includes('OXXO')" data-test="OXXO"
                        title-link-class="tab-nav-icon OXXO" @click="showBtn('OXXO')">
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          OXXO
                        </template>
                      </b-tab>

                      <b-tab v-if="payment_methods.includes('BOLETO')" data-test="boleto"
                        title-link-class="tab-nav-icon BOLETO" @click="showBtn('BOLETO')">
                        <template v-slot:title>
                          <font-awesome-icon icon="file-invoice-dollar" class="icon" />
                          Boleto
                        </template>
                        <div data-anima="top" v-if="$i18n.locale == 'pt'">
                          <p>
                            Pagamentos com Boleto Bancário levam até 3 dias
                            úteis para serem compensados e então terem os
                            produtos liberados.
                          </p>
                        </div>
                      </b-tab>

                      <b-tab v-if="payment_methods.includes('PAYPAL') && gateway !== 'stripe'" data-test="paypal"
                        title-link-class="tab-nav-icon PAYPAL" @click="renderPaypal()">
                        <template v-slot:title>
                          <font-awesome-icon :icon="['fab', 'paypal']" class="icon" />
                          Paypal
                        </template>
                        <b-row data-anima="top">
                          <b-col cols="12" style="padding: 30px">
                            <div v-if="paypal_true == true" id="div-paypal" ref="paypal" data-test="submitpaypal"></div>

                            <b-button v-else id="disabled-paypal" block type="button" disabled variant="dark"
                              class="btn-paypal">
                              <img
                                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAxcHgiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAxMDEgMzIiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaW5ZTWluIG1lZXQiIHhtbG5zPSJodHRwOiYjeDJGOyYjeDJGO3d3dy53My5vcmcmI3gyRjsyMDAwJiN4MkY7c3ZnIj48cGF0aCBmaWxsPSIjZmZmZmZmIiBkPSJNIDEyLjIzNyAyLjggTCA0LjQzNyAyLjggQyAzLjkzNyAyLjggMy40MzcgMy4yIDMuMzM3IDMuNyBMIDAuMjM3IDIzLjcgQyAwLjEzNyAyNC4xIDAuNDM3IDI0LjQgMC44MzcgMjQuNCBMIDQuNTM3IDI0LjQgQyA1LjAzNyAyNC40IDUuNTM3IDI0IDUuNjM3IDIzLjUgTCA2LjQzNyAxOC4xIEMgNi41MzcgMTcuNiA2LjkzNyAxNy4yIDcuNTM3IDE3LjIgTCAxMC4wMzcgMTcuMiBDIDE1LjEzNyAxNy4yIDE4LjEzNyAxNC43IDE4LjkzNyA5LjggQyAxOS4yMzcgNy43IDE4LjkzNyA2IDE3LjkzNyA0LjggQyAxNi44MzcgMy41IDE0LjgzNyAyLjggMTIuMjM3IDIuOCBaIE0gMTMuMTM3IDEwLjEgQyAxMi43MzcgMTIuOSAxMC41MzcgMTIuOSA4LjUzNyAxMi45IEwgNy4zMzcgMTIuOSBMIDguMTM3IDcuNyBDIDguMTM3IDcuNCA4LjQzNyA3LjIgOC43MzcgNy4yIEwgOS4yMzcgNy4yIEMgMTAuNjM3IDcuMiAxMS45MzcgNy4yIDEyLjYzNyA4IEMgMTMuMTM3IDguNCAxMy4zMzcgOS4xIDEzLjEzNyAxMC4xIFoiPjwvcGF0aD48cGF0aCBmaWxsPSIjZmZmZmZmIiBkPSJNIDM1LjQzNyAxMCBMIDMxLjczNyAxMCBDIDMxLjQzNyAxMCAzMS4xMzcgMTAuMiAzMS4xMzcgMTAuNSBMIDMwLjkzNyAxMS41IEwgMzAuNjM3IDExLjEgQyAyOS44MzcgOS45IDI4LjAzNyA5LjUgMjYuMjM3IDkuNSBDIDIyLjEzNyA5LjUgMTguNjM3IDEyLjYgMTcuOTM3IDE3IEMgMTcuNTM3IDE5LjIgMTguMDM3IDIxLjMgMTkuMzM3IDIyLjcgQyAyMC40MzcgMjQgMjIuMTM3IDI0LjYgMjQuMDM3IDI0LjYgQyAyNy4zMzcgMjQuNiAyOS4yMzcgMjIuNSAyOS4yMzcgMjIuNSBMIDI5LjAzNyAyMy41IEMgMjguOTM3IDIzLjkgMjkuMjM3IDI0LjMgMjkuNjM3IDI0LjMgTCAzMy4wMzcgMjQuMyBDIDMzLjUzNyAyNC4zIDM0LjAzNyAyMy45IDM0LjEzNyAyMy40IEwgMzYuMTM3IDEwLjYgQyAzNi4yMzcgMTAuNCAzNS44MzcgMTAgMzUuNDM3IDEwIFogTSAzMC4zMzcgMTcuMiBDIDI5LjkzNyAxOS4zIDI4LjMzNyAyMC44IDI2LjEzNyAyMC44IEMgMjUuMDM3IDIwLjggMjQuMjM3IDIwLjUgMjMuNjM3IDE5LjggQyAyMy4wMzcgMTkuMSAyMi44MzcgMTguMiAyMy4wMzcgMTcuMiBDIDIzLjMzNyAxNS4xIDI1LjEzNyAxMy42IDI3LjIzNyAxMy42IEMgMjguMzM3IDEzLjYgMjkuMTM3IDE0IDI5LjczNyAxNC42IEMgMzAuMjM3IDE1LjMgMzAuNDM3IDE2LjIgMzAuMzM3IDE3LjIgWiI+PC9wYXRoPjxwYXRoIGZpbGw9IiNmZmZmZmYiIGQ9Ik0gNTUuMzM3IDEwIEwgNTEuNjM3IDEwIEMgNTEuMjM3IDEwIDUwLjkzNyAxMC4yIDUwLjczNyAxMC41IEwgNDUuNTM3IDE4LjEgTCA0My4zMzcgMTAuOCBDIDQzLjIzNyAxMC4zIDQyLjczNyAxMCA0Mi4zMzcgMTAgTCAzOC42MzcgMTAgQyAzOC4yMzcgMTAgMzcuODM3IDEwLjQgMzguMDM3IDEwLjkgTCA0Mi4xMzcgMjMgTCAzOC4yMzcgMjguNCBDIDM3LjkzNyAyOC44IDM4LjIzNyAyOS40IDM4LjczNyAyOS40IEwgNDIuNDM3IDI5LjQgQyA0Mi44MzcgMjkuNCA0My4xMzcgMjkuMiA0My4zMzcgMjguOSBMIDU1LjgzNyAxMC45IEMgNTYuMTM3IDEwLjYgNTUuODM3IDEwIDU1LjMzNyAxMCBaIj48L3BhdGg+PHBhdGggZmlsbD0iI2ZmZmZmZiIgZD0iTSA2Ny43MzcgMi44IEwgNTkuOTM3IDIuOCBDIDU5LjQzNyAyLjggNTguOTM3IDMuMiA1OC44MzcgMy43IEwgNTUuNzM3IDIzLjYgQyA1NS42MzcgMjQgNTUuOTM3IDI0LjMgNTYuMzM3IDI0LjMgTCA2MC4zMzcgMjQuMyBDIDYwLjczNyAyNC4zIDYxLjAzNyAyNCA2MS4wMzcgMjMuNyBMIDYxLjkzNyAxOCBDIDYyLjAzNyAxNy41IDYyLjQzNyAxNy4xIDYzLjAzNyAxNy4xIEwgNjUuNTM3IDE3LjEgQyA3MC42MzcgMTcuMSA3My42MzcgMTQuNiA3NC40MzcgOS43IEMgNzQuNzM3IDcuNiA3NC40MzcgNS45IDczLjQzNyA0LjcgQyA3Mi4yMzcgMy41IDcwLjMzNyAyLjggNjcuNzM3IDIuOCBaIE0gNjguNjM3IDEwLjEgQyA2OC4yMzcgMTIuOSA2Ni4wMzcgMTIuOSA2NC4wMzcgMTIuOSBMIDYyLjgzNyAxMi45IEwgNjMuNjM3IDcuNyBDIDYzLjYzNyA3LjQgNjMuOTM3IDcuMiA2NC4yMzcgNy4yIEwgNjQuNzM3IDcuMiBDIDY2LjEzNyA3LjIgNjcuNDM3IDcuMiA2OC4xMzcgOCBDIDY4LjYzNyA4LjQgNjguNzM3IDkuMSA2OC42MzcgMTAuMSBaIj48L3BhdGg+PHBhdGggZmlsbD0iI2ZmZmZmZiIgZD0iTSA5MC45MzcgMTAgTCA4Ny4yMzcgMTAgQyA4Ni45MzcgMTAgODYuNjM3IDEwLjIgODYuNjM3IDEwLjUgTCA4Ni40MzcgMTEuNSBMIDg2LjEzNyAxMS4xIEMgODUuMzM3IDkuOSA4My41MzcgOS41IDgxLjczNyA5LjUgQyA3Ny42MzcgOS41IDc0LjEzNyAxMi42IDczLjQzNyAxNyBDIDczLjAzNyAxOS4yIDczLjUzNyAyMS4zIDc0LjgzNyAyMi43IEMgNzUuOTM3IDI0IDc3LjYzNyAyNC42IDc5LjUzNyAyNC42IEMgODIuODM3IDI0LjYgODQuNzM3IDIyLjUgODQuNzM3IDIyLjUgTCA4NC41MzcgMjMuNSBDIDg0LjQzNyAyMy45IDg0LjczNyAyNC4zIDg1LjEzNyAyNC4zIEwgODguNTM3IDI0LjMgQyA4OS4wMzcgMjQuMyA4OS41MzcgMjMuOSA4OS42MzcgMjMuNCBMIDkxLjYzNyAxMC42IEMgOTEuNjM3IDEwLjQgOTEuMzM3IDEwIDkwLjkzNyAxMCBaIE0gODUuNzM3IDE3LjIgQyA4NS4zMzcgMTkuMyA4My43MzcgMjAuOCA4MS41MzcgMjAuOCBDIDgwLjQzNyAyMC44IDc5LjYzNyAyMC41IDc5LjAzNyAxOS44IEMgNzguNDM3IDE5LjEgNzguMjM3IDE4LjIgNzguNDM3IDE3LjIgQyA3OC43MzcgMTUuMSA4MC41MzcgMTMuNiA4Mi42MzcgMTMuNiBDIDgzLjczNyAxMy42IDg0LjUzNyAxNCA4NS4xMzcgMTQuNiBDIDg1LjczNyAxNS4zIDg1LjkzNyAxNi4yIDg1LjczNyAxNy4yIFoiPjwvcGF0aD48cGF0aCBmaWxsPSIjZmZmZmZmIiBkPSJNIDk1LjMzNyAzLjMgTCA5Mi4xMzcgMjMuNiBDIDkyLjAzNyAyNCA5Mi4zMzcgMjQuMyA5Mi43MzcgMjQuMyBMIDk1LjkzNyAyNC4zIEMgOTYuNDM3IDI0LjMgOTYuOTM3IDIzLjkgOTcuMDM3IDIzLjQgTCAxMDAuMjM3IDMuNSBDIDEwMC4zMzcgMy4xIDEwMC4wMzcgMi44IDk5LjYzNyAyLjggTCA5Ni4wMzcgMi44IEMgOTUuNjM3IDIuOCA5NS40MzcgMyA5NS4zMzcgMy4zIFoiPjwvcGF0aD48L3N2Zz4="
                                width="75px" data-v-fd53f700="" alt="paypal" aria-label="PayPal" class="
                                  paypal-logo
                                  paypal-logo-paypal
                                  paypal-logo-color-white
                                " />
                              {{
                                $t("checkout.pagamento.metodos.paypal.btn_text")
                              }}
                            </b-button>
                          </b-col>
                        </b-row>
                      </b-tab>
                    </b-tabs>

                    <!-- Instellments -->
                    <b-row v-if="gateway != 'stripe'" class="justify-content-start">
                      <b-col v-if="
                        (method == 'CREDIT_CARD' ||
                          method == 'TWO_CREDIT_CARDS') &&
                        ((product_type == 'COMMON' &&
                          product.type == 'TRANSACTION') ||
                          (product_type == 'PROPOSAL' &&
                            product.product.type == 'TRANSACTION'))
                      " cols="12" md="6" id="parcelas_item">
                        <b-form-group :label="$t('checkout.pagamento.metodos.um_cartao.parcelas')
                          " label-for="installments">
                          <!-- Installments Not Fixed -->
                          <b-form-select v-if="
                            validateSelectNotFixedInstallments() &&
                            !sellerSettingsLoading
                          " id="installments" v-model="installments" data-test="installments"
                            @change="changeParcelamentoCartao" name="installments" v-on:change="(value) =>
                              trackEvent({
                                currentTarget: {
                                  name: 'card_installments',
                                  value,
                                },
                              })
                              ">
                            <template v-for="(n, $index) in max_installments">
                              <b-form-select-option v-if="getIndexInstallments($index + 1)" :key="n"
                                :value="$index + 1">
                                {{
                                  $index + 1 > 1
                                    ? $index +
                                    1 +
                                    `x ${!sem_juros ? $t("order.de") : ""} ${sem_juros ? "(Sem Juros) de" : ""
                                    } ${filterCurrency(currency_id)} ` +
                                    formatMoney(
                                      totalInstallmentPrice($index + 1), $i18n.locale
                                    ) +
                                    `${sem_juros ? "" : "*"}`
                                    : $index +
                                    1 +
                                    `x ${$t("order.de")} ${filterCurrency(
                                      currency_id
                                    )}
                                ${formatMoney(
                                      totalInstallmentPrice(1), $i18n.locale
                                    )}`
                                }}
                              </b-form-select-option>
                            </template>
                          </b-form-select>
                          <!-- Loading spinner -->
                          <b-spinner v-if="sellerSettingsLoading" class="mt-2" variant="primary"
                            label="Loading..."></b-spinner>
                          <!-- Installments Fixed -->
                          <b-form-select v-if="
                            parcela_fixa &&
                            countryGlobal === 'BR'
                          " id="installments" v-model="installments" data-test="installments" name="installments"
                            @change="changeParcelamentoCartao">
                            <b-form-select-option v-bind:value="parcela_fixa">
                              {{
                                parcela_fixa +
                                `x ${!sem_juros ? $t("order.de") : ""} ${sem_juros ? "(Sem Juros) de" : ""
                                } ${filterCurrency(currency_id)} ` +
                                formatMoney(
                                  totalInstallmentPrice(parcela_fixa), $i18n.locale
                                ) +
                                `${sem_juros ? "" : "*"}`
                              }}
                            </b-form-select-option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>

                      <!-- Parcelas Boleto -->
                      <b-col v-if="
                        method == 'BOLETO' &&
                        permite_parcela_boleto > 1 &&
                        ((product_type == 'COMMON' &&
                          product.type == 'TRANSACTION') ||
                          (product_type == 'PROPOSAL' &&
                            product.product.type == 'TRANSACTION'))
                      " cols="12" md="6" id="parcelas_item">
                        <b-form-group label="Parcelas do boleto" label-for="installments">
                          <b-form-select id="installments" v-model="installments_boleto" data-test="installmentsboleto"
                            name="installments">
                            <b-form-select-option v-for="(n, $index) in permite_parcela_boleto" :key="n"
                              :value="$index + 1">
                              {{
                                $index + 1 > 1
                                  ? $index +
                                  1 +
                                  `x ${!sem_juros ? $t("order.de") : ""} ${sem_juros ? "(Sem Juros) de" : ""
                                  } ${filterCurrency(currency_id)} ` +
                                  formatMoney(
                                    totalInstallmentPrice($index + 1), $i18n.locale
                                  ) +
                                  `${sem_juros ? "" : "*"}`
                                  : $index +
                                  1 +
                                  `x ${$t("order.de")} ${filterCurrency(
                                    currency_id
                                  )}
                              ${formatMoney(
                                    totalInstallmentPrice(1), $i18n.locale
                                  )}`
                              }}
                            </b-form-select-option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>

                      <!-- parcelas assinatura -->
                      <b-col v-if="
                        method == 'CREDIT_CARD' &&
                        permite_parcela_assinatura >= 1 &&
                        ((product_type == 'COMMON' &&
                          product.type == 'SUBSCRIPTION' &&
                          product.period > 30) ||
                          (product_type == 'PROPOSAL' &&
                            product.product.type == 'SUBSCRIPTION' &&
                            product.product.period > 30))
                      " cols="12" md="6" id="parcelas_item">
                        <b-form-group label="Parcelas da Assinatura" label-for="installments">
                          <b-form-select v-if="!parcela_fixa" id="installments" v-model="installments"
                            data-test="installmentsboleto" name="installments">
                            <b-form-select-option v-for="(n, $index) in permite_parcela_assinatura" :key="n"
                              :value="$index + 1">
                              {{
                                $index + 1 > 1
                                  ? $index +
                                  1 +
                                  `x ${$t("order.de")} ${filterCurrency(
                                    currency_id
                                  )} ` +
                                  formatMoney(
                                    totalInstallmentPrice($index + 1), $i18n.locale
                                  ) +
                                  `${sem_juros ? "" : "*"}`
                                  : $index +
                                  1 +
                                  `x ${$t("order.de")} ${filterCurrency(
                                    currency_id
                                  )}
                              ${formatMoney(
                                    totalInstallmentPrice(1), $i18n.locale
                                  )}`
                              }}
                            </b-form-select-option>
                          </b-form-select>
                          <!-- parcela fixa -->
                          <b-form-select v-if="parcela_fixa" id="installments" v-model="installments"
                            data-test="installments" name="installments">
                            <b-form-select-option :value="parcela_fixa">
                              {{
                                parcela_fixa +
                                `x ${!sem_juros ? $t("order.de") : ""} ${sem_juros ? "(Sem Juros) de" : ""
                                } ${filterCurrency(currency_id)} ` +
                                formatMoney(
                                  totalInstallmentPrice(parcela_fixa), $i18n.locale
                                ) +
                                `${sem_juros ? "" : "*"}`
                              }}
                            </b-form-select-option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col>
                        <div v-if="themeCheckout.trial_position == 'bottom'">
                          <b-badge v-if="
                            (product_type == 'COMMON' && product.trial) ||
                            (product_type == 'PROPOSAL' &&
                              product.product.trial)
                          " data-test="trialproduct" variant="success" class="Product-trial business">
                            {{ $t("order.apos_trial") }} de
                            {{
                              product_type == "COMMON"
                                ? product.trial
                                : "" || product_type == "PROPOSAL"
                                  ? product.product.trial
                                  : ""
                            }}
                            dia(s):
                            {{
                              parcela_fixa && themeCheckout.trial_info == "fixa"
                                ? `${parcela_fixa}x de ${filterCurrency(
                                  currency_id
                                )} ${formatMoney(
                                  getInstallments(
                                    parcela_fixa,
                                    product.amount
                                  ), $i18n.locale
                                )} `
                                : `${filterCurrency(currency_id)} ${formatMoney(
                                  amount, $i18n.locale
                                )}`
                            }}

                            <span v-if="
                              (product_type == 'COMMON' &&
                                product.type == 'SUBSCRIPTION') ||
                              (product_type == 'PROPOSAL' &&
                                product.product.type == 'SUBSCRIPTION')
                            ">
                              {{ setPeriod() }}
                            </span>
                          </b-badge>
                        </div>
                      </b-col>
                    </b-row>
                    <!-- List Order Bump -->
                    <div v-if="bump_list.length">
                      <div class="Product-bump">
                        <!-- Custom Title of Order Bump -->
                        <p class="titleBump" v-if="custom_bump">
                          {{ custom_bump.ob_title }}
                        </p>
                        <!-- Normal Title of Order Bump -->
                        <p class="titleBump" v-else>
                          {{ $t("checkout.pagamento.bump.title") }} 🔥
                        </p>
                        <!-- Order Bump -->
                        <div v-for="(bump, index) in bump_list" :key="bump.id" :class="{ noBump: no_bump }">
                          <!-- Custom Order Bump -->
                          <div v-if="custom_bump" class="order-bump mb-3" @click="changeBump(bump, index)">
                            <div class="header" :style="`background:${custom_bump.ob_background_color.color};`
                              ">
                              <div>
                                <b-form-checkbox v-model="bump.checkbox" style="position: relative; top: 15px"
                                  :disabled="no_bump">
                                  <p class="ml-2 info-value">
                                    {{ custom_bump.ob_subtitle }}
                                  </p>
                                </b-form-checkbox>
                              </div>
                              <p class="info-value" style="position: relative; top: 15px">
                                {{ filterCurrency(currency_id) }}
                                {{
                                  method === "PAYPAL"
                                    ? formatMoney(bump.paypal.amount, $i18n.locale)
                                    : formatMoney(bump.amount, $i18n.locale)
                                }}
                              </p>
                            </div>
                            <div class="base" :style="custom_bump.ob_border !== 'off'
                              ? custom_bump.ob_border === 'pontilhada'
                                ? `border-left: ${custom_bump.ob_border_px}px dashed ${custom_bump.ob_background_color.color}; border-right: ${custom_bump.ob_border_px}px dashed ${custom_bump.ob_background_color.color}; border-bottom: ${custom_bump.ob_border_px}px dashed ${custom_bump.ob_background_color.color}; background:${custom_bump.ob_background_color.background};`
                                : `border-bottom:  ${custom_bump.ob_border_px}px solid ${custom_bump.ob_background_color.color}; border-right:  ${custom_bump.ob_border_px}px solid ${custom_bump.ob_background_color.color}; border-left:  ${custom_bump.ob_border_px}px solid ${custom_bump.ob_background_color.color}; background:${custom_bump.ob_background_color.background};`
                              : `border:none; background:${custom_bump.ob_background_color.background};`
                              ">
                              <div class="img">
                                <img :src="bump.images[0].path" alt="logo" />
                              </div>
                              <div>
                                <p class="name">{{ bump.name }}</p>
                                <p class="value" :style="`color:${custom_bump.ob_background_color.color};`
                                  ">
                                  {{ filterCurrency(currency_id) }}
                                  {{
                                    method === "PAYPAL"
                                      ? formatMoney(bump.paypal.amount, $i18n.locale)
                                      : formatMoney(bump.amount, $i18n.locale)
                                  }}
                                </p>
                                <v-md-preview v-if="custom_bump.ob_description" :id="`mark-down-${bump.id}`"
                                  class="description-mark preview description" :name="`mark-down-${bump.id}`"
                                  :text="bump.description"></v-md-preview>
                              </div>
                            </div>
                          </div>
                          <!-- Normal Order Bump -->
                          <div v-else class="order-bump mb-3" @click="changeBump(bump, index)">
                            <div class="header">
                              <div>
                                <b-form-checkbox v-model="bump.checkbox" style="position: relative; top: 15px"
                                  :disabled="no_bump">
                                  <p class="ml-2 info-value">Sim, eu quero!</p>
                                </b-form-checkbox>
                              </div>
                              <p class="info-value" style="position: relative; top: 15px">
                                {{ filterCurrency(currency_id) }}
                                {{
                                  method === "PAYPAL"
                                    ? formatMoney(bump.paypal.amount, $i18n.locale)
                                    : formatMoney(bump.amount, $i18n.locale)
                                }}
                              </p>
                            </div>
                            <div class="base">
                              <div class="img">
                                <img :src="bump.images[0].path" alt="logo" />
                              </div>
                              <div>
                                <p class="name">{{ bump.name }}</p>
                                <p class="value">
                                  {{ filterCurrency(currency_id) }}
                                  {{
                                    method === "PAYPAL"
                                      ? formatMoney(bump.paypal.amount, $i18n.locale)
                                      : formatMoney(bump.amount, $i18n.locale)
                                  }}
                                </p>
                                <v-md-preview :id="`mark-down-${bump.id}`" class="description-mark preview description"
                                  :name="`mark-down-${bump.id}`" :text="bump.description"></v-md-preview>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <b-row class="mt-2" data-anima="bottom">
                      <b-col cols="12">
                        <!-- Buy Now Button -->
                        <Captcha ref="Captcha" @verifyCaptcha="verifyCaptcha">
                          <b-button v-show="btn_paypal == false" data-test="submit" variant="success"
                            class="col-12 btn-checkout" :disabled="loading" type="button" @click="onSubmit">
                            <div v-if="!loading">
                              {{
                                !themeCheckout.button_text
                                  ? $t("checkout.footer.btn_compra")
                                  : themeCheckout.button_text
                              }}
                            </div>
                            <div v-if="loading">
                              <b-spinner label="Loading..."></b-spinner>
                            </div>
                          </b-button>
                        </Captcha>
                        <!-- Security and Encryption Info -->
                        <div class="mt-4 d-flex flex-column">
                          <div
                            v-if="(method === 'CREDIT_CARD' && installments > 1 && !product.no_interest_installments)"
                            class="amout-obs">
                            {{ $t("checkout.footer.possui_acrescimo") }}
                          </div>
                          <p>
                            {{ $t("checkout.footer.comprar_agora") }}
                            {{ name }}
                            {{ $t("checkout.footer.com_os") }}
                            <a v-if="$i18n.locale === 'pt'"
                              href="https://www.voompcreators.com.br/termos-e-documentacoes/">
                              {{ $t("checkout.footer.termos_compra") }}
                            </a>
                            <a v-else
                              :href="'https://www.voompcreators.com.br/termos-e-documentacoes-' + $i18n.locale + '/'">
                              {{ $t("checkout.footer.termos_compra") }}
                            </a>
                            {{ $t("checkout.footer.ciente_da") }}
                            <a href="https://www.canaldatransparencia.com.br/cogna/">{{
                              $t("checkout.footer.politica_de_privacidade")
                            }}</a>
                            {{ $t("checkout.footer.maior_de_idade") }}
                          </p>
                        </div>
                        <div class="mt-4 d-flex align-items-center">
                          <font-awesome-icon icon="lock" class="icon-lock" />
                          <p class="m-0 ml-3">
                            {{ $t("checkout.footer.info_seguranca") }}
                          </p>
                        </div>
                      </b-col>
                    </b-row>
                  </template>
                </b-form>
              </div>

              <template v-if="
                themeCheckout.bottom_thumb && !charge_error && !charge_success
              ">
                <div class="container banner-container container-banner-footer">
                  <img :src="themeCheckout.bottom_thumb" alt="bottom-thumb" class="banner" />
                </div>
              </template>

              <!-- <b-row v-if="!charge_error && !charge_success"
                class="Checkout-footer"
              >
                <div class="info-termos">
                  <p class="p-footer"></p>
                  <p class="p-footer mb-1" v-if="isMobile && !sem_juros">
                    {{ $t("checkout.footer.taxa_parcela") }}
                  </p>
                  <p class="p-footer" v-if="has_greenn_me">
                    Greenn © {{ ano_atual }} -
                    {{ $t("checkout.footer.direitos_reservados_me") }}
                  </p>
                  <p class="p-footer" v-else>
                    Greenn © {{ ano_atual }} -
                    {{ $t("checkout.footer.direitos_reservados") }}
                  </p>
                </div>
              </b-row> -->

              <!-- Confirmation -->
              <div v-if="charge_success">
                <div class="wrapper-box success">
                  <b-row class="justify-content-center my-5">
                    <div class="icon">
                      <font-awesome-icon icon="check" />
                    </div>
                  </b-row>
                  <b-row>
                    <b-col cols="12">
                      <h5 class="text-center">
                        {{ $t("checkout.sucesso_compra") }}
                      </h5>
                    </b-col>
                  </b-row>
                </div>
              </div>

              <!-- Failed -->
              <div v-if="charge_error">
                <h5 v-if="
                  !bump_error &&
                  ((product_type == 'COMMON' &&
                    product.status_product == 'APPROVED' &&
                    product.status_offer == 'APPROVED' &&
                    product.is_active === 1) ||
                    (product_type == 'PROPOSSAL' &&
                      product.product.status_product == 'APPROVED' &&
                      product.product.status_offer == 'APPROVED' &&
                      product.product.is_active === 1))
                ">
                  {{ $t("checkout.erro_compra") }}
                </h5>
                <div class="wrapper-box failed">
                  <b-row class="justify-content-center my-5">
                    <div class="icon">
                      <font-awesome-icon icon="times" />
                    </div>
                  </b-row>
                  <h5 class="text-center">{{ error_message }}</h5>
                </div>
              </div>
            </b-overlay>
          </b-col>
          <!-- Product Card -->
          <b-col v-if="!charge_error && !charge_success && renderComponent" cols="12" md="4" order="1" order-md="2"
            class="mb-3 pb-3 mb-md-0 p-md-0">
            <div class="Product" :class="{
              'product-desktop': !isMobile,
              'column-fixed':
                !themeCheckout.side_thumb &&
                !isMobile &&
                !charge_error &&
                !charge_success,
            }" data-anima="right">
              <!-- Secure Purchase -->
              <div class="Product-header">
                <font-awesome-icon icon="shield-alt" class="mr-2" />
                {{ $t("order.text_header") }}
              </div>
              <div class="content-card pr-3">
                <!-- Product Image -->
                <div v-if="product_type == 'PROPOSAL' && product.product.images" class="imagem-produto"
                  data-test="imgproduct">
                  <img v-if="product.product.images.length" data-test="imgproduct" :src="product.product.images[0].path"
                    class="product-img" alt="image-product" />
                  <div v-else class="product-img" data-test="imgproduct"></div>
                </div>

                <div v-if="product_type == 'COMMON' && product.images" class="imagem-produto" data-test="imgproduct">
                  <img v-if="product.images.length" :src="product.images[0].path" alt="product-image"
                    class="product-img" />
                  <div v-else class="product-img" data-test="imgproduct"></div>
                </div>
                <!-- Product Info -->
                <div class="info-card">
                  <!-- Info Sub -->
                  <p v-if="
                    (product_type == 'COMMON' &&
                      product.type == 'SUBSCRIPTION') ||
                    (product_type == 'PROPOSAL' &&
                      product.product.type == 'SUBSCRIPTION')
                  " class="tipo-produto">
                    {{ $t("order.info_sub") }}
                  </p>
                  <!-- Name -->
                  <div class="Product-name_2" data-test="nameproduct">
                    {{ product.name }}
                  </div>
                  <!-- More Product Info -->
                  <div v-if="
                    (product_type == 'COMMON' &&
                      product.type == 'SUBSCRIPTION') ||
                    (product_type == 'PROPOSAL' &&
                      product.product.type == 'SUBSCRIPTION') ||
                    !method_credit_card
                  " class="Product-price_2">
                    <!-- Original Amount -->
                    <small data-test="avistaproduct x" class="d-block small-text mb-1">
                      <span v-if="
                        original_amount && cupom_checkout && cupom_valid
                      " class="original-amount">
                        {{ filterCurrency(currency_id) }}
                        {{ formatMoney(original_amount, $i18n.locale) }}
                      </span>
                    </small>
                    <!-- Free Trial -->
                    <div v-if="
                      (product_type == 'COMMON' && product.trial) ||
                      (product_type == 'PROPOSAL' && product.product.trial)
                    " data-test="priceproduct" class="Product-price_2 free-trial business">
                      {{ $t("order.gratuito_por") }}
                      {{
                        product_type == "COMMON"
                          ? product.trial
                          : product.product.trial
                      }}
                      {{ $t("order.dias") }}
                    </div>
                    <!-- Showing Value Without Evaluation
                    <div
                      v-else-if="
                        (!product.pre_selected_installment &&
                          !product.max_subscription_installments) ||
                          product.period === 30
                      "
                      class="Product-price_2"
                      data-test="priceproduct"
                    >
                      {{ filterCurrency(currency_id) }}
                      {{ formatMoney(amount, $i18n.locale) }}
                      <div
                        data-test="periodproduct"
                        class="Product-subscription-period"
                      >
                        {{ setPeriod }}
                      </div>
                    </div> -->
                    <!-- When method is BOLETO -->
                    <section v-else-if="method == 'BOLETO'">
                      {{ filterCurrency(currency_id) }}
                      {{ formatMoney(product.amount, $i18n.locale) }}
                      <div v-if="product.period" data-test="periodproduct" class="Product-subscription-period">
                        {{ setPeriod() }}
                      </div>
                    </section>
                    <!-- Price with Installments -->
                    <div v-else class="Product-price_2" data-test="priceproduct">
                      <span v-if="product.period && installments > 1">{{ installments }}x {{ $t("order.de") }}</span>
                      {{ filterCurrency(currency_id) }}
                      {{
                        formatMoney(
                          getInstallments(installments, product.amount), $i18n.locale
                        )
                      }}
                      {{ sem_juros && installments > 1 ? "(Sem Juros)" : "" }}
                      <div v-if="product.period" data-test="periodproduct" class="Product-subscription-period">
                        {{ setPeriod() }}
                      </div>
                    </div>
                  </div>
                  <!-- More Product Info -->
                  <div v-else class="Product-price_2" data-test="priceproduct">
                    <div>
                      <div v-if="
                        sem_parcela ||
                        method === 'PAYPAL' ||
                        method === 'OXXO' ||
                        method === 'EFECTY' ||
                        method === 'SENCILLITO' ||
                        method === 'SPEI' ||
                        method === 'SAFETYPAY-CASH' ||
                        method === 'BOLETO'
                      " data-test="installmentsproduct">

                        <!-- Original Amount -->
                        <small data-test="avistaproduct x" class="d-block small-text mb-1">
                          <span v-if="
                            original_amount && cupom_checkout && cupom_valid
                          " class="original-amount">
                            {{ filterCurrency(currency_id) }}
                            {{ formatMoney(original_amount, $i18n.locale) }}
                          </span>
                        </small>
                        <!-- Tiket Amount with Instellments -->
                        <div v-if="
                          method == 'BOLETO' && permite_parcela_boleto > 1
                        ">
                          <span>
                            {{ installments_boleto }}x {{ $t("order.de") }}
                          </span>
                          {{ filterCurrency(currency_id) }}
                          {{
                            formatMoney(
                              getInstallments(
                                installments_boleto,
                                product.amount
                              ), $i18n.locale
                            )
                          }}
                          {{ sem_juros && installments_boleto > 1 ? "(Sem Juros)" : "" }}

                          <small v-if="installments_boleto > 1" class="d-block small-text">
                            {{ $t("order.a_vista") }}
                            {{ filterCurrency(currency_id) }}
                            {{ formatMoney(product.amount, $i18n.locale) }}
                            <br v-if="
                              checkoutPayment &&
                              checkoutPayment.price &&
                              checkoutPayment.price.payable_tax
                            " />
                            {{
                              checkoutPayment &&
                                checkoutPayment.price &&
                                checkoutPayment.price.payable_tax
                                ? $t("order.impostos")
                                : ""
                            }}
                          </small>
                        </div>
                        <!-- Amount with Shipping -->
                        <div v-else>
                          <span v-if="method !== 'PAYPAL' || !paypal">
                            {{ filterCurrency(currency_id) }}
                            {{
                              shipping.amount
                                ? formatMoney((product.amount + shipping.amount), $i18n.locale)
                                : formatMoney(product.amount, $i18n.locale)
                            }}
                          </span>
                          <!-- Amount Paypal -->
                          <span v-else>
                            {{ paypal.symbol_currency }}
                            {{ formatMoney(product.amount, $i18n.locale) }}
                          </span>
                        </div>
                      </div>
                      <div v-else data-test="installmentsproduct">
                        <!-- Original Amount -->
                        <small data-test="avistaproduct xx" class="d-block small-text mb-1">
                          <span v-if="
                            original_amount && cupom_checkout && cupom_valid
                          " class="original-amount">
                            {{ filterCurrency(currency_id) }}
                            {{ formatMoney(original_amount, $i18n.locale) }}
                          </span>
                        </small>

                        {{ installments }}x {{ $t("order.de") }}
                        {{ filterCurrency(currency_id) }}
                        {{
                          formatMoney(
                            getInstallments(installments, product.amount), $i18n.locale
                          )
                        }}

                        {{
                          sem_juros &&
                            method === "CREDIT_CARD" &&
                            installments > 1
                            ? "(Sem Juros)"
                            : ""
                        }}
                        <!-- À Vista -->
                        <small v-if="
                          installments > 1 &&
                          parcela_fixa === null
                        " data-test="avistaproduct xxx" class="d-block small-text">
                          {{ $t("order.a_vista") }}
                          {{ filterCurrency(currency_id) }}
                          {{
                            shipping.amount
                              ? formatMoney((product.amount + shipping.amount), $i18n.locale)
                              : formatMoney(product.amount, $i18n.locale)
                          }}
                          <br v-if="
                            checkoutPayment &&
                            checkoutPayment.price &&
                            checkoutPayment.price.payable_tax
                          " />
                          {{
                            checkoutPayment &&
                              checkoutPayment.price &&
                              checkoutPayment.price.payable_tax
                              ? $t("order.impostos")
                              : ""
                          }}
                          <br v-if="
                            checkoutPayment &&
                            checkoutPayment.price &&
                            checkoutPayment.price.payable_tax
                          " />
                        </small>
                        <div v-if="
                          checkoutPayment &&
                          checkoutPayment.price &&
                          checkoutPayment.price.payable_tax
                        ">
                          <small v-for="fee in checkoutPayment.price.tax" :key="fee" class="d-block small-text">
                            {{ $t("order.taxa") }} {{ fee.description }} -
                            {{
                              fee.type === "FIXED"
                                ? filterCurrency(currency_id)
                                : ""
                            }}
                            {{
                              fee.type === "FIXED"
                                ? formatMoney(fee.fee, $i18n.locale)
                                : fee.fee + "%"
                            }}
                            <br />
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--  BUMP CARD  -->
              <div class="content-card pr-3" v-if="bump && bump.checkbox">
                <!-- Product Image -->
                <div v-if="bump && bump.images" class="imagem-produto" data-test="imgproduct">
                  <img v-if="bump.images.length" :src="bump.images[0].path" alt="product-image" class="product-img" />
                  <div v-else class="product-img" data-test="imgproduct"></div>
                </div>
                <!-- Product Info -->
                <div class="info-card">
                  <!-- Info Sub -->
                  <p v-if="
                    (product_type == 'COMMON' &&
                      bump.type == 'SUBSCRIPTION') ||
                    (product_type == 'PROPOSAL' &&
                      bump.type == 'SUBSCRIPTION')
                  " class="tipo-produto">
                    {{ $t("order.info_sub") }}
                  </p>
                  <!-- Name -->
                  <div class="Product-name_2" data-test="nameproduct">
                    {{ bump.name }}
                  </div>
                  <!-- More Product Info -->
                  <div v-if="
                    (product_type == 'COMMON' &&
                      bump.type == 'SUBSCRIPTION') ||
                    (product_type == 'PROPOSAL' &&
                      bump.type == 'SUBSCRIPTION') ||
                    !method_credit_card
                  " class="Product-price_2">
                    <!-- Free Trial -->
                    <div v-if="
                      (product_type == 'COMMON' && bump.trial) ||
                      (product_type == 'PROPOSAL' && bump.trial)
                    " data-test="priceproduct" class="Product-price_2 free-trial business">
                      {{ $t("order.gratuito_por") }}
                      {{ product_type == "COMMON" ? bump.trial : bump.trial }}
                      {{ $t("order.dias") }}
                    </div>
                    <!-- Showing Value Without Evaluation -->
                    <div v-else-if="
                      (!bump.pre_selected_installment &&
                        !bump.max_subscription_installments) ||
                      bump.period === 30
                    " class="Product-price_2" data-test="priceproduct">
                      {{ filterCurrency(currency_id) }}
                      {{ formatMoney(bump.amount, $i18n.locale) }}
                      <div data-test="periodproduct" class="Product-subscription-period">
                        {{ setPeriod(true) }}
                      </div>
                    </div>
                    <!-- When method is BOLETO -->
                    <section v-else-if="method == 'BOLETO'">
                      {{ filterCurrency(currency_id) }}
                      {{ formatMoney(bump.amount, $i18n.locale) }}
                      <div v-if="bump.period" data-test="periodproduct" class="Product-subscription-period">
                        {{ setPeriod(true) }}
                      </div>
                    </section>
                    <!-- Price with Installments -->
                    <div v-else class="Product-price_2" data-test="priceproduct">
                      <span v-if="
                        installments > 1 &&
                        bump.type === 'TRANSACTION' &&
                        product.type === 'TRANSACTION'
                      ">{{ installments }}x {{ $t("order.de") }}
                      </span>
                      {{ filterCurrency(currency_id) }} {{
                        formatMoney(
                          getInstallments(
                            bump.type === "TRANSACTION" &&
                              product.type === "TRANSACTION"
                              ? installments
                              : 1,
                            bump.amount,
                            !!bump
                          ), $i18n.locale
                        )
                      }}

                      <div v-if="bump.period" data-test="periodproduct" class="Product-subscription-period">
                        {{ setPeriod(true) }}
                      </div>
                    </div>
                  </div>
                  <!-- More Product Info -->
                  <div v-else class="Product-price_2" data-test="priceproduct">
                    <div>
                      <div v-if="
                        sem_parcela ||
                        method === 'PAYPAL' ||
                        method === 'OXXO' ||
                        method === 'EFECTY' ||
                        method === 'SENCILLITO' ||
                        method === 'SPEI' ||
                        method === 'SAFETYPAY-CASH' ||
                        method === 'BOLETO'
                      " data-test="installmentsproduct">
                        <!-- Original Amount -->
                        <!-- <small
                          data-test="avistaproduct x"
                          class="d-block small-text mb-1"
                        >
                          <span
                            v-if="
                              original_amount && cupom_checkout && cupom_valid
                            "
                            class="original-amount"
                          >
                            {{ filterCurrency(currency_id) }}
                            {{ formatMoney(original_amount, $i18n.locale) }}
                          </span>
                        </small> -->
                        <!-- Tiket Amount with Instellments -->
                        <div v-if="
                          method == 'BOLETO' && permite_parcela_boleto > 1
                        ">
                          <span v-if="
                            bump.type === 'TRANSACTION' &&
                            product.type === 'TRANSACTION'
                          ">
                            {{ installments_boleto }}x {{ $t("order.de") }}
                          </span>
                          {{ filterCurrency(currency_id) }}
                          {{
                            formatMoney(
                              getInstallments(installments_boleto, bump.amount, false), $i18n.locale
                            )
                          }}
                          {{ sem_juros && installments_boleto > 1 ? "(Sem Juros)" : "" }}
                          <!-- À Vista -->
                          <small v-if="
                            installments_boleto > 1 &&
                            parcela_fixa === null
                          " data-test="avistaproduct xxx" class="d-block small-text">
                            {{ $t("order.a_vista") }}
                            {{ filterCurrency(currency_id) }}
                            {{
                              shipping.amount
                                ? formatMoney((bump.amount + shipping.amount), $i18n.locale)
                                : formatMoney(bump.amount, $i18n.locale)
                            }}
                            <br v-if="
                              checkoutPayment &&
                              checkoutPayment.price &&
                              checkoutPayment.price.payable_tax
                            " />
                            {{
                              checkoutPayment &&
                                checkoutPayment.price &&
                                checkoutPayment.price.payable_tax
                                ? $t("order.impostos")
                                : ""
                            }}
                            <br v-if="
                              checkoutPayment &&
                              checkoutPayment.price &&
                              checkoutPayment.price.payable_tax
                            " />
                          </small>
                        </div>
                        <!-- Amount with Shipping -->
                        <div v-else>
                          <span v-if="method !== 'PAYPAL' || !paypal">
                            {{ filterCurrency(currency_id) }}
                            {{
                              shipping.amount
                                ? formatMoney((bump.amount + shipping.amount), $i18n.locale)
                                : formatMoney(bump.amount, $i18n.locale)
                            }}
                          </span>
                          <!-- Amount Paypal -->
                          <span v-else>
                            {{ paypal.symbol_currency }}
                            {{ formatMoney(bump.amount, $i18n.locale) }}
                          </span>
                        </div>
                      </div>
                      <div v-else data-test="installmentsproduct">
                        <!-- Original Amount -->
                        <!-- <small
                          data-test="avistaproduct xx"
                          class="d-block small-text mb-1"
                        >
                          <span
                            v-if="
                              original_amount && cupom_checkout && cupom_valid
                            "
                            class="original-amount"
                          >
                            {{ filterCurrency(currency_id) }}
                            {{ formatMoney(product.amount, $i18n.locale) }}
                          </span>
                        </small> -->
                        <span v-if="
                          bump.type === 'TRANSACTION' &&
                          product.type === 'TRANSACTION'
                        ">{{ installments }}x {{ $t("order.de") }}</span>
                        {{ filterCurrency(currency_id) }}
                        {{
                          formatMoney(
                            getInstallments(
                              bump.type === "TRANSACTION" &&
                                product.type === "TRANSACTION"
                                ? installments
                                : 1,
                              bump.amount,
                              !!bump
                            ), $i18n.locale
                          )
                        }}
                        {{ bump.no_interest_installments && installments > 1 ? "(Sem Juros)" : "" }}
                        <!-- À Vista -->
                        <small v-if="
                          installments > 1 &&
                          parcela_fixa === null
                        " data-test="avistaproduct xxx" class="d-block small-text">
                          {{ $t("order.a_vista") }}
                          {{ filterCurrency(currency_id) }}
                          {{
                            shipping.amount
                              ? formatMoney((bump.amount + shipping.amount), $i18n.locale)
                              : formatMoney(bump.amount, $i18n.locale)
                          }}
                          <br v-if="
                            checkoutPayment &&
                            checkoutPayment.price &&
                            checkoutPayment.price.payable_tax
                          " />
                          {{
                            checkoutPayment &&
                              checkoutPayment.price &&
                              checkoutPayment.price.payable_tax
                              ? $t("order.impostos")
                              : ""
                          }}
                          <br v-if="
                            checkoutPayment &&
                            checkoutPayment.price &&
                            checkoutPayment.price.payable_tax
                          " />
                        </small>
                        <div v-if="
                          checkoutPayment &&
                          checkoutPayment.price &&
                          checkoutPayment.price.payable_tax
                        ">
                          <small v-for="fee in checkoutPayment.price.tax" :key="fee" class="d-block small-text">
                            {{ $t("order.taxa") }} {{ fee.description }} -
                            {{
                              fee.type === "FIXED"
                                ? filterCurrency(currency_id)
                                : ""
                            }}
                            {{
                              fee.type === "FIXED"
                                ? formatMoney(fee.fee, $i18n.locale)
                                : fee.fee + "%"
                            }}
                            <br />
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Gift -->
              <div v-if="
                (product_type == 'COMMON' &&
                  product.type == 'TRANSACTION' &&
                  product.format == 'PHYSICALPRODUCT' &&
                  product.can_be_gifted) ||
                (product_type == 'PROPOSAL' &&
                  product.product.type == 'TRANSACTION' &&
                  product.product.format == 'PHYSICALPRODUCT' &&
                  product.product.can_be_gifted)
              " class="item-info gift-content">
                <b-badge variant="info">
                  <b-form-checkbox id="check-gift" v-model="data.is_gift" name="check-gift">
                    Quero presentear alguém 🎁
                  </b-form-checkbox>
                </b-badge>
                <b-form-group v-if="data.is_gift" data-anima="top" class="mt-3">
                  <b-form-textarea id="gift_message" v-model="data.gift_message" data-test="gift_message" type="text"
                    name="gift_message" placeholder="Escreva uma mensagem para quem receberá o presente"
                    :state="submit ? !errors.has('gift_message') : null" v-validate="'required'"></b-form-textarea>

                  <b-form-invalid-feedback :state="submit ? !errors.has('gift_message') : null">
                    {{ $t("checkout.dados_pessoais.feedbacks.gift_message") }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>

              <b-row v-if="
                (product_type == 'COMMON' &&
                  product.type == 'SUBSCRIPTION') ||
                (product_type == 'PROPOSAL' &&
                  product.product.type == 'SUBSCRIPTION') ||
                !method_credit_card
              " class="infos-mais">
                <!-- mostrando valor grifado (cupom) -->

                <b-col cols="12">
                  <!-- <div
                    v-if="cupom_checkout && cupom_valid && permite_cupom"
                    style="font-size: clamp(0.6rem, 0.6vw, 1rem); display: flex; justify-content: space-between; flex: 1;margin-bottom: 1rem;margin-top: 1rem; color: var(--text-input);"
                  >
                    <span>Cupom de desconto:</span>
                    <span>
                      {{
                        `${filterCurrency(currency_id)} ${formatMoney(
                          (original_amount - desconto_amount), $i18n.locale
                        )}`
                      }}
                    </span>
                  </div> -->
                  <!-- <div
                    style="display: flex; justify-content: space-between; flex: 1;margin-bottom: 1rem;margin-top: 1rem; color: var(--text-input);"
                  >
                    <h6 style="font-weight: bold;">Total a pagar</h6>
                    <h6 style="font-weight: bold;">
                      {{
                        `${filterCurrency(currency_id)} ${formatMoney(
                          totalToPay, $i18n.locale
                        )}`
                      }}
                    </h6>
                  </div> -->
                  <div>
                    <!-- <span
                      v-if="original_amount && cupom_checkout && cupom_valid"
                      class="original-amount mb-2"
                    >
                      {{ filterCurrency(currency_id) }}
                      {{ formatMoney(original_amount, $i18n.locale) }}
                      <span
                        v-if="
                          (product_type == 'COMMON' &&
                            product.type == 'SUBSCRIPTION') ||
                            (product_type == 'PROPOSAL' &&
                              product.product.type == 'SUBSCRIPTION')
                        "
                      >
                        {{ setPeriod }}
                      </span>
                    </span> -->

                    <!-- mostrar bagde apenas se nao tiver parametro -->
                    <div v-if="themeCheckout.trial_position != 'bottom'">
                      <b-badge v-if="
                        (product_type == 'COMMON' && product.trial) ||
                        (product_type == 'PROPOSAL' &&
                          product.product.trial)
                      " data-test="trialproduct" variant="success" class="Product-trial business">
                        {{ $t("order.apos_trial") }}
                        {{
                          product_type == "COMMON"
                            ? product.trial
                            : "" || product_type == "PROPOSAL"
                              ? product.product.trial
                              : ""
                        }}
                        dias:
                        {{
                          parcela_fixa && themeCheckout.trial_info == "fixa"
                            ? `${parcela_fixa}x de ${filterCurrency(
                              currency_id
                            )} ${formatMoney(
                              getInstallments(parcela_fixa, product.amount), $i18n.locale
                            )} `
                            : `${filterCurrency(currency_id)} ${formatMoney(
                              product.amount, $i18n.locale
                            )}`
                        }}
                        <span v-if="
                          (product_type == 'COMMON' &&
                            product.type == 'SUBSCRIPTION') ||
                          (product_type == 'PROPOSAL' &&
                            product.product.type == 'SUBSCRIPTION')
                        ">
                          {{ setPeriod() }}
                        </span></b-badge>
                    </div>
                  </div>
                  <div>
                    <div class="item-info" v-if="is_produto_fisico">
                      <div class="info-title">Frete</div>
                      <p class="frete-amount">
                        {{
                          !data.has_shipping_fee
                            ? "GRÁTIS para todo Brasil"
                            : `${shipping.amount
                              ? `${filterCurrency(
                                currency_id
                              )} ${formatMoney(shipping.amount, $i18n.locale)}`
                              : "a calcular"
                            }`
                        }}
                      </p>
                    </div>
                    <div v-if="themeCheckout.warranty_checkout == 'on'" class="item-info">
                      <div class="info-title">
                        {{ $t("order.garantia_label") }}
                      </div>
                      <p data-test="warrantyproduct">
                        {{
                          product_type == "COMMON"
                            ? product.warranty
                            : product.product.warranty
                        }}
                        {{ $t("order.dias_garantia") }}
                      </p>
                    </div>

                    <div class="item-info">
                      <div class="info-title">
                        {{ $t("order.autor_label") }}
                      </div>
                      <p v-if="product_type == 'COMMON' && product.seller" data-test="sellerproduct">
                        {{
                          product.seller.company
                            ? product.seller.company.fantasy_name ||
                            product.seller.name
                            : product.seller.name
                        }}
                      </p>
                      <p v-if="
                        product_type == 'PROPOSAL' &&
                        (product.product.seller.company ||
                          product.product.seller)
                      " data-test="sellerproduct">
                        {{
                          product.product.seller.company
                            ? product.product.seller.company.fantasy_name ||
                            product.product.seller.name
                            : product.product.seller.name
                        }}
                      </p>
                    </div>

                    <div class="item-info">
                      <div v-if="
                        (product_type == 'COMMON' &&
                          product.seller &&
                          product.seller.company &&
                          product.seller.company.email) ||
                        (product_type == 'PROPOSAL' &&
                          product.product.seller &&
                          product.product.seller.company &&
                          product.product.seller.company.email)
                      " class="info-title">
                        {{ $t("order.email_label") }}
                      </div>
                      <p v-if="
                        product_type == 'COMMON' &&
                        product.seller &&
                        product.seller.company &&
                        product.seller.company.email
                      " data-test="support_email">
                        {{ product.seller.company.email }}
                      </p>
                      <p v-if="
                        product_type == 'PROPOSAL' &&
                        product.product.seller &&
                        product.product.seller.company &&
                        product.product.seller.company.email
                      " data-test="support_email">
                        {{ product.product.seller.company.email }}
                      </p>
                    </div>

                    <div class="item-info">
                      <div v-if="
                        (product_type == 'COMMON' &&
                          product.seller &&
                          product.seller.company &&
                          product.seller.company.support_telephone) ||
                        (product_type == 'PROPOSAL' &&
                          product.product.seller &&
                          product.product.seller.company &&
                          product.product.seller.company.support_telephone)
                      " class="info-title">
                        {{ $t("order.telefone_label") }}
                      </div>
                      <p v-if="
                        product_type == 'COMMON' &&
                        product.seller &&
                        product.seller.company &&
                        product.seller.company.support_telephone
                      " data-test="support_telephone">
                        <a :href="`tel:${product.seller.company.support_telephone}`
                          ">
                          {{ product.seller.company.support_telephone }}
                        </a>
                      </p>
                      <p v-if="
                        product_type == 'PROPOSAL' &&
                        product.product.seller &&
                        product.product.seller.company &&
                        product.product.seller.company.support_telephone
                      " data-test="support_telephone">
                        <a :href="`tel:${product.product.seller.company.support_telephone}`
                          ">
                          {{ product.product.seller.company.support_telephone }}
                        </a>
                      </p>
                    </div>
                    <div v-show="permite_cupom" class="item-info">
                      <Cupom :cupom_checkout="cupom_checkout" :product_id="product.product_id || product.id"
                        :product_name="product.name" :amount="product.amount" :trackEvent="trackEvent" ref="Cupom" />
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row class="infos-mais" v-else>
                <b-col cols="12">
                  <!-- <div
                    v-if="cupom_checkout && cupom_valid && permite_cupom"
                    style="font-size: clamp(0.6rem, 0.6vw, 1rem); display: flex; justify-content: space-between; flex: 1;margin-bottom: 1rem;margin-top: 1rem; color: var(--text-input);"
                  >
                    <span>Cupom de desconto:</span>
                    <span>
                      {{
                        `${filterCurrency(currency_id)} ${formatMoney(
                          (original_amount - desconto_amount), $i18n.locale
                        )}`
                      }}
                    </span>
                  </div> -->
                  <!-- <div
                    style="display: flex; justify-content: space-between; flex: 1;margin-bottom: 1rem;margin-top: 1rem; color: var(--text-input);"
                  >
                    <h6 style="font-weight: bold;">Total a pagar</h6>
                    <h6 style="font-weight: bold;">
                      {{
                        `${filterCurrency(currency_id)} ${formatMoney(
                          totalToPay, $i18n.locale
                        )}`
                      }}
                    </h6>
                  </div> -->
                  <!-- Frete -->
                  <div v-if="is_produto_fisico" class="item-info">
                    <div class="info-title">Frete</div>
                    <p class="frete-amount">
                      {{
                        !data.has_shipping_fee
                          ? "GRÁTIS para todo Brasil"
                          : `${shipping.amount
                            ? `${filterCurrency(currency_id)} ${formatMoney(
                              shipping.amount, $i18n.locale
                            )}`
                            : "a calcular"
                          }`
                      }}
                    </p>
                  </div>
                  <!-- Warranty Days -->
                  <div v-if="themeCheckout.warranty_checkout == 'on'" class="item-info">
                    <div class="info-title">
                      {{ $t("order.garantia_label") }}
                    </div>
                    <p data-test="warrantyproduct">
                      {{
                        product_type == "COMMON"
                          ? product.warranty
                          : product.product.warranty
                      }}
                      {{ $t("order.dias_garantia") }}
                    </p>
                  </div>
                  <!-- Author -->
                  <div class="item-info">
                    <div class="info-title">{{ $t("order.autor_label") }}</div>
                    <p v-if="product_type == 'COMMON' && product.seller" data-test="sellerproduct">
                      {{
                        product.seller.company
                          ? product.seller.company.fantasy_name ||
                          product.seller.name
                          : product.seller.name
                      }}
                    </p>
                    <p v-if="
                      product_type == 'PROPOSAL' &&
                      (product.product.seller.company ||
                        product.product.seller)
                    " data-test="sellerproduct">
                      {{
                        product.product.seller.company
                          ? product.product.seller.company.fantasy_name ||
                          product.product.seller.name
                          : product.product.seller.name
                      }}
                    </p>
                  </div>
                  <!-- E-mail -->
                  <div class="item-info">
                    <div v-if="
                      (product_type == 'COMMON' &&
                        product.seller &&
                        product.seller.company &&
                        product.seller.company.email) ||
                      (product_type == 'PROPOSAL' &&
                        product.product.seller &&
                        product.product.seller.company &&
                        product.product.seller.company.email)
                    " class="info-title">
                      {{ $t("order.email_label") }}
                    </div>
                    <p v-if="
                      product_type == 'COMMON' &&
                      product.seller &&
                      product.seller.company &&
                      product.seller.company.email
                    " data-test="support_email">
                      {{ product.seller.company.email }}
                    </p>
                    <p v-if="
                      product_type == 'PROPOSAL' &&
                      product.product.seller &&
                      product.product.seller.company &&
                      product.product.seller.company.email
                    " data-test="support_email">
                      {{ product.product.seller.company.email }}
                    </p>
                  </div>
                  <!-- Telephone -->
                  <div class="item-info">
                    <div v-if="
                      (product_type == 'COMMON' &&
                        product.seller &&
                        product.seller.company &&
                        product.seller.company.support_telephone) ||
                      (product_type == 'PROPOSAL' &&
                        product.product.seller &&
                        product.product.seller.company &&
                        product.product.seller.company.support_telephone)
                    " class="info-title">
                      {{ $t("order.telefone_label") }}
                    </div>
                    <p v-if="
                      product_type == 'COMMON' &&
                      product.seller &&
                      product.seller.company &&
                      product.seller.company.support_telephone
                    " data-test="support_telephone">
                      <a :href="`tel:${product.seller.company.support_telephone}`
                        ">
                        {{ product.seller.company.support_telephone }}
                      </a>
                    </p>
                    <p v-if="
                      product_type == 'PROPOSAL' &&
                      product.product.seller &&
                      product.product.seller.company &&
                      product.product.seller.company.support_telephone
                    " data-test="support_telephone">
                      <a :href="`tel:${product.product.seller.company.support_telephone}`
                        ">
                        {{ product.product.seller.company.support_telephone }}
                      </a>
                    </p>
                  </div>
                  <!-- Coupom -->
                  <div v-if="permite_cupom" class="item-info">
                    <Cupom :cupom_checkout="cupom_checkout" :product_id="product.product_id || product.id"
                      :product_name="product.name" :amount="product.amount" :trackEvent="trackEvent" ref="Cupom" />
                  </div>
                </b-col>
              </b-row>
            </div>
            <!-- Banner -->
            <template v-if="
              themeCheckout.side_thumb &&
              !isMobile &&
              !charge_error &&
              !charge_success
            ">
              <div class="container banner-container container-banner-side">
                <img :src="themeCheckout.side_thumb" alt="side-thumb" class="banner" />
              </div>
            </template>
          </b-col>

          <b-col v-if="isMobile && !charge_error" class="etapas" order="2">
            <p></p>
            <p>
              <span v-for="(etapa, index) in etapa_total" :key="etapa" class="icon-etapa"
                :class="{ target: index == 0 }"></span>
            </p>
          </b-col>
        </b-row>
        <div class="Checkout-footer-brands">
          <div class="footer-safe" v-if="!charge_error && !charge_success">
            <div class="item-safe">
              <img src="@/assets/img/icon/safe_lock.svg" alt="safe_lock" />
              <p>{{ $t("checkout.footer.icons.compra_segura.label") }}</p>
              <p class="destaque-info _lock">
                {{ $t("checkout.footer.icons.compra_segura.destaque") }}
              </p>
            </div>
            <div class="item-safe">
              <img src="@/assets/img/icon/safe_product.svg" alt="safe_product" />
              <p>
                {{ $t("checkout.footer.icons.produto_revisado.label") }}
              </p>
              <p class="destaque-info _product">
                {{ $t("checkout.footer.icons.produto_revisado.destaque") }}
              </p>
            </div>
            <div class="item-safe">
              <img src="@/assets/img/icon/safe_dados.svg" alt="safe_dados" />
              <p>
                {{ $t("checkout.footer.icons.dados_protegidos.label") }}
              </p>
              <p class="destaque-info _dados">
                {{ $t("checkout.footer.icons.dados_protegidos.destaque") }}
              </p>
            </div>
          </div>

          <div v-if="
            !charge_error &&
            !charge_success &&
            isMobile &&
            themeCheckout.theme == 'light'
          " class="cards_type mobile">
            <img src="@/assets/img/logo2.png" class="icon-footer" alt="icon-greenn" />
            <img :src="getImg('visa')" class="icon-footer" alt="icon-visa" />
            <img :src="getImg('mastercard')" class="icon-footer" alt="icon-mastercard" />
            <img :src="getImg('hipercard-v2')" class="icon-footer" alt="icon-hipercard" />
            <img :src="getImg('diners')" class="icon-footer" alt="icon-diners" />
            <img :src="getImg('elo')" class="icon-footer" alt="icon-elo" />
            <img :src="getImg('boleto-barcode')" class="icon-footer" alt="icon-boleto" />
          </div>
          <div v-if="
            !charge_error &&
            !charge_success &&
            isMobile &&
            themeCheckout.theme == 'dark'
          " class="cards_type mobile">
            <!-- <img
              src="@/assets/img/logo2-dark.png"
              class="icon-footer"
              alt="icon-greenn"
            /> -->
            <img :src="getImg('visa-dark')" class="icon-footer" alt="icon-visa" />
            <img :src="getImg('mastercard-dark')" class="icon-footer" alt="icon-mastercard" />
            <img :src="getImg('hipercard-v2-dark')" class="icon-footer" alt="icon-hipercard" />
            <img :src="getImg('diners-dark')" class="icon-footer" alt="icon-diners" />
            <img :src="getImg('elo-dark')" class="icon-footer" alt="icon-elo" />
            <img :src="getImg('boleto-barcode-dark')" class="icon-footer" alt="icon-boleto" />
          </div>
          <div>
            <p v-if="
              !charge_error &&
              !charge_success &&
              !isMobile &&
              !sem_juros &&
              (method === 'CREDIT_CARD' && installments > 1)
            " class="p-footer">
              {{ $t("checkout.footer.taxa_parcela") }}
              {{ monthly_interest }}% a.m
              <!-- Interest Free Instellments -->
            </p>
          </div>
          <div v-if="
            !charge_error &&
            !charge_success &&
            !isMobile &&
            themeCheckout.theme == 'light'
          " class="cards_type">
            <img src="@/assets/img/logo2.png" class="icon-footer" alt="icon-greenn" />
            <img :src="getImg('visa')" class="icon-footer" alt="icon-visa" />
            <img :src="getImg('mastercard')" class="icon-footer" alt="icon-mastercard" />
            <img :src="getImg('hipercard-v2')" class="icon-footer" alt="icon-hipercard" />
            <img :src="getImg('diners')" class="icon-footer" alt="icon-diners" />
            <img :src="getImg('elo')" class="icon-footer" alt="icon-elo" />
            <img :src="getImg('boleto-barcode')" class="icon-footer" alt="icon-boleto" />
          </div>

          <div v-if="
            !charge_error &&
            !charge_success &&
            !isMobile &&
            themeCheckout.theme == 'dark'
          " class="cards_type">
            <!-- <img
              src="@/assets/img/logo2-dark.png"
              class="icon-footer"
              alt="icon-greenn"
            /> -->
            <img :src="getImg('visa-dark')" class="icon-footer" alt="icon-visa" />
            <img :src="getImg('mastercard-dark')" class="icon-footer" alt="icon-mastercard" />
            <img :src="getImg('hipercard-v2-dark')" class="icon-footer" alt="icon-hipercard" />
            <img :src="getImg('diners-dark')" class="icon-footer" alt="icon-diners" />
            <img :src="getImg('elo-dark')" class="icon-footer" alt="icon-elo" />
            <img :src="getImg('boleto-barcode-dark')" class="icon-footer" alt="icon-boleto" />
          </div>
        </div>
        <Alert :product_name="product.name" :message_error="error_message" :has_code="has_code" />
        <!-- WhatsApp -->
        <a v-if="
          themeCheckout.whatsapp_button &&
          themeCheckout.whatsapp_number &&
          themeCheckout.whatsapp_number != ''
        " :href="'https://wa.me/' +
          wpp_number.replace(/\(|\)/g, '') +
          '?text=' +
          themeCheckout.whatsapp_msg.replace(' ', '%20')
          " class="btn-wpp" target="_blank" :style="themeCheckout.jivochat_id
            ? 'bottom: 110px; right: 23px !important;'
            : ''
            ">
          <img src="@/assets/img/icon/whatsapp.png" height="40" width="40" />
        </a>
      </b-container>
    </div>
  </div>
</template>
<script>
import VuePhoneNumberInput from "vue-phone-number-input";

import Navbar from "@/components/navbar/NavBar.vue";
import PaymentService from "@/services/resources/PaymentService";
import GatewayService from "@/services/resources/GatewayService";
import ProductService from "@/services/resources/ProductService";
import CheckoutService from "@/services/resources/CheckoutService";
import UserSettingsService from "@/services/resources/UserSettingsService";
import GlobalSettingsService from "@/services/resources/GlobalSettingsService";
import ClientStatisticsService from "@/services/resources/ClientStatisticsService";
import LeadService from "@/services/resources/LeadService";
import ShippingService from "@/services/resources/ShippingService";
import ProposalService from "@/services/resources/ProposalService";
import UpsellService from "@/services/resources/UpsellService";
import Card from "@/components/Checkout/Card";
import Escassez from "@/components/Checkout/Escassez";
import axios from "axios";
import Cookies from "js-cookie";
import pagarme from "@/assets/js/pagarme.min";
import UAParser from "ua-parser-js";
import Money from "@/mixins/money";
import LocaleUtils from "@/mixins/localeUtils";
import Alert from "@/components/Alert";
import Locales from "@/components/Locales";
import Cupom from "@/components/Checkout/Cupom";
import { EventBus } from "@/main.js";
import Vue from "vue";
import { symbolCurrency } from "@/utils/currency.js";
import Captcha from "@/components/security/Captcha.vue";
// import InfoPix from "@/components/Checkout/InfoPix";
// import {loadStripe} from '@stripe/stripe-js';

const serviceGateway = GatewayService.build();
const servicePayment = PaymentService.build();
const serviceProduct = ProductService.build();
const serviceCheckout = CheckoutService.build();
const serviceSettings = UserSettingsService.build();
const serviceGlobalSettings = GlobalSettingsService.build();
const serviceClientStatistics = ClientStatisticsService.build();
const serviceLead = LeadService.build();
const serviceShipping = ShippingService.build();
const serviceProposal = ProposalService.build();
const serviceUpsell = UpsellService.build();

export default {
  components: {
    Card,
    Navbar,
    Alert,
    Locales,
    VuePhoneNumberInput,
    Cupom,
    Escassez,
    // InfoPix, 
    Captcha
  },
  mixins: [Money, LocaleUtils],
  data() {
    return {
      captcha: false,
      isValidToken: false,
      bank_type: "",
      external_banks: [],
      address_step: false,
      affiliate: null,
      max_installments: 12,
      amexCardMask: "#### ###### #####",
      amount_cards: {
        card_1: 0,
        card_2: 0,
      },
      boleto_barcode: null,
      boleto_url: null,
      b_offer: null,
      btn_paypal: false,
      bump: null,
      bump_list: [],
      bump_error: false,
      bump_descriptions: [],
      business: false,
      buy_button_text: "Comprar agora",
      capture: {
        product_id: null,
        proposal_id: null,
        seller_id: null,
        affiliate_id: null,
        name: null,
        email: null,
        cpf: null,
        cellphone: null,
        zip_code: null,
        street: null,
        number: null,
        neighborhood: null,
        city: null,
        state: null,
        step: null,
        uuid: null,
      },
      card_number_error: false,
      charge_success: false,
      charge_error: false,
      checkoutPayment: [],
      client: {
        width: 0,
      },
      client_statistics: [],
      countryGlobal: "BR",
      cupom_checkout: "",
      desconto_amount: 0,
      cupom_valid: false,
      currency: "BRL",
      currency_id: 1,
      custom_bump: null,
      data: {
        name: "",
        email: "",
        confirmation_email: "",
        cellphone: "",
        document: "",
        cards: [
          {
            amount: "",
            number: "",
            holder_name: "",
            valid: "",
            year: "",
            month: "",
            cvv: "",
          },
        ],
        zipcode: "",
        street: "",
        number: "",
        complement: "",
        neighborhood: "",
        city: "",
        state: "",
        bump: false,
        gift_message: "",
        is_gift: false,
        billing_shipping_same_address: false,
        has_shipping_fee: false,
        ip_address: "",
        fbc: "",
        fbp: "",
      },
      dataLog: {},
      debounce: null,
      debugPixel: false,
      defaultCountry: "",
      document: null,
      error_message: "",
      errorPhone: false,
      escassez: null,
      etapa_atual: 1,
      etapa_total: 2,
      foreign: false,
      has_code: false,
      has_greenn_me: false,
      includeBump: false,
      installments: 1,
      installments_boleto: 1,
      last_step: false,
      loading: false,
      loading_frete: false,
      is_antifraude: false,
      is_produto_fisico: false,
      isBr: true,
      metas: null,
      method: "",
      method_credit_card: true,
      method_pix: false,
      minCardYear: new Date().getFullYear(),
      monthly_interest: 0,
      sellerSettingsLoading: false,
      no_bump: false,
      notifications: [],
      optionsStateUS: [
        { value: null, text: "Select your state", disabled: true },
        { value: "US-AK", text: "Alaska" },
        { value: "US-AL", text: "Alabama" },
        { value: "US-AR", text: "Arkansas" },
        { value: "US-AS", text: "American Samoa" },
        { value: "US-AZ", text: "Arizona" },
        { value: "US-CA", text: "California" },
        { value: "US-CO", text: "Colorado" },
        { value: "US-CT", text: "Connecticut" },
        { value: "US-DC", text: "District of Columbia" },
        { value: "US-DE", text: "Delaware" },
        { value: "US-FL", text: "Florida" },
        { value: "US-GA", text: "Georgia" },
        { value: "US-GU", text: "Guam" },
        { value: "US-HI", text: "Hawaii" },
        { value: "US-IA", text: "Iowa" },
        { value: "US-ID", text: "Idaho" },
        { value: "US-IL", text: "Illinois" },
        { value: "US-IN", text: "Indiana" },
        { value: "US-KS", text: "Kansas" },
        { value: "US-KY", text: "Kentucky" },
        { value: "US-LA", text: "Louisiana" },
        { value: "US-MA", text: "Massachusetts" },
        { value: "US-MD", text: "Maryland" },
        { value: "US-ME", text: "Maine" },
        { value: "US-MI", text: "Michigan" },
        { value: "US-MN", text: "Minnesota" },
        { value: "US-MO", text: "Missouri" },
        { value: "US-MS", text: "Mississippi" },
        { value: "US-MT", text: "Montana" },
        { value: "US-NC", text: "North Carolina" },
        { value: "US-ND", text: "North Dakota" },
        { value: "US-NE", text: "Nebraska" },
        { value: "US-NH", text: "New Hampshire" },
        { value: "US-NJ", text: "New Jersey" },
        { value: "US-NM", text: "New Mexico" },
        { value: "US-NV", text: "Nevada" },
        { value: "US-NY", text: "New York" },
        { value: "US-OH", text: "Ohio" },
        { value: "US-OK", text: "Oklahoma" },
        { value: "US-OR", text: "Oregon" },
        { value: "US-PA", text: "Pennsylvania" },
        { value: "US-PR", text: "Puerto Rico" },
        { value: "US-RI", text: "Rhode Island" },
        { value: "US-SC", text: "South Carolina" },
        { value: "US-SD", text: "South Dakota" },
        { value: "US-TN", text: "Tennessee" },
        { value: "US-TX", text: "Texas" },
        { value: "US-UT", text: "Utah" },
        { value: "US-VA", text: "Virginia" },
        { value: "US-VI", text: "Virgin Islands" },
        { value: "US-VT", text: "Vermont" },
        { value: "US-WA", text: "Washington" },
        { value: "US-WI", text: "Wisconsin" },
        { value: "US-WV", text: "West Virginia" },
        { value: "US-WY", text: "Wyoming" },
      ],
      options_shipping: [],
      original_amount: 0,
      original_amount_sem_frete: 0,
      otherCardMask: "#### #### #### ####",
      page_thanks_response: "",
      parcela_fixa: null,
      paypal: {
        original_amount: 0,
        amount: 0,
        currency: "BRL",
        symbol_currency: "R$",
      },
      paypal_true: false,
      permite_cupom: 1,
      permite_parcela_assinatura: 0,
      permite_parcela_boleto: 0,
      possui_endereco: false,
      preload: false,
      price: 0,
      product: {
        images: [{ path: "" }],
        name: "",
        description: "",
        seller: {
          company: {
            name: "",
          },
          name: "",
        },
        method: "",
        status: "",
      },
      product_type: "COMMON",
      products_client_statistics: [],
      products_list: [],
      queryUrl: {},
      rate: {
        target_currency: "",
        base_currency: "",
        token: "",
      },
      renderComponent: true,
      sem_juros: 0,
      sem_parcela: false,
      payment_methods: [],
      shipping: {
        address: {
          zipcode: "",
          street: "",
          number: "",
          complement: "",
          neighborhood: "",
          city: "",
          state: "",
        },
        service_name: "",
        service_id: "",
        amount: 0,
        old_amount: 0,
        frete: null,
        frete_anterior: null,
      },
      submit: false,
      themeCheckout: {
        theme: "light",
        theme_color: null,
        top_thumb: null,
        bottom_thumb: null,
        side_thumb: null,
        logotipo: null,
        theme_color_bg: null,
        whatsapp_number: "",
        whatsapp_button: null,
        whatsapp_msg: "",
      },
      upsell_id: undefined,
      uuid: this.$uuid.v4(),
      valid_document_es: false,
      wpp: false,
      wpp_number: "",
      confirmation_email: false,
      // telephone
      yourValue: this.$route.query.ph ?? null,
      results_tel: {
        valid: false,
        isValid: false,
      },
      results_country: {
        valid: false,
      },
      translations_pt: {
        countrySelectorLabel: "Código do país",
        countrySelectorError: "Escolha um país",
        phoneNumberLabel: "Número de Telefone",
        example: "Exemplo: ",
      },
      translations_en: {
        countrySelectorLabel: "Country code",
        countrySelectorError: "Choose a country",
        phoneNumberLabel: "Phone number",
        example: "Example: ",
      },
      name: "",
      eventData: {},
      sellersDomains: [],
      stripe: {
        load: null,
        card: null,
      },
      mdFormCard: '6',
    };
  },
  computed: {
    ano_atual() {
      return new Date().getFullYear();
    },
    totalToPay() {
      // product amount (com juros ou sem) + bump amount ( com juros ou sem )
      // juros só aplica se os dois produtos forem type SUBSCRIPTION
      let totalToPay = 0;

      if (this.bump) {
        if (
          this.product.type === "TRANSACTION" &&
          this.bump.type === "TRANSACTION"
        ) {
          if (this.method === "CREDIT_CARD") {
            totalToPay =
              this.getInstallments(this.installments, this.product.amount) *
              this.installments;
            if (this.bump.checkbox)
              totalToPay +=
                this.getInstallments(
                  this.installments,
                  this.bump.amount,
                  true
                ) * this.installments;
          } else if (this.method === "BOLETO") {
            totalToPay =
              this.getInstallments(
                this.installments_boleto,
                this.product.amount
              ) * this.installments_boleto;
            if (this.bump.checkbox)
              totalToPay +=
                this.getInstallments(
                  this.installments_boleto,
                  this.bump.amount,
                  false
                ) * this.installments_boleto;
          } else {
            totalToPay = this.product.amount + (this.bump.checkbox ? this.bump.amount : 0);
          }
        } else {
          if (this.method === "CREDIT_CARD") {
            totalToPay =
              this.getInstallments(this.installments, this.product.amount) *
              this.installments;
          } else if (this.method === "BOLETO") {
            totalToPay =
              this.getInstallments(
                this.installments_boleto,
                this.product.amount
              ) * this.installments_boleto;
          } else {
            totalToPay = this.product.amount;
          }
          totalToPay += this.bump.checkbox ? this.bump.amount : 0;
        }
      } else {
        if (this.method === "CREDIT_CARD") {
          totalToPay =
            this.getInstallments(this.installments, this.product.amount) *
            this.installments;
        } else if (this.method === "BOLETO") {
          totalToPay =
            this.getInstallments(
              this.installments_boleto,
              this.product.amount
            ) * this.installments_boleto;
        } else {
          totalToPay = this.product.amount;
        }
      }
      return totalToPay;
    },
    generateCardNumberMask() {
      return this.getCardType === "amex"
        ? this.amexCardMask
        : this.otherCardMask;
    },
    minCardMonth() {
      if (this.cardYear === this.minCardYear) return new Date().getMonth() + 1;
      return 1;
    },
    isMobile() {
      return this.client.width <= 769;
    },
    amount: {
      get() {
        return this.price;
      },
      set(value) {
        this.price = value;
      },
    },
    amountPaypalWithOrderBumps() {
      let amountBump = 0;
      this.products_list.forEach((p) => {
        if (p.product_id !== this.product.id) {
          this.bump_list.forEach((b) => {
            if (b.id === p.product_id) {
              amountBump += b.paypal.amount;
            }
          });
        }
      });
      return this.formatMoney((this.paypal.amount + amountBump), $i18n.locale);
    },
    confirmed_email() {
      return this.data.confirmation_email == this.data.email;
    },
    gateway() {
      let gw = (this.method == "CREDIT_CARD" && this.checkoutPayment.base_currency != "BRL" && this.checkoutPayment.gateway_name == "STRIPE") ? "stripe" : (this.method == "CREDIT_CARD" || this.method == "BOLETO" || this.method == "PIX") && this.checkoutPayment.base_currency == "BRL" && this.checkoutPayment.gateway_name == "PAGARME" ? "pagarme" : this.method.toLowerCase();
      this.mdFormCard = gw == 'stripe' ? '12' : '6';
      if (this.countryGlobal !== "BR" && this.payment_methods && this.payment_methods.indexOf("CREDIT_CARD") >= 0) {
        this.loadStripe();
      }
      return gw;
    }
  },
  watch: {
    results_tel(event) {
      // this.$refs.telinput.$refs.CountrySelector.$listeners.input(event.countryCode);
      this.defaultCountry = event.countryCode;
      this.foreign = event.countryCode !== "BR";

      if (event.countryCode !== "BR") this.errorPhone = false;
    },
    checkoutPayment(data) {
      this.checkoutPayment = data;
      this.forceRerender();
    },
    countryGlobal() {
      this.country_code = this.countryGlobal;
      if (this.countryGlobal !== "BR") {
        this.mountStripeCard();
      } else {
        this.destroyStripeCard();
      }
    },
  },
  methods: {
    totalInstallmentPrice(installments) {
      // product amount (com juros ou sem) + bump amount ( com juros ou sem )
      let totalToPay = 0;

      if (this.bump && this.bump.checkbox) {
        if (
          this.product.type === "TRANSACTION" &&
          this.bump.type === "TRANSACTION"
        ) {
          if (this.method === "CREDIT_CARD") {
            totalToPay =
              this.getInstallments(installments, this.product.amount);
            if (this.bump.checkbox)
              totalToPay +=
                this.getInstallments(
                  installments,
                  this.bump.amount,
                  true
                );
          } else if (this.method === "BOLETO") {
            totalToPay =
              this.getInstallments(
                installments,
                this.product.amount
              );
            if (this.bump.checkbox)
              totalToPay +=
                this.getInstallments(
                  installments,
                  this.bump.amount,
                  false
                );
          } else {
            totalToPay = this.product.amount + (this.bump.checkbox ? this.bump.amount : 0);
          }
        } else {
          totalToPay = this.getInstallments(
            installments,
            this.product.amount
          );
        }
      } else {
        if (this.method === "CREDIT_CARD") {
          totalToPay =
            this.getInstallments(installments, this.product.amount);
        } else if (this.method === "BOLETO") {
          totalToPay =
            this.getInstallments(
              installments,
              this.product.amount
            );
        } else {
          totalToPay = this.product.amount;
        }
      }
      return totalToPay;
    },
    getDomainName(domain) {
      var parts = domain.split('.').reverse();
      var cnt = parts.length;
      if (cnt >= 3) {
        // see if the second level domain is a common SLD.
        if (parts[1].match(/^(com|edu|gov|net|mil|org|nom|co|name|info|biz|dev)$/i)) {
          return parts[2] + '.' + parts[1] + '.' + parts[0];
        }
      }
      return parts[1] + '.' + parts[0];
    },
    isCorrectDomain() {
      const sellerDomains = this.sellersDomains.flat();
      if (sellerDomains.length > 0) {
        const domain = this.getDomainName(window.location.hostname);
        const creatorsMainDomain = "voompcreators." + process.env.VUE_URL_DOMAIN;

        if (sellerDomains.length > 0 && !sellerDomains.includes(domain) && domain !== creatorsMainDomain && window.location.hostname !== "localhost") {
          setTimeout(() => {
            this.preload = true
            document.querySelector(".carregando").classList.add("erro");
          }, 300);
        } else if (sellerDomains.length == 0 && domain !== creatorsMainDomain && window.location.hostname !== "localhost") {
          setTimeout(() => {
            this.preload = true
            document.querySelector(".carregando").classList.add("erro");
          }, 300);
        }
      }
    },
    setPeriod(bump = false) {
      const type = this.product_type;
      let periodo = 0;

      let texto = "";
      if (type == "COMMON") periodo = this.product.period;
      else if (type == "PROPOSAL") periodo = this.product.product.period;
      if (bump) periodo = this.bump.period;

      switch (periodo) {
        case 30:
          texto = this.$t("order.por_mes");
          break;
        case 90:
          texto = this.$t("order.por_trimestre");
          break;
        case 180:
          texto = this.$t("order.por_semestre");
          break;
        case 365:
          texto = this.$t("order.por_ano");
          break;
        default:
          if (periodo > 365) {
            texto = `/ ${Math.floor(periodo / 365)} ${this.$t("order.anos")}`;
          } else {
            texto = `/ ${periodo} ${this.$t("order.dias")}`;
          }
          break;
      }

      return texto;
    },
    verifyCaptcha(e) {
      this.captcha = e;
      this.method === "PAYPAL"
        ? this.renderPaypal("check")
        : this.onSubmit("check");
    },
    normalizeString(str) {
      return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replaceAll("-", "")
        .replaceAll("  ", " ")
        .replaceAll(" ", "-")
        .replaceAll(" ", "")
        .toLowerCase();
    },
    trackEvent(event) {
      if (event.currentTarget.value.length < 1) return;
      const inputName = event.currentTarget.name;
      const seller = this.normalizeString(
        this.product.seller.company
          ? this.product.seller.company.fantasy_name ||
          this.product.seller.company.name
          : this.product.seller.name
      );
      if (
        this.eventData[inputName] &&
        this.eventData[inputName] === event.currentTarget.value
      )
        return;
      this.eventData[inputName] = event.currentTarget.value;

      if (this.$gtm.enabled()) {
        const eventObj = {
          event: "event",
          eventCategory: `${seller}:checkout`,
          eventAction: "interacao:campo",
          eventLabel: inputName,
        };
        window.dataLayer?.push(eventObj);
      }
    },
    getIndexInstallments(e) {
      if (
        this.countryGlobal !== "BR"
      ) {
        this.installments = 1;
        if (e === 1 || e === 3 || e === 6 || e === 9 || e === 12) return true;
        else return false;
      } else return true;
    },
    forceRerender() {
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    filterCurrency() {
      if (
        this.checkoutPayment &&
        this.checkoutPayment.data &&
        this.checkoutPayment.data.symbol_currency
      ) {
        return this.checkoutPayment.data.symbol_currency;
      }
      return "R$";
    },
    filterCurrencyPais(id) {
      try {
        return symbolCurrency(id).pais;
      } catch (error) {
        return "BR";
      }
    },
    formatValueToValidation(value) {
      if (!value || value >= 0 || value == "") return false;
      value = parseFloat(
        value
          .toString()
          .replace(",", ".")
          .replace("-", "")
          .split(" ")[1]
      );
      if (value >= this.getInstallments(this.installments) * this.installments)
        return false;
      else return true;
    },
    onCheckoutEvent(product) {
      const dataProduct = {
        id: product.id,
        name: product.name,
        price: product.amount,
      };

    },
    changeEnderecoEntrega(e) {
      if (e) this.getCEP("charge");
    },
    changeBump(item, index) {
      if (item.checkbox === true) {
        Vue.set(this.bump_list[index], "checkbox", false);
      } else {
        Vue.set(this.bump_list[index], "checkbox", true);
      }
      this.addBumpProduct(item);
    },
    // reset erro payment
    resetCheckout(type) {
      this.submit = false;
      switch (type.toUpperCase()) {
        case "ALL":
        default:
          this.etapa_atual = 1;
          this.address_step = false;
          this.last_step = false;
          this.capture.step = 1;

          window.scrollTo({ top: 0, behavior: "smooth" });
          this.yourValue = "";
          this.cupom_checkout = "";
          this.cupom_valid = false;
          if (this.product.amount) {
            this.product.amount = this.original_amount;
            this.amount = this.original_amount;
          } else {
            this.product.product.amount = this.original_amount;
            this.amount = this.original_amount;
          }

          this.data = {
            name: "",
            email: "",
            confirmed_email: "",
            cellphone: "",
            document: "",
            cards: [
              {
                amount: "",
                number: "",
                holder_name: "",
                valid: "",
                year: "",
                month: "",
                cvv: "",
              },
            ],
            zipcode: "",
            street: "",
            number: "",
            complement: "",
            neighborhood: "",
            city: "",
            state: "",
            bump: false,
            gift_message: "",
            is_gift: false,
            billing_shipping_same_address: false,
            has_shipping_fee: false,
          };

          if (this.method === "TWO_CREDIT_CARDS") {
            this.data.cards.push({
              amount: "",
              number: "",
              holder_name: "",
              valid: "",
              year: "",
              month: "",
              cvv: "",
            });
          }

          this.data.has_shipping_fee =
            this.product_type == "COMMON"
              ? this.product.has_shipping_fee
              : this.product.product.has_shipping_fee;

          break;
        case "CARD":
          this.data.cards = [
            {
              amount: "",
              number: "",
              holder_name: "",
              valid: "",
              year: "",
              month: "",
              cvv: "",
            },
          ];

          if (this.method == "TWO_CREDIT_CARDS") {
            this.data.cards.push({
              amount: "",
              number: "",
              holder_name: "",
              valid: "",
              year: "",
              month: "",
              cvv: "",
            });
          }
          break;
        case "CVV":
          if (this.data.cards.length == 2) this.data.cards[1].cvv = "";
          else this.data.cards[0].cvv = "";
          break;
      }
    },
    blurInputPhone() {
      this.validateForm();
      try {
        if (
          this.results_tel.nationalNumber?.length !== 11 &&
          this.results_tel.countryCode === "BR"
        )
          this.errorPhone = false;
        else {
          if (this.results_tel.nationalNumber?.length < 12 && this.results_tel.countryCode !== "BR") return;
          this.errorPhone = false;
        }
      } catch (e) {
        console.log(e)
      }
    },
    onSelectCountry(event) {
      this.country_code = event.iso2;
      let countyCode = document.getElementsByClassName("country-code")[0];
      countyCode.classList.add("ml-2");
      countyCode.classList.add("mr-2");
      countyCode.innerText = event.name;
    },
    resetTokens() {
      this.preload = false;
      this.loading = false;

      // const query = this.$route.query;
      // const slug = this.$route.params.product;
      // if (slug && !query.prop_id && !query.ch_id) {
      //   this.getProduct(slug, this.countryGlobal);
      // } else if (typeof query.prop_id != "undefined") {
      //   this.getProposal(query.prop_id);
      // } else if (typeof query.ch_id != "undefined") {
      //   this.getThemeCheckout(slug, query.ch_id);
      // }

      // if (query.b_id) this.getBump(query.b_id, this.countryGlobal);
    },
    formatPageThankYou(response) {
      if (response[0].upsell && response[0].upsell.metas.length) {
        response[0].upsell.metas.forEach((item) => {
          if (item.upsell_key == "link_obrigado") {
            this.page_thanks_response = item.upsell_value;

            if (!item.upsell_value) {
              this.page_thanks_response =
                this.product_type == "COMMON"
                  ? this.product.thank_you_page
                  : this.product.product.thank_you_page;
            }
          }
        });
      } else {
        if (this.product_type == "COMMON") {
          this.page_thanks_response = this.product.thank_you_page;
        } else {
          this.page_thanks_response = this.product.product.thank_you_page;
        }
      }
    },
    getThemeCheckout(id_produto, id_checkout) {
      let data = {
        id: `/${id_produto}/checkout/${id_checkout}`,
      };

      if (this.$route.params.hash) {
        data.id = `/${id_produto}/checkout/${id_checkout}/offer/${this.$route.params.hash}`;
      }

      serviceCheckout
        .readAll(data)
        .then((response) => {
          const token_header = {
            "controller-token-": response.headers["controller-token-"],
            "requestray-token-": response.headers["requestray-token-"],
            "firewall-token-": response.headers["firewall-token-"],
            "cache-token-": response.headers["cache-token-"],
            "trans-token-": response.headers["trans-token-"],
          };
          var data = JSON.parse(response.data);
          this.name = (data.data.seller.company && data.data.seller.company.fantasy_name !== '') ? data.data.seller.company.fantasy_name : data.data.seller.name;
          this.$store.commit("UPDATE_TOKEN", token_header);
          return JSON.parse(response.data);
        })
        .then((response) => {
          if (this.countryGlobal !== "BR" &&
            response.data &&
            response.checkout_payment &&
            response.data.method &&
            response.data.method.indexOf("CREDIT_CARD") >= 0) {
            this.loadStripe();
          }

          if (response.data.type !== "SUBSCRIPTION") {
            let client_id;
            if (process.env.NODE_ENV !== "production") {
              if (this.countryGlobal !== "BR") {
                client_id = process.env.PAYPAL_CLIENT_ID_INTERNATIONAL;
              } else {
                client_id = process.env.PAYPAL_CLIENT_ID_NATIONAL;
              }
            } else {
              if (this.countryGlobal !== "BR") {
                client_id = process.env.PAYPAL_CLIENT_ID_INTERNATIONAL;
              } else {
                client_id = process.env.PAYPAL_CLIENT_ID_NATIONAL;
              }
            }

            // Verifica se o elemento com o ID "paypal_id" existe
            const paypalId = document.getElementById("paypal_id");
            if (paypalId) {
              // Se existir, remove o elemento
              paypalId.remove();
            }
            let script = document.createElement("script");
            script.id = "paypal_id";
            if (
              response.data &&
              response.checkout_payment &&
              response.data.method &&
              response.data.method.indexOf("PAYPAL") >= 0
            ) {
              if (response.checkout_payment.paypal) {
                script.src =
                  "https://www.paypal.com/sdk/js?client-id=" +
                  client_id +
                  `&currency=${response.checkout_payment.paypal.currency}&disable-funding=credit,card,mercadopago`;

                document.body.appendChild(script);

                // get paypal data
                this.paypal.amount = response.checkout_payment.paypal.amount;
                this.paypal.original_amount =
                  response.checkout_payment.paypal.amount;
                this.paypal.currency =
                  response.checkout_payment.paypal.currency;
                this.paypal.symbol_currency =
                  response.checkout_payment.paypal.symbol_currency;
              }
            }
          }

          this.checkoutPayment = response.checkout_payment;
          if (
            this.checkoutPayment &&
            this.checkoutPayment.data &&
            this.checkoutPayment.data.amount
          ) {
            response.data.amount = this.checkoutPayment.data.amount;
          }
          if (!this.$store.state.mounted) {
            this.mountedProduct(response.data, response.type);
            this.themeCheckout = response.custom_checkout;

            this.escassez = {
              scarcity: this.themeCheckout.scarcity,
              scarcity_background_color: this.themeCheckout
                .scarcity_background_color,
              scarcity_subtitle: this.themeCheckout.scarcity_subtitle,
              scarcity_time: this.themeCheckout.scarcity_time,
              scarcity_title: this.themeCheckout.scarcity_title,
            };

            if (this.themeCheckout.ob_custom) {
              this.custom_bump = {
                ob_description: this.themeCheckout.ob_description,
                ob_title: this.themeCheckout.ob_title,
                ob_subtitle: this.themeCheckout.ob_subtitle,
                ob_background_color: JSON.parse(
                  this.themeCheckout.ob_background_color
                ),
                ob_border: this.themeCheckout.ob_border,
                ob_border_px: this.themeCheckout.ob_border_px,
              };
            }

            if (this.themeCheckout.jivochat_id) {
              this.initJivoChat(this.themeCheckout.jivochat_id);
            }

            if (this.themeCheckout.zopim_id) {
              this.initZopimChat(this.themeCheckout.zopim_id);
            }

            if (
              this.themeCheckout.purchase_notification === "on" &&
              (this.product_type == "COMMON"
                ? this.product.status == "APPROVED"
                : this.product.product.status == "APPROVED")
            ) {
              this.notifications = response.purchase_notification;
              this.initNotifications();
            }

            if (this.business) {
              // setando itens
              this.themeCheckout.button_text = "Reservar agora";
              this.themeCheckout.trial_position = "bottom";
              this.themeCheckout.trial_info = "fixa";
            }

            this.themeCheckout.whatsapp_button =
              this.themeCheckout.whatsapp_button == "1" ? true : false;

            if (
              this.themeCheckout.whatsapp_button &&
              this.themeCheckout.whatsapp_number != null &&
              this.themeCheckout.whatsapp_number != ""
            ) {
              this.wpp_number = this.themeCheckout.whatsapp_number.substring(3);
              this.wpp_number = this.wpp_number.replace(".", "");
              this.wpp = true;
            }

            // set local variabel with currency conversion data
            this.rate = {
              target_currency: response.checkout_payment.data.to,
              base_currency: response.checkout_payment.data.from,
              token: response.checkout_payment.token,
            };

            this.confirmation_email =
              this.themeCheckout.confirmation_email === "on" ?? false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.removePreload(true);
        });
    },
    initNotifications() {
      let color = this.themeCheckout.theme_color;
      let background = this.themeCheckout.theme_color_bg;
      if (color === null) {
        color = "#00E4A0";
      }
      if (background === null || background === "rgba(0, 228, 160, 0.3)") {
        background = "rgb(232 252 246)";
      } else if (background === "rgba(33, 51, 210, 0.3)") {
        background = "#e9eafa";
      } else if (background === "rgba(255, 12, 55, 0.3)") {
        background = "#ffb8c4";
      } else if (background === "rgba(255, 203, 55, 0.3)") {
        background = "#ffefc6";
      } else if (background === "rgba(46, 215, 238, 0.3)") {
        background = "#c2f3f9";
      } else if (background === "rgba(93, 33, 210, 0.3)") {
        background = "#cebff1";
      } else if (background === "rgba(0, 9, 22, 0.3)") {
        background = "#b2b5b8";
      } else if (background === "rgba(52, 131, 250, 0.3)") {
        background = "#c2dafd";
      } else if (background === "rgba(0, 175, 123, 0.3)") {
        background = "#b8e7d8";
      }
      let css = `.b-toast-custom .toast-header strong {
        color: ${color};
        }
        .b-toast-custom .toast-header strong::before {
          content: "🔥";
          background: none;
          font-size: 22px;
          position: absolute;
          left: -36px;
        }
        .b-toast-custom .toast {
          background-color: ${background} !important;
          border-color: ${color} !important;
          color: ${color} !important;
        }
        .b-toast-custom .toast .toast-header {
          color: ${color} !important;
          background-color: ${background} !important;
          border: none !important;
        }
        .b-toast-custom.b-toast-solid .toast {
          background-color: ${color} !important;
        }`;
      let head = document.head || document.getElementsByTagName("head")[0];
      let style = document.createElement("style");
      head.appendChild(style);

      style.type = "text/css";

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }

      let array = this.notifications;

      for (let i = 0; i < array.length; i++) {
        const element = array[i];

        if (localStorage.getItem(`notification${element.id}`) === null) {
          localStorage.setItem(`notification${element.id}`, "true");
          let time =
            this.getRandomInt(
              this.themeCheckout.minimum_purchase_notification_interval,
              this.themeCheckout.maximum_purchase_notification_interval
            ) + "000";
          this.makeNotification(element.name, time);
          return;
        }
      }
    },
    calculateNotification() {
      let array = this.notifications;
      for (let i = 0; i < array.length; i++) {
        const element = array[i];
        if (localStorage.getItem(`notification${element.id}`) === null) {
          localStorage.setItem(`notification${element.id}`, "true");
          let time =
            this.getRandomInt(
              this.themeCheckout.minimum_purchase_notification_interval,
              this.themeCheckout.maximum_purchase_notification_interval
            ) + "000";
          this.makeNotification(element.name, time);
          return;
        }
      }
    },
    makeNotification(name, time) {
      var position = this.themeCheckout.type_purchase_notification;
      if (!position) {
        position = "b-toaster-bottom-right";
      }
      setTimeout(() => {
        this.$bvToast.toast(`${name} acabou de comprar!`, {
          title: `Nova venda realizada`,
          variant: "custom",
          toaster: position,
          autoHideDelay: 5000,
          appendToast: true,
        });
        this.calculateNotification();
      }, parseInt(time));
    },
    getRandomInt(min, max) {
      min = Math.ceil(5);
      max = Math.floor(10);
      return Math.floor(Math.random() * (max - min)) + min;
    },
    initJivoChat(id) {
      // J0jlVX87X9
      // script jivochat
      const jivoScript = document.createElement("script");
      jivoScript.setAttribute("src", `//code.jivosite.com/widget/${id}`);
      jivoScript.async = true;
      document.head.appendChild(jivoScript);
    },
    initZopimChat(id) {
      // 3d5dAUgCZbe2ecEjO0Zz1eIlAg9qTnQF
      const zopimScript = document.createElement("script");
      zopimScript.setAttribute("src", `https://v2.zopim.com/?${id}`);
      zopimScript.async = true;
      document.head.appendChild(zopimScript);
    },
    debounceSave() {
      if (this.debounce) {
        clearTimeout(this.debounce);
        this.debounce = null;
      }
      this.debounce = setTimeout(() => {
        this.saveDataUser();
        this.debounce = null;
      }, 1000 * 3);
    },
    fetchCapture(capture) {
      let data = {
        product_id: capture.product_id,
        uuid: capture.uuid,
      };

      serviceLead.search(data).then((r) => {
        this.capture = Object.keys(r).length ? r : capture;

        if (!this.data.isValidToken) {
          this.data.name = this.capture.name;
          this.data.email = this.capture.email;
          this.data.zipcode = this.capture.zip_code;
          this.data.street = this.capture.street;
          this.data.number = this.capture.number;
          this.data.neighborhood = this.capture.neighborhood;
          this.data.city = this.capture.city;
          this.data.state = this.capture.state;
          this.yourValue = this.capture.cellphone;
        }

        this.data.offer_hash = this.$route.params.hash;

        this.data.name = !this.data.name ? this.capture.name : this.data.name;
        this.data.email = !this.data.email
          ? this.capture.email
          : this.data.email;
        this.yourValue = !this.data.cellphone
          ? this.capture.cellphone
          : this.data.cellphone;
        this.data.zipcode = this.capture.zip_code;
        this.data.offer_hash = this.$route.params.hash;
        this.data.street = this.capture.street;
        this.data.number = this.capture.number;
        this.data.neighborhood = this.capture.neighborhood;
        this.data.city = this.capture.city;
        this.data.state = this.capture.state;

        if (
          this.data.zipcode &&
          this.is_produto_fisico &&
          this.data.has_shipping_fee
        ) {
          this.checkShippingFee(this.data.zipcode);
        }
      });
    },
    atualizaCapture(capture) {
      const data = capture;
      data.id = this.capture.uuid;
      data.product_id = this.capture.product_id;
      data.offer_hash = this.product.hash ? this.product.hash : this.$route.params.hash;
      if (data.id) serviceLead.update(data);
    },
    createCapture(capture) {
      let data = {
        product_id: capture.product_id,
        seller_id: capture.seller_id,
        offer_hash: this.product.hash ? this.product.hash : this.$route.params.hash,
        email: capture.email,
        name: capture.name,
        cellphone: capture.cellphone,
        cpf: capture.document,
        uuid: capture.uuid,
        step: capture.step,
      };
      serviceLead.create(data);
    },
    saveDataUser() {
      this.data.cellphone = this.results_tel.formattedNumber;

      this.capture.name = this.data.name;
      this.capture.cellphone = this.data.cellphone;
      this.capture.email = this.data.email;
      this.capture.document = this.data.document;
      this.capture.cpf = this.data.document;
      this.capture.zip_code = this.data.zipcode;
      this.capture.street = this.data.street;
      this.capture.number = this.data.number;
      this.capture.neighborhood = this.data.neighborhood;
      this.capture.city = this.data.city;
      this.capture.state = this.data.state;
      this.capture.complement = this.data.complement;

      if (this.is_produto_fisico) {
        this.capture.shipping_address_zip_code = this.shipping.address.zipcode;
        this.capture.shipping_address_street = this.shipping.address.street;
        this.capture.shipping_address_number = this.shipping.address.number;
        this.capture.shipping_address_neighborhood = this.shipping.address.neighborhood;
        this.capture.shipping_address_city = this.shipping.address.city;
        this.capture.shipping_address_state = this.shipping.address.state;
        this.capture.shipping_address_complement = this.shipping.address.complement;
      }

      this.capture.step = 0;
      if (this.capture.name && this.capture.cellphone && this.capture.email) {
        this.capture.step = 1;

        if (this.capture.zip_code && this.capture.street && this.capture.number &&
          this.capture.neighborhood && this.capture.city) {
          this.capture.step = 2;
        }
      }

      if (this.capture.email || this.capture.cellphone) {
        if (!this.data.isValidToken && this.capture.uuid) {
          this.atualizaCapture(this.capture);
        } else {
          localStorage.setItem(`${this.capture.product_id}_user_uuid`, this.uuid);
          this.capture.uuid = localStorage.getItem(
            `${this.capture.product_id}_user_uuid`
          );
          this.createCapture(this.capture);
        }
      }
      //valida os dados para o paypal
      this.validateForm();
    },
    // função validando formulario
    async validateAllForm() {
      let valid_pessoal = false;
      let valid_address = false;
      let valid_pay = false;
      let valid_document_es = !this.data.document;

      // validando primeira etapa
      valid_pessoal = await this.$validator.validateAll("pessoal");

      if (
        this.countryGlobal === "AR" ||
        this.countryGlobal === "MX" ||
        this.countryGlobal === "UY"
      ) {
        if (this.data.document)
          if (this.data.document.length === 0) {
            valid_document_es = false;
          } else valid_document_es = true;
      } else {
        valid_document_es = true;
      }

      this.valid_document_es = valid_document_es;

      // validando segunda etapa (se existir)
      if (this.etapa_total == 3) {
        valid_address = await this.$validator.validateAll("address");
      } else {
        valid_address = true;
      }

      // validando terceira etapa
      if (this.method === "CREDIT_CARD" || this.method === "TWO_CREDIT_CARDS") {
        valid_pay = await this.$validator.validateAll("pay");
      } else valid_pay = true;

      if (this.results_tel.isValid && this.results_tel.countryCode === "BR") {
        this.errorPhone = false;
      } else {
        if (this.results_tel.phoneNumber) {
          this.errorPhone = this.results_tel.countryCode === 'BR' && (this.results_tel.phoneNumber?.length == 14 || this.results_tel.phoneNumber?.length == 15)
            ? false
            : this.results_tel.countryCode !== 'BR' && this.results_tel.phoneNumber?.length > 0 ? false : true;
        } else {
          this.errorPhone = true;
        }
      }

      return (
        valid_pessoal &&
        valid_address &&
        valid_pay &&
        this.results_tel.isValid &&
        valid_document_es
      );
    },
    hasAddress() {
      this.possui_endereco = true;
      if (this.$i18n.locale == "pt") this.etapa_total = 3;
      else this.etapa_total = 2;
    },
    addBumpProduct(bump_item) {
      let divisaoValor = 0;
      const b_product_id = this.$route.query.b_id || this.$route.query.b_id_1

      const contem = [...this.products_list].findIndex((item) => {
        if (item.product_id == bump_item.id) {
          return true;
        }
      });

      if (contem > -1) {
        this.products_list.splice(contem, 1);

        if (this.product_type == "COMMON") {
          this.amount -= bump_item.amount;
          // this.original_amount -= bump_item.amount;
        } else {
          this.amount -= bump_item.amount;
          // this.original_amount -= bump_item.amount;
        }
      } else {
        if (this.b_offer && typeof b_product_id == "string") {
          this.products_list.push({
            product_id: bump_item.id,
            product_offer: this.b_offer,
          });
        } else {
          this.products_list.push({
            product_id: bump_item.id,
          });
        }

        if (this.product_type == "COMMON") {
          this.amount += bump_item.amount;
          // this.original_amount += bump_item.amount;
        } else {
          this.amount += bump_item.amount;
          // this.original_amount += bump_item.amount;
        }
      }

      divisaoValor = this.amount / 2;

      if (this.method == "TWO_CREDIT_CARDS") {
        this.data.cards[0].amount = `${this.filterCurrency(
          this.currency_id
        )} ${this.formatMoney(divisaoValor, $i18n.locale)}`;
        this.data.cards[1].amount = `${this.filterCurrency(
          this.currency_id
        )} ${this.formatMoney(divisaoValor, $i18n.locale)}`;
      }

      this.amount_cards = {
        card_1: divisaoValor,
        card_2: divisaoValor,
      };
    },
    handleResize() {
      this.client.width = window.innerWidth;
    },
    nextStep(step, scope) {
      this.submit = true;

      // this.data.email = this.data.email.trim();

      this.$validator.validateAll(scope).then((result) => {
        if (result) {

          if (this.results_tel.isValid === false) {
            return;
          }

          this.submit = false;
          if (step == "address") {
            if (this.$i18n.locale == "pt") {
              this.address_step = true;
              this.last_step = false;
            } else {
              this.last_step = true;
              this.address_step = false;
            }
          } else if (step == "pagamento") {
            this.last_step = true;
            this.address_step = false;
          }

          window.scrollTo({ top: 250, behavior: "smooth" });

          const etapas = document.querySelectorAll(".icon-etapa");
          etapas[this.etapa_atual - 1].classList.add("complete");
          etapas[this.etapa_atual].classList.add("target");
          this.etapa_atual++;
        }
      });
    },
    previous_step() {
      const cep = document.querySelector("#zipcode");
      this.submit = true;
      if (this.etapa_atual == 2) {
        this.address_step = false;
        this.last_step = false;
      } else if (this.etapa_atual == 3) {
        this.address_step = true;
        this.last_step = false;
        setTimeout(() => {
          if (cep) cep.focus();
        });
      }

      window.scrollTo({ top: 340, behavior: "smooth" });
      this.submit = false;

      const etapas = document.querySelectorAll(".icon-etapa");
      this.etapa_atual--;
      etapas[this.etapa_atual - 1].classList.remove("complete");
      etapas[this.etapa_atual - 1].classList.add("target");
      etapas[this.etapa_atual].classList.remove("target");
    },
    getImg(img) {
      return require(`@/assets/img/footer/${img}.svg`);
    },
    flipCard(status) {
      if (this.$refs.card) this.$refs.card.flipCard(status);
    },
    focusInput(e) {
      if (this.$refs.card) this.$refs.card.focusInput(e);
    },
    blurInput() {
      if (this.$refs.card) this.$refs.card.blurInput();
    },
    clickTab(metodo) {
      this.submit = false;
      this.sem_parcela = false;
      this.method_pix = false;
      const seller = this.normalizeString(
        this.product.seller.company
          ? this.product.seller.company.fantasy_name ||
          this.product.seller.company.name
          : this.product.seller.name
      );
      window.dataLayer?.push({
        event: "checkoutOption",
        eventCategory: `${seller}:enhanced-ecommerce`,
        eventAction: "checkout_option",
        eventLabel: "payment-method",
        ecommerce: {
          checkout_option: {
            actionField: {
              step: 1,
              option: `payment:${metodo.toLowerCase()}`,
            },
          },
        },
      });
      switch (metodo) {
        case "CREDIT_CARD":
          if (this.countryGlobal !== "BR") {
            this.mountStripeCard();
          } else {
            this.destroyStripeCard();
          }
          this.method = "CREDIT_CARD";
          this.sem_juros =
            this.product_type == "COMMON"
              ? this.product.no_interest_installments
              : this.product.product.no_interest_installments;
          break;
        case "BOLETO":
          this.method = "BOLETO";
          this.sem_juros = true;
          break;
        case "PAYPAL":
          this.method = "PAYPAL";
          this.sem_juros = false;
          break;
        case "SAFETYPAY-CASH":
          this.method = "SAFETYPAY-CASH";
          this.sem_juros = false;
          break;
        case "EFT":
          this.method = "EFT";
          this.sem_juros = false;
          break;
        case "BANKTRANSFER":
          this.method = "BANKTRANSFER";
          this.sem_juros = false;
          break;
        case "DEBITCARD":
          this.method = "DEBITCARD";
          this.sem_juros = false;
          break;
        case "EFECTY":
          this.method = "EFECTY";
          this.sem_juros = false;
          break;
        case "MULTICAJA":
          this.method = "MULTICAJA";
          this.sem_juros = false;
          break;
        case "SENCILLITO":
          this.method = "SENCILLITO";
          this.sem_juros = false;
          break;
        case "SERVIPAG":
          this.method = "SERVIPAG";
          this.sem_juros = false;
          break;
        case "PAGOSNET":
          this.method = "PAGOSNET";
          this.sem_juros = false;
          break;
        case "RAPIPAGO":
          this.method = "RAPIPAGO";
          this.sem_juros = false;
          break;
        case "PAGOFACIL":
          this.method = "PAGOFACIL";
          this.sem_juros = false;
          break;
        case "WEBPAY":
          this.method = "WEBPAY";
          this.sem_juros = false;
          break;
        case "OXXO":
          this.method = "OXXO";
          this.sem_juros = false;
          break;
        case "SPEI":
          this.method = "SPEI";
          this.sem_juros = false;
          break;
        case "PIX":
          this.method = "PIX";
          this.method_pix = true;
          this.sem_parcela = true;
          this.sem_juros = false;
          break;
      }
    },
    addCard1() {
      this.method = "CREDIT_CARD";
      if (this.data.cards.length > 1) {
        this.data.cards = [
          {
            amount: "",
            number: "",
            holder_name: "",
            valid: "",
            year: "",
            month: "",
            cvv: "",
          },
        ];
      }
    },
    addCard2() {
      this.method = "TWO_CREDIT_CARDS";
      this.data.cards.push({
        amount: "",
        number: "",
        holder_name: "",
        valid: "",
        year: "",
        month: "",
        cvv: "",
      });

      this.initValueTwoCards();
    },
    initValueTwoCards() {
      let divisaoValor = 0;
      if (this.installments > 1) {
        if (this.includeBump) {
          divisaoValor = (this.amount + this.bump.amount) / 2;
        } else {
          divisaoValor = (this.getInstallments() * this.installments) / 2;
        }
      } else {
        if (this.data.has_shipping_fee) {
          divisaoValor = (this.amount + this.shipping.amount) / 2;
        } else {
          divisaoValor = this.amount / 2;
        }
      }
      this.data.cards[0].amount = `${this.filterCurrency(
        this.currency_id
      )} ${this.formatMoney(divisaoValor, $i18n.locale)}`;
      this.data.cards[1].amount = `${this.filterCurrency(
        this.currency_id
      )} ${this.formatMoney(divisaoValor, $i18n.locale)}`;

      this.amount_cards = {
        card_1: this.amount / 2,
        card_2: this.amount / 2,
      };
    },
    changeParcelamentoCartao() {
      if (this.method == "TWO_CREDIT_CARDS") {
        this.initValueTwoCards();
      }
    },
    firstCard() {
      if (this.debounce) {
        clearTimeout(this.debounce);
        this.debounce = null;
      }
      this.debounce = setTimeout(() => {
        this.changeFirstCard();
        this.debounce = null;
      }, 1500);
    },
    changeFirstCard() {
      // limpando valor digitado
      const amountFix = +this.data.cards[0].amount
        .toString()
        .replace(",", ".")
        .replace("-", "")
        .split(" ")[1];

      // pegando amount com juros
      const amountJuros =
        this.getInstallments(this.installments) * this.installments;
      if (amountFix) {
        let amount = this.amount - amountFix;
        if (!isNaN(amount)) {
          // valor sem juros
          this.amount_cards = {
            card_1: this.amount - amount,
            card_2: amount,
          };

          // subtração de valor digitado - valorTotal
          const amountVariant = amountJuros - amountFix;

          // setando os valores nos campos
          this.data.cards[1].amount = `${this.filterCurrency(
            this.currency_id
          )} ${this.formatMoney(amountVariant, $i18n.locale)}`;
          this.data.cards[0].amount = `${this.filterCurrency(
            this.currency_id
          )} ${this.formatMoney(amountFix, $i18n.locale)}`;

          if (amountFix > amountJuros) {
            // setando os valores nos campos
            this.data.cards[0].amount = `${this.filterCurrency(
              this.currency_id
            )} ${this.formatMoney(amountJuros, $i18n.locale)}`;
            this.data.cards[1].amount = "";
          }
        } else {
          this.data.cards[0].amount = "";
        }
      } else {
        // setando os valores nos campos

        this.data.cards[1].amount = `${this.filterCurrency(
          this.currency_id
        )} ${this.formatMoney(amountJuros, $i18n.locale)}`;
        this.data.cards[0].amount = "";
      }
    },
    secoundCard() {
      if (this.debounce) {
        clearTimeout(this.debounce);
        this.debounce = null;
      }
      this.debounce = setTimeout(() => {
        this.changeSecoundCard();
        this.debounce = null;
      }, 1500);
    },
    changeSecoundCard() {
      // limpando valor digitado
      const amountFix = +this.data.cards[1].amount
        .toString()
        .replace(",", ".")
        .replace("-", "")
        .split(" ")[1];

      // pegando amount com juros
      const amountJuros =
        this.getInstallments(this.installments) * this.installments;
      if (amountFix) {
        let amount = this.amount - amountFix;
        if (!isNaN(amount)) {
          // valor sem juros
          this.amount_cards = {
            card_1: amount,
            card_2: this.amount - amount,
          };

          // subtração de valor digitado - valorTotal
          const amountVariant = amountJuros - amountFix;

          // setando os valores nos campos
          this.data.cards[0].amount = `${this.filterCurrency(
            this.currency_id
          )} ${this.formatMoney(amountVariant, $i18n.locale)}`;
          this.data.cards[1].amount = `${this.filterCurrency(
            this.currency_id
          )} ${this.formatMoney(amountFix, $i18n.locale)}`;

          if (amountFix > amountJuros) {
            // setando os valores nos campos
            this.data.cards[1].amount = `${this.filterCurrency(
              this.currency_id
            )} ${this.formatMoney(amountJuros, $i18n.locale)}`;
            this.data.cards[0].amount = "";
          }
        } else {
          this.data.cards[1].amount = "";
        }
      } else {
        // setando os valores nos campos
        this.data.cards[0].amount = `${this.filterCurrency(
          this.currency_id
        )} ${this.formatMoney(amountJuros, $i18n.locale)}`;
        this.data.cards[1].amount = "";
      }
    },
    convertAmount() {
      if (
        this.data.cards[0].amount
          .toString()
          .includes(`${this.filterCurrency(this.currency_id)} `)
      ) {
        this.data.cards[0].amount = +this.data.cards[0].amount
          .replace(`${this.filterCurrency(this.currency_id)} `, "")
          .replace(".", "")
          .replace(",", ".");
      }
      if (
        this.data.cards[1].amount
          .toString()
          .includes(`${this.filterCurrency(this.currency_id)}`)
      ) {
        this.data.cards[1].amount = +this.data.cards[1].amount
          .replace(`${this.filterCurrency(this.currency_id)} `, "")
          .replace(".", "")
          .replace(",", ".");
      }
    },
    checkAddressShipping() {
      return new Promise((resolve) => {
        if (this.is_produto_fisico) {
          if (this.data.billing_shipping_same_address) {
            this.shipping.address.zipcode = this.data.zipcode;
            this.shipping.address.street = this.data.street;
            this.shipping.address.neighborhood = this.data.neighborhood;
            this.shipping.address.city = this.data.city;
            this.shipping.address.state = this.data.state;
            this.shipping.address.number = this.data.number;
            this.shipping.address.complement = this.data.complement;
          }
          this.checkShippingFee(this.shipping.address.zipcode).then((resp) =>
            resolve(resp)
          );
        } else resolve(true);
      });
    },
    changeFrete(frete) {
      this.shipping.frete = frete;
      this.shipping.amount = +frete.price;
      this.shipping.old_amount = this.amount;
      this.shipping.service_name = frete.name;
      this.shipping.frete_anterior = +frete.price;
    },
    checkShippingFee(cep) {
      return new Promise((resolve) => {
        if (this.data.has_shipping_fee) {
          let product_id =
            this.product_type == "COMMON"
              ? this.product.id
              : this.product.product.id;

          let data = { shipping_address_zip_code: cep.replace(/[-]/g, "") };
          serviceShipping
            .create(data, `/calculate/${product_id}`)
            .then((response) => {
              this.options_shipping = response;
            })
            .catch(() => {
              this.$bvToast.toast(
                this.$t("Esse produto não possue integração para envio"),
                {
                  title: "Frete",
                  variant: "danger",
                  autoHideDelay: 5000,
                  appendToast: true,
                }
              );
            })
            .finally(() => {
              if (this.options_shipping.length) {
                this.options_shipping = [...this.options_shipping].filter(
                  (frete) => frete.price
                );

                this.options_shipping = [...this.options_shipping].sort(
                  (a, b) => {
                    return +a.price - +b.price;
                  }
                );

                // revalidando
                if (this.shipping.frete) {
                  const frete_selecionado = this.options_shipping.find(
                    (item) => item.id == this.shipping.service_id
                  );

                  if (+this.shipping.frete.price != +frete_selecionado.price) {
                    this.$bvToast.toast(this.$t("Erro no cálculo do frete"), {
                      title: "Frete",
                      variant: "danger",
                      autoHideDelay: 5000,
                      appendToast: true,
                    });

                    resolve(false);
                  } else resolve(true);
                } else {
                  this.shipping.service_id = this.options_shipping[0].id;
                  this.changeFrete(this.options_shipping[0]);
                  resolve(true);
                }
              } else resolve(true);
              this.loading_frete = false;
              if (this.method == "TWO_CREDIT_CARDS") this.initValueTwoCards();
            });
        } else resolve(true);
      });
    },
    setDisableStreetGroup(status) {
      document.querySelectorAll('[data-street-group]').forEach(element => {
        const value = this.data[element.id];

        if (status && value) {
          element.setAttribute('disabled', 'disabled');
          return;
        }

        element.removeAttribute('disabled');
      });
    },
    getCEP(type) {
      let cep = null;
      switch (type) {
        case "charge":
          cep = this.data.zipcode;
          break;
        case "shipping":
          cep = this.shipping.address.zipcode;
          break;
      }
      if (cep && cep.replace("-", "").length >= 8) {
        this.loading = true;
        this.shipping.frete = null;

        if (this.data.has_shipping_fee) {
          this.loading_frete = true;
        }

        this.setDisableStreetGroup(false);

        axios
          .get("https://viacep.com.br/ws/" + cep.replace("-", "") + "/json")
          .then((response) => {
            if (type == "charge") {
              this.data.number = "";
              this.data.street = response.data.logradouro;
              this.data.neighborhood = response.data.bairro;
              this.data.city = response.data.localidade;
              this.data.state = response.data.uf;

              document.querySelector("#number-address").focus();
            } else if (type == "shipping") {
              this.shipping.address.number = "";
              this.shipping.address.street = response.data.logradouro;
              this.shipping.address.neighborhood = response.data.bairro;
              this.shipping.address.city = response.data.localidade;
              this.shipping.address.state = response.data.uf;

              document.querySelector("#number-address-shipping").focus();
            }

            this.checkShippingFee(cep);
            this.setDisableStreetGroup(typeof response.data?.erro === 'undefined');
          })
          .catch(() => {
            this.setDisableStreetGroup(false);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    getInstallments(n = this.installments, valor = 0, is_bump = false) {
      let amount = this.original_amount_sem_frete || this.product.amount;
      if (n == 1)
        return !this.is_produto_fisico
          ? valor || amount
          : (valor || amount) + this.shipping.amount;

      let retorno = 0;
      let pv = valor || amount; // product amount

      if (this.is_produto_fisico) pv += this.shipping.amount;
      if (
        is_bump &&
        this.bump.type === "TRANSACTION" &&
        this.product.type === "TRANSACTION"
      ) {
        if (this.bump.no_interest_installments) {
          retorno = pv / n;
        } else {
          let i = this.monthly_interest / 100; // tax per month
          retorno = pv / ((Math.pow(1 + i, n) - 1) / (Math.pow(1 + i, n) * i));
        }
      } else {
        if (
          (this.sem_juros || this.monthly_interest === 0) &&
          (this.method == "CREDIT_CARD" ||
            this.method == "TWO_CREDIT_CARDS" ||
            this.method == "BOLETO")
        ) {
          retorno = pv / n;
        } else {
          let i = this.monthly_interest / 100; // tax per month
          retorno = pv / ((Math.pow(1 + i, n) - 1) / (Math.pow(1 + i, n) * i));
        }
      }
      return retorno;
    },

    async getParamsSetValue() {

      let currentUrl = window.location.href;

      let parametersObj = {};

      if (currentUrl.includes('?')) {
        let parametersString = currentUrl.split('?')[1];

        let params = new URLSearchParams(parametersString);

        for (const [key, value] of params) {
          parametersObj[key] = value;
        }
      }

      this.metas = parametersObj;

    },
    async onSubmit(check = false) {

      try {
        this.loading = true;
        this.submit = true;

        this.getParamsSetValue();

        this.country_code = this.countryGlobal;
        if (!this.countryGlobal) this.country_code = "BR";

        // atualizando com o step click
        this.capture.step = 3;
        this.atualizaCapture(this.capture);

        // this.country_code
        if (await this.validateAllForm()) {
          this.data.cellphone = this.results_tel.formattedNumber;
          this.preload = true;
          this.data.country_code = this.country_code;
          if (check !== "check") {
            try {
              this.$refs.Captcha.setCaptcha();
              this.captchaTimeout = setTimeout(() => {
                this.$refs.Captcha.resetCaptcha();
                this.captcha = 'error';
                this.onSubmit('check')
              }, 10000)
              return;
            } catch (e) {
              console.log(e);
            }
          } else {
            clearTimeout(this.captchaTimeout);
          }

          if (!(await this.checkAddressShipping())) {
            this.preload = false;
            this.loading = false;
            this.submit = false;
            return;
          }

          if (
            this.method == "CREDIT_CARD" ||
            this.method == "TWO_CREDIT_CARDS" ||
            this.method == "DEBITCARD"
          ) {
            let cards = [];

            if (this.method == "TWO_CREDIT_CARDS") {
              // this.initValueTwoCards();
            }

            if (this.gateway != 'stripe') {
              for (let i = 0; i < this.data.cards.length; i++) {
                if (
                  this.data.cards[i].number &&
                  this.data.cards[i].holder_name &&
                  this.data.cards[i].month &&
                  this.data.cards[i].year &&
                  this.data.cards[i].cvv
                ) {
                  var card = {
                    card_number: this.data.cards[i].number,
                    card_holder_name: this.data.cards[i].holder_name,
                    card_expiration_date:
                      String(this.data.cards[i].month) +
                      String(this.data.cards[i].year),
                    card_cvv: this.data.cards[i].cvv,
                  };

                  var cardValidations = pagarme.validate({ card: card });

                  // Check if the card number is valid
                  if (!cardValidations.card.card_number) {
                    this.card_number_error = true;
                    this.preload = false;
                    this.loading = false;
                    return;
                  }

                  if (this.method == "TWO_CREDIT_CARDS") {
                    this.convertAmount();
                  }

                  if (this.data.cards[i].amount) {
                    card.amount = parseFloat(
                      String(this.data.cards[i].amount)
                        .replace(this.filterCurrency(this.currency_id) + " ", "")
                        .replace(",", ".")
                    );
                  } else {
                    card.amount = this.amount;
                  }

                  if (this.method == "CREDIT_CARD" || this.method == "DEBITCARD") {
                    card.amount = this.amount;
                  }

                  cards.push(card);
                }
              }

              if (this.method == "TWO_CREDIT_CARDS") {
                const amountFix = +this.data.cards[0].amount
                  .toString()
                  .replace(",", ".")
                  .replace("-", "")
                  .split(" ")[1];

                if (amountFix) {
                  let amount = this.amount - amountFix;
                  if (!isNaN(amount)) {
                    // valor sem juros
                    this.amount_cards = {
                      card_1: this.amount - amount,
                      card_2: amount,
                    };
                  }
                }
                cards[0].amount = this.amount_cards.card_1;
                cards[1].amount = this.amount_cards.card_2;
              }
            }
            // Create Stripe's Payment Method
            else {
              let stripePaymentMethod = await this.createStripePaymentMethod();

              if (stripePaymentMethod) {
                const { exp_month, exp_year, last4 } = stripePaymentMethod.card;

                cards = [];
                cards.push({
                  stripe_card: stripePaymentMethod,
                  card_expiration_date: `${String(exp_month).padStart(2, '0')}${exp_year}`,
                  card_last_digits: last4,
                  amount: this.amount,
                });
              } else {
                this.preload = false;
                this.loading = false;
                return;
              }
            }

            // Success, so send the data to the server in order
            // to make the transaction
            var response;

            if (this.product_type == "COMMON") {
              try {
                let bump_id;

                if (
                  this.data.bump &&
                  this.product.type == "TRANSACTION" &&
                  this.bump.type == "TRANSACTION"
                ) {
                  bump_id = this.bump.id;
                } else {
                  bump_id = null;
                }

                response = await this.purchaseCreditCard(
                  this.product.amount,
                  this.product_type,
                  this.installments,
                  this.product.id,
                  null,
                  cards,
                  bump_id
                );

              } catch (e) {
                this.paymentError(e.response);

                if (
                  this.method == "TWO_CREDIT_CARDS" &&
                  this.data.cards.length === 2
                ) {
                  this.data.cards[0].amount = `${filterCurrency(this.currency_id)} ${this.formatMoney(
                    this.data.cards[0].amount, $i18n.locale
                  )}`;
                  this.data.cards[1].amount = `${filterCurrency(this.currency_id)} ${this.formatMoney(
                    this.data.cards[1].amount, $i18n.locale
                  )}`;
                }
                this.preload = false;
                this.loading = false;
                return;
              }
            } else {
              try {
                let bump_id;
                if (
                  this.data.bump &&
                  this.product.product.type == "TRANSACTION" &&
                  this.bump.type == "TRANSACTION"
                ) {
                  bump_id = this.bump.id;
                } else {
                  bump_id = null;
                }

                response = await this.purchaseCreditCard(
                  this.product.amount,
                  this.product_type,
                  this.installments,
                  this.product.product.id,
                  this.product.id,
                  cards,
                  bump_id
                );
              } catch (e) {
                this.paymentError(e.response);

                if (
                  this.method == "TWO_CREDIT_CARDS" &&
                  this.data.cards.length === 2
                ) {
                  this.data.cards[0].amount = `${filterCurrency(this.currency_id)} ${this.formatMoney(
                    this.data.cards[0].amount, $i18n.locale
                  )}`;
                  this.data.cards[1].amount = `${filterCurrency(this.currency_id)} ${this.formatMoney(
                    this.data.cards[1].amount, $i18n.locale
                  )}`;
                }
                this.preload = false;
                this.loading = false;
                return;
              }
            }
            if (response.sales != undefined) {
              if (response.sales.length) {
                this.preload = false;
                this.loading = false;
                if (
                  (response.sales[0].success && !response.sales[0].code) ||
                  response.sales[0].status == "delayed"
                ) {
                  let product_id =
                    this.product_type == "COMMON"
                      ? this.product.id
                      : this.product.product.id;
                  Cookies.remove("affiliate_" + product_id);

                  let query = {
                    s_id:
                      response.sales[0].status == "delayed"
                        ? "delayed"
                        : response.sales[0].sale_id, // id da venda
                  };

                  if (response.sales[0].token) {
                    query.token = response.sales[0].token;
                  }

                  query = Object.assign(this.$route.query, query);

                  this.getParamsSetValue();

                  this.formatPageThankYou(response.sales);

                  let chc = "";
                  if (
                    response.sales &&
                    response.sales.length &&
                    response.sales[0].chc
                  ) {
                    chc = "?chc=" + response.sales[0].chc;
                  }
                  //aqui
                  const seller = this.normalizeString(
                    this.product.seller.company
                      ? this.product.seller.company.fantasy_name ||
                      this.product.seller.company.name
                      : this.product.seller.name
                  );
                  const product_name = this.normalizeString(this.product.name);

                  const items = [
                    {
                      item_name: product_name,
                      item_id: this.product.id,
                      price: this.product.amount,
                      item_brand: seller,
                    },
                  ];
                  if (this.bump && this.bump.checkbox) {
                    const bump_name = this.normalizeString(this.bump.name);
                    items.push({
                      item_name: bump_name,
                      item_id: this.bump.id,
                      price: this.bump.amount,
                      item_brand: seller,
                    });
                  }

                  window.dataLayer?.push({
                    event: "purchase",
                    ecommerce: {
                      transaction_id: response.sales[0].sale_id,
                      affiliation: this.affiliate_id,
                      value: this.totalToPay,
                      currency: this.filterCurrency(),
                      items,
                      customer: {
                        email: this.data.email,
                        phone: this.data.cellphone,
                      },
                      payment: {
                        opcao_de_pagamento: this.method,
                        parcelamento: this.installments,
                        tipo_cobranca: response.sales[0].is_smart_sale ? 'venda_inteligente' : 'sem_venda_inteligente'
                      }
                    },
                  });
                  let valor = this.getInstallments(this.installments);
                  let params_multiple = {
                    id_product: product_id,
                    name_product: this.product.name,
                    valor: valor,
                    type: this.product_type,
                    parcelas:
                      response.sales[0].installments || this.installments,
                    trial:
                      this.product_type == "COMMON"
                        ? this.product.trial
                        : this.product.product.trial,
                    thank_you_page:
                      response.sales[0].product.custom_thank_you_page ||
                      this.page_thanks_response,
                    isCheckout: true,
                    methodCheckout: "CREDIT_CARD",
                    dados_response: response,
                    currency_symbol: this.filterCurrency()
                  };

                  let pixelData = {
                    ...this.data,
                    ip_address: this.ip_address,
                    external_id: this.product.seller.id
                  };

                  localStorage.setItem('pixelData', JSON.stringify(pixelData));

                  await this.$router.push({
                    path: `/${params_multiple.id_product}/obrigado` + chc,
                    query: { ...query, params_multiple },
                  });
                } else {
                  this.paymentError(response.sales[0]);
                }
              } else if (response.reason) {
                this.resetTokens();
              } else {
                this.paymentError(response);
              }
            } else this.paymentError(response);
          } else if (this.method == "PIX" || this.method_pix) {
            let product_id, amount, proposal_id, bump_amount, bump_product_id;
            amount = this.product.amount;

            if (this.product_type == "COMMON") {
              product_id = this.product.id;
            } else if (this.product_type == "PROPOSAL") {
              product_id = this.product.product.id;
              proposal_id = this.product.id;
            }

            if (this.data.bump) {
              bump_amount = this.bump.amount;
              bump_product_id = this.bump.id;
            }

            try {
              let response = await this.buildPix(
                this.product_type,
                product_id,
                amount,
                proposal_id,
                bump_product_id,
                bump_amount
              );

              if (response.sales.length) {
                // if (response.success) {
                this.preload = false;
                this.loading = false;

                if (
                  (response.sales[0].success && !response.sales[0].code) ||
                  response.sales[0].status == "delayed"
                ) {
                  Cookies.remove("affiliate");

                  let query = {
                    s_id:
                      response.sales[0].status == "delayed"
                        ? "delayed"
                        : response.sales[0].sale_id, // id da venda
                  };
                  if (response.sales[0].token) {
                    query.token = response.sales[0].token;
                  }

                  query = Object.assign(this.$route.query, query);
                  this.formatPageThankYou(response.sales);

                  let chc = "";
                  if (
                    response.sales &&
                    response.sales.length &&
                    response.sales[0].chc
                  ) {
                    chc = "?chc=" + response.sales[0].chc;
                  }

                  let params_multiple = {};
                  if (response.sales.length === 1) {
                    params_multiple = {
                      id_product: this.product.id,
                      qrcode: response.sales[0].qrcode,
                      valor: this.amount,
                      name_product: this.product.name,
                      thank_you_page:
                        response.sales[0].product.custom_thank_you_page ||
                        this.page_thanks_response,
                      isCheckout: true,
                      methodCheckout: "PIX",
                      dados_response: response,
                    };
                  } else {
                    params_multiple = {
                      id_product: this.product.id,
                      qrcode: response.order.qrcode,
                      valor: this.amount,
                      name_product: this.product.name,
                      thank_you_page:
                        response.sales[0].product.custom_thank_you_page ||
                        this.page_thanks_response,
                      isCheckout: true,
                      methodCheckout: "PIX",
                      dados_response: response,
                    };
                  }
                  const seller = this.normalizeString(
                    this.product.seller.company
                      ? this.product.seller.company.fantasy_name ||
                      this.product.seller.company.name
                      : this.product.seller.name
                  );
                  const product_name = this.normalizeString(this.product.name);

                  const items = [
                    {
                      item_name: product_name,
                      item_id: this.product.id,
                      price: this.product.amount,
                      item_brand: seller,
                    },
                  ];

                  if (this.bump && this.bump.checkbox) {
                    const bump_name = this.normalizeString(this.bump.name);
                    items.push({
                      item_name: bump_name,
                      item_id: this.bump.id,
                      price: this.bump.amount,
                      item_brand: seller,
                    });
                  }

                  window.dataLayer?.push({
                    event: "purchase",
                    ecommerce: {
                      transaction_id: response.sales[0].sale_id,
                      affiliation: this.affiliate_id,
                      value: this.totalToPay,
                      currency: this.filterCurrency(),
                      items,
                      customer: {
                        email: this.data.email,
                        phone: this.data.cellphone,
                      },
                      payment: {
                        opcao_de_pagamento: this.method,
                        parcelamento: this.installments,
                        tipo_cobranca: response.sales[0].is_smart_sale ? 'venda_inteligente' : 'sem_venda_inteligente'
                      }
                    },
                  });

                  let pixelData = {
                    ...this.data,
                    ip_address: this.ip_address,
                    external_id: this.product.seller.id
                  };

                  localStorage.setItem('pixelData', JSON.stringify(pixelData));

                  await this.$router.push({
                    path: `/${params_multiple.id_product}/obrigado` + chc,
                    query: query,
                    params: params_multiple,
                  });
                } else {
                  this.paymentError(response.sales[0]);
                }
              } else if (response.reason) {
                this.resetTokens();
              } else {
                this.paymentError(response);
              }
            } catch (err) {
              console.log(err);
              this.submit = false;
              this.preload = false;
              this.loading = false;
              this.paymentError("GENERIC");
            }
          } else {
            let product_id, amount, proposal_id, bump_amount, bump_product_id;
            amount = this.product.amount;

            if (this.product_type == "COMMON") {
              product_id = this.product.id;
            } else if (this.product_type == "PROPOSAL") {
              product_id = this.product.product.id;
              proposal_id = this.product.id;
            }

            if (this.data.bump) {
              bump_amount = this.bump.amount;
              bump_product_id = this.bump.id;
            }

            try {
              let response = await this.buildTicket(
                this.product_type,
                product_id,
                amount,
                proposal_id,
                bump_product_id,
                bump_amount
              );

              if (response.sales.length) {
                // if (response.success) {
                this.preload = false;
                this.loading = false;
                if (
                  (response.sales[0].success && !response.sales[0].code) ||
                  response.sales[0].status == "delayed"
                ) {
                  Cookies.remove("affiliate_" + product_id);
                  let query = {
                    s_id:
                      response.sales[0].status == "delayed"
                        ? "delayed"
                        : response.sales[0].sale_id, // id da venda
                  };

                  if (response.sales[0].token) {
                    query.token = response.sales[0].token;
                  }

                  query = Object.assign(this.$route.query, query);

                  this.formatPageThankYou(response.sales);

                  let chc = "";
                  if (
                    response.sales &&
                    response.sales.length &&
                    response.sales[0].chc
                  ) {
                    chc = "?chc=" + response.sales[0].chc;
                  }

                  let params_multiple = {};
                  if (response.sales.length >= 1) {
                    params_multiple = {
                      id_product: this.product.id,
                      name_product: this.product.name,
                      valor: this.getInstallments(this.installments_boleto),
                      parcelas: this.installments_boleto,
                      type: this.product_type,
                      trial:
                        this.product_type == "COMMON"
                          ? this.product.trial
                          : this.product.product.trial,
                      thank_you_page:
                        response.sales[0].product.custom_thank_you_page ||
                        this.page_thanks_response,
                      isCheckout: true,
                      methodCheckout: "BOLETO",
                      // response
                      dados_response: response,
                      boleto_url: response.sales[0].boleto_url,
                      boleto_barcode: response.sales[0].boleto_barcode,
                    };
                  } else {
                    params_multiple = {
                      id_product: this.product.id,
                      name_product: this.product.name,
                      valor: this.getInstallments(this.installments_boleto),
                      parcelas: this.installments_boleto,
                      type: this.product_type,
                      trial:
                        this.product_type == "COMMON"
                          ? this.product.trial
                          : this.product.product.trial,
                      thank_you_page:
                        response.sales[0].product.custom_thank_you_page ||
                        this.page_thanks_response,
                      isCheckout: true,
                      methodCheckout: "BOLETO",
                      // response
                      dados_response: response,
                      boleto_url: response.order.boleto_url,
                      boleto_barcode: response.order.boleto_barcode,
                    };
                  }
                  const seller = this.normalizeString(
                    this.product.seller.company
                      ? this.product.seller.company.fantasy_name ||
                      this.product.seller.company.name
                      : this.product.seller.name
                  );
                  const product_name = this.normalizeString(this.product.name);

                  const items = [
                    {
                      item_name: product_name,
                      item_id: this.product.id,
                      price: this.product.amount,
                      item_brand: seller,
                    },
                  ];

                  if (this.bump && this.bump.checkbox) {
                    const bump_name = this.normalizeString(this.bump.name);
                    items.push({
                      item_name: bump_name,
                      item_id: this.bump.id,
                      price: this.bump.amount,
                      item_brand: seller,
                    });
                  }

                  window.dataLayer?.push({
                    event: "purchase",
                    ecommerce: {
                      transaction_id: response.sales[0].sale_id,
                      affiliation: this.affiliate_id,
                      value: this.totalToPay,
                      currency: this.filterCurrency(),
                      items,
                      customer: {
                        email: this.data.email,
                        phone: this.data.cellphone,
                      },
                      payment: {
                        opcao_de_pagamento: this.method,
                        parcelamento: this.installments,
                        tipo_cobranca: response.sales[0].is_smart_sale ? 'venda_inteligente' : 'sem_venda_inteligente'
                      }
                    },
                  });

                  let pixelData = {
                    ...this.data,
                    ip_address: this.ip_address,
                    external_id: this.product.seller.id
                  };

                  localStorage.setItem('pixelData', JSON.stringify(pixelData));

                  await this.$router.push({
                    path: `/${params_multiple.id_product}/obrigado` + chc,
                    query: query,
                    params: params_multiple,
                  });
                } else {
                  this.paymentError(response.sales[0]);
                }
              } else if (response.reason) {
                this.resetTokens();
              } else {
                this.paymentError(response).sales;
              }
            } catch (err) {
              console.log(err);
              this.submit = false;
              this.preload = false;
              this.loading = false;
              this.paymentError("GENERIC");
            }
          }
        } else {
          if (this.isMobile) {
            const dados_card = document.querySelector("#dados-card");

            if (dados_card) {
              const top = dados_card.parentElement.offsetTop + 100;
              window.scrollTo({ top: top, behavior: "smooth" });
            }
          }
          this.$bvToast.toast(
            this.$t("checkout.feedbacks.dados_obrigatorios.text"),
            {
              title: this.$t("checkout.feedbacks.dados_obrigatorios.title"),
              variant: "danger",
              autoHideDelay: 5000,
              appendToast: true,
            }
          );

          this.loading = false;
        }
        this.loading = false;
        this.preload = false;
      } catch (e) {
        console.log(e)
        this.loading = false;
        this.preload = false;
      }
    },
    paymentError(response) {
      this.has_code = false;
      if (response.status == "error") {
        switch (response.code) {
          case "0001": {
            if (this.$i18n.locale === "pt") {
              this.error_message =
                "Este cupom que está utilizando não é mais válido.";
            } else if (this.$i18n.locale === "es") {
              this.error_message =
                "Este cupón que está utilizando ya no es válido.";
            } else {
              this.error_message =
                "This coupon you are using is no longer valid.";
            }
            this.resetCheckout("CARD");
            break;
          }
          case "BANK": {
            if (this.$i18n.locale === "pt") {
              this.error_message =
                "Algo deu errado com sua compra, por favor, entre em contato com o banco ou emissor do seu cartão.";
            } else if (this.$i18n.locale === "es") {
              this.error_message =
                "Algo salió mal con su compra, comuníquese con su banco o emisor de la tarjeta.";
            } else {
              this.error_message =
                "Something went wrong with your purchase, please contact your bank or card issuer.";
            }
            this.resetCheckout("ALL");
            break;
          }
          case "BLACKLIST_PURCHASE": {
            this.has_code = true;
            if (this.$i18n.locale === "pt") {
              this.error_message = `Após inúmeras tentativas de pagamento o banco retornou que seu cartão foi bloqueado, entre em contato com sua operadora de cartão solicitando o desbloqueio e caso já tenha feito, nos avise em <a href="https://www.voompcreators.com.br" target="_blank">www.voompcreators.com.br</a> para liberarmos aqui.`;
            } else if (this.$i18n.locale === "es") {
              this.error_message = `Después de numerosos intentos de pago, el banco devolvió que su tarjeta estaba bloqueada, comuníquese con el operador de su tarjeta para solicitar el desbloqueo y, si ya lo hizo, infórmenos en <a href="https://www.voompcreators.com.br" target ="_blank">www.voompcreators.com.br</a> para publicar aquí.`;
            } else {
              this.error_message = `After numerous payment attempts, the bank returned that your card was blocked, contact your card operator asking to unblock it and if you have already done so, let us know at <a href="https://www.voompcreators.com.br" target ="_blank">www.voompcreators.com.br</a> to release here.`;
            }
            this.resetCheckout("ALL");
            break;
          }
          case "INVALID_CVV": {
            if (this.$i18n.locale === "pt") {
              this.error_message =
                "Código de segurança do cartão inválido, verifique e tente novamente";
            } else if (this.$i18n.locale === "es") {
              this.error_message =
                "Código de seguridad de la tarjeta no válido, verifíquelo e inténtelo de nuevo";
            } else {
              this.error_message =
                "Invalid card security code, please check and try again";
            }
            this.resetCheckout("CVV");
            break;
          }
          case "INVALID_CLIENT_DATA": {
            if (this.$i18n.locale === "pt") {
              this.error_message =
                "Dados do cliente consta incorretos, verifique e tente novamente";
            } else if (this.$i18n.locale === "es") {
              this.error_message =
                "Los datos del cliente son incorrectos, verifíquelo e inténtelo de nuevo";
            } else {
              this.error_message =
                "Customer data is incorrect, please check and try again";
            }
            this.resetCheckout("ALL");
            break;
          }
          case "DUPLICATE_PURCHASE": {
            if (this.$i18n.locale === "pt") {
              this.error_message = "Você já efetuou uma compra deste produto";
            } else if (this.$i18n.locale === "es") {
              this.error_message = "Ya has comprado este producto";
            } else {
              this.error_message = "You have already purchased this product";
            }
            this.resetCheckout("ALL");
            break;
          }
          case "PRODUCT_OUT_OF_STOCK": {
            if (this.$i18n.locale === "pt") {
              this.error_message =
                "Produto sem estoque. Não foi possível efetivar a compra.";
            } else if (this.$i18n.locale === "es") {
              this.error_message =
                "Producto agotado. No se puede completar la compra.";
            } else {
              this.error_message =
                "Product out of stock. Unable to complete the purchase.";
            }
            this.resetCheckout("ALL");
            break;
          }
          case "CREDIT_CARD_OPERATOR": {
            if (this.$i18n.locale === "pt") {
              this.error_message =
                "Algo deu errado com sua compra, por favor, entre em contato com a operadora do seu cartão.";
            } else if (this.$i18n.locale === "es") {
              this.error_message =
                "Algo salió mal con su compra, comuníquese con la compañía de su tarjeta.";
            } else {
              this.error_message =
                "Something went wrong with your purchase, please contact your card company.";
            }
            this.resetCheckout("ALL");
            break;
          }
          case "INVALID_DATA": {
            if (this.$i18n.locale === "pt") {
              this.error_message =
                "Os dados do seu cartão foram inseridos incorretamente, verifique e tente novamente.";
            } else if (this.$i18n.locale === "es") {
              this.error_message =
                "Los datos de su tarjeta se ingresaron incorrectamente, verifique e intente nuevamente.";
            } else {
              this.error_message =
                "Your card details were entered incorrectly, please check and try again.";
            }
            this.resetCheckout("CARD");
            break;
          }
          case "INVALID_CREDIT_CARD": {
            if (this.$i18n.locale === "pt") {
              this.error_message =
                "O cartão usado está desabilitado, bloqueado ou está vencido, entre em contato com o banco ou emissor do cartão.";
            } else if (this.$i18n.locale === "es") {
              this.error_message =
                "La tarjeta utilizada está deshabilitada, bloqueada o vencida, comuníquese con su banco o emisor de la tarjeta.";
            } else {
              this.error_message =
                "The card used is disabled, blocked or expired, contact your bank or card issuer.";
            }
            this.resetCheckout("ALL");
            break;
          }
          case "INSUFFICIENT_FUNDS": {
            if (this.$i18n.locale === "pt") {
              this.error_message =
                "Não há limite suficiente, Tente com outro cartão ou método de pagamento.";
            } else if (this.$i18n.locale === "es") {
              this.error_message =
                "No hay suficiente límite, prueba con otra tarjeta o método de pago.";
            } else {
              this.error_message =
                "There is not enough limit, Try with another card or payment method.";
            }
            this.resetCheckout("CARD");
            break;
          }
          case "INVALID_PAYMENT_TYPE": {
            if (this.$i18n.locale === "pt") {
              this.error_message =
                "Método de pagamento inválido, tente com outro cartão ou método de pagamento.";
            } else if (this.$i18n.locale === "es") {
              this.error_message =
                "Método de pago no válido, intente con otra tarjeta o método de pago.";
            } else {
              this.error_message =
                "Invalid payment method, please try another card or payment method.";
            }
            this.resetCheckout("ALL");
            break;
          }
          case "INVALID_INSTALLMENTS": {
            if (this.$i18n.locale === "pt") {
              this.error_message =
                "Número ou valor das parcelas não foi autorizado, tente com outro cartão ou método de pagamento.";
            } else if (this.$i18n.locale === "es") {
              this.error_message =
                "Número o valor de cuotas no autorizadas, prueba con otra tarjeta o forma de pago.";
            } else {
              this.error_message =
                "Number or value of installments not authorized, try with another card or payment method.";
            }
            this.resetCheckout("CARD");
            break;
          }
          case "CURRENCY_NOT_SUPPORTED": {
            if (this.$i18n.locale === "pt") {
              this.error_message = "Moeda não suportada.";
            } else if (this.$i18n.locale === "es") {
              this.error_message = "Moneda no admitida.";
            } else {
              this.error_message = "Currency not supported.";
            }
            this.resetCheckout("CARD");
            break;
          }
          case "SUSPECTED_FRAUD": {
            if (this.$i18n.locale === "pt") {
              this.error_message =
                "Transação não permitida - Entre em contato com o banco ou tente outra forma de pagamento";
            } else if (this.$i18n.locale === "es") {
              this.error_message =
                "Transacción no permitida: comuníquese con su banco o pruebe con otro método de pago";
            } else {
              this.error_message =
                "Transaction not allowed - Contact your bank or try another payment method";
            }
            this.resetCheckout("ALL");
            break;
          }
          case "CANNOT_COMBINE_CURRENCIES_CUSTOMER": {
            this.error_message = this.$t('checkout.pagamento.feedbacks.' + response.code.toLowerCase());
            this.has_code = true;
            this.resetCheckout("ALL");
            break;
          }
          case "CARD_NOT_SUPPORTED_FOR_CURRENCY": {
            this.error_message = this.$t('checkout.pagamento.feedbacks.' + response.code.toLowerCase());
            this.has_code = true;
            this.resetCheckout("ALL");
            break;
          }
          case "CARD_DECLINED": {
            this.error_message = this.$t('checkout.pagamento.feedbacks.' + response.code.toLowerCase());
            this.has_code = true;
            this.resetCheckout("ALL");
            break;
          }
          case "GENERIC": {
            if (this.$i18n.locale === "pt") {
              this.error_message =
                "Ocorreu um erro durante o processamento da compra, verifique os dados e tente novamente, em caso de falhas, faça contato conosco para maiores orientações.";
            } else if (this.$i18n.locale === "es") {
              this.error_message =
                "Ocurrió un error al procesar la compra, verifique los datos e intente nuevamente, en caso de fallas, contáctenos para obtener más orientación.";
            } else {
              this.error_message =
                "An error occurred while processing the purchase, please check the data and try again, in case of failures, please contact us for further guidance.";
            }
            this.resetCheckout("ALL");
            break;
          }
          case "EXPIRED_RATE_TOKEN": {
            if (this.$i18n.locale === "pt") {
              this.error_message = "Erro na compra, tente novamente.";
            } else if (this.$i18n.locale === "es") {
              this.error_message = "Error de compra, inténtalo de nuevo.";
            } else {
              this.error_message = "Purchase error, please try again.";
            }
            break;
          }
          default: {
            if (this.$i18n.locale === "pt") {
              this.error_message =
                "Ocorreu um erro durante o processamento da compra, verifique os dados e tente novamente, em caso de falhas, faça contato conosco para maiores orientações.";
            } else if (this.$i18n.locale === "es") {
              this.error_message =
                "Ocurrió un error al procesar la compra, verifique los datos e intente nuevamente, en caso de fallas, contáctenos para obtener más orientación.";
            } else {
              this.error_message =
                "An error occurred while processing the purchase, please check the data and try again, in case of failures, please contact us for further guidance.";
            }
            break;
          }
        }
        // this.charge_error = true;
      } else {
        if (response.shipping) {
          this.error_message = response.shipping[0];
        } else if (response.email) {
          if (this.$i18n.locale === "pt") {
            this.error_message =
              "O campo email não contém um endereço de email válido.";
          } else if (this.$i18n.locale === "es") {
            this.error_message =
              "El campo de correo electrónico no contiene una dirección de correo electrónico válida.";
          } else {
            this.error_message =
              "The email field does not contain a valid email address.";
          }
        } else if (response.product) {
          this.error_message = response.product[0];
        } else {
          if (this.$i18n.locale === "pt") {
            this.error_message =
              "Ocorreu um erro durante o processamento da compra, tente novamente mais tarde.";
          } else if (this.$i18n.locale === "es") {
            this.error_message =
              "Ocurrió un error al procesar la compra, inténtalo de nuevo más tarde.";
          } else {
            this.error_message =
              "An error occurred while processing the purchase, please try again later.";
          }
        }
      }

      // notificação
      this.$bvModal.show("alert-modal");

      this.resetTokens();
    },
    purchaseCreditCard: async function (
      amount,
      product_type,
      installments,
      product_id,
      proposal_id,
      cards,
      bump_id
    ) {
      var data = {
        recaptcha: this.captcha || 'error',
        gateway: this.gateway,
        method: this.method,
        language: this.$i18n.locale,
        total:
          this.getInstallments() * this.installments - this.shipping.amount,
        product_type: product_type,
        // product_id: product_id,
        products: this.products_list,
        amount: this.amount,
        cards: cards,
        installments: installments,
        name: this.data.name,
        email: this.data.email,
        cellphone: this.data.cellphone,
        document: this.data.document,
        client_statistics: this.client_statistics,
        uuid: this.capture.uuid,
        upsell_id: this.upsell_id,
        country_code: this.country_code,
      };
     
      data.zipcode = this.data.zipcode
        ? this.data.zipcode.replace(/[-]/g, "")
        : null;
      data.street = this.data.street;
      data.number = this.data.number;
      data.complement = this.data.complement;
      data.neighborhood = this.data.neighborhood;
      data.city = this.data.city;
      data.state = this.data.state;
      

      if (this.$route.params.hash) {
        data.products[0].product_offer = this.$route.params.hash;
      }

      if (this.is_produto_fisico) {
        data.shipping_address_zip_code = this.shipping.address.zipcode
          ? this.shipping.address.zipcode.replace(/[-]/g, "")
          : null;
        data.shipping_address_street = this.shipping.address.street;
        data.shipping_address_number = this.shipping.address.number;
        data.shipping_address_complement = this.shipping.address.complement;
        data.shipping_address_neighborhood = this.shipping.address.neighborhood;
        data.shipping_address_city = this.shipping.address.city;
        data.shipping_address_state = this.shipping.address.state;

        if (this.data.has_shipping_fee) {
          // adicionando frete ao total
          data.total += this.shipping.amount;

          data.shipping_amount = this.shipping.amount;
          data.shipping_service_name = this.shipping.service_name;
          data.shipping_service_id = this.shipping.service_id;
          // todos dados do frete
          data.shipping_selected = JSON.stringify(this.shipping);
        }
      }

      data.total = parseFloat(data.total);

      if (typeof proposal_id != "undefined" && proposal_id != null) {
        data.proposal_id = proposal_id;
      }

      // cupom
      if (this.cupom_checkout && this.cupom_valid) {
        data.products[0].coupon = this.cupom_checkout.toUpperCase();
      }

      // produto fisico / presente
      if (this.data.is_gift) {
        data.is_gift = this.data.is_gift;
        data.gift_message = this.data.gift_message;
      }

      // Check if there's affiliate with this product
      if (this.affiliate_id != null) {
        data.affiliate_id = this.affiliate_id;
      }

      if (typeof bump_id != "undefined" && bump_id != null) {
        data.bump_product_id = bump_id;
        data.bump_amount = this.bump.amount;
      }

      // Check if there's meta tags
      if (
        typeof this.metas != "undefined" &&
        Object.keys(this.metas).length > 0
      ) {
        data.metas = this.metas;
      }

      // set currency conversion data
      data.rate = this.rate;

      // registrando log do objeto com os dados de compra
      if (
        this.method == "CREDIT_CARD" ||
        this.method == "TWO_CREDIT_CARDS" ||
        this.method == "DEBITCARD"
      ) {
        this.dataLog = Object.assign(
          {
            cartoes: [],
          },
          data
        );
        if (this.gateway !== 'stripe') {
          // enviando amount junto dos dados para analises
          this.dataLog.cartoes.push({
            amount: data.cards[0].amount,
            cvv: "###",
            holder_name: data.cards[0].card_holder_name,
            expiration_date: data.cards[0].card_expiration_date,
            number: `#### #### #### ${data.cards[0].card_number.split(" ")[
              data.cards[0].card_number.split(" ").length - 1
            ]
              }`,
          });

          if (this.method == "TWO_CREDIT_CARDS") {
            this.dataLog.cartoes.push({
              amount: data.cards[1].amount,
              cvv: "###",
              holder_name: data.cards[1].card_holder_name,
              expiration_date: data.cards[1].card_expiration_date,
              number: `#### #### #### ${data.cards[1].card_number.split(" ")[
                data.cards[1].card_number.split(" ").length - 1
              ]
                }`,
            });
          }
        } else {
          // enviando amount junto dos dados para analises
          this.dataLog.cartoes.push({
            stripe_card: cards[0].stripe_card,
          });
        }
        delete this.dataLog.cards;
      } else {
        this.dataLog = Object.assign({}, data);
      }

      let response = await servicePayment.create(data);
      return response;
    },
    paymentPayPal: async function (
      product_type,
      product_id,
      amount,
      proposal_id,
      bump_product_id,
      bump_amount,
      paypal
    ) {
      var data = {
        recaptcha: this.captcha || 'error',
        method: "PAYPAL",
        language: this.$i18n.locale,
        product_type: product_type,
        amount: amount,
        product_id: product_id,
        products: this.products_list,
        name: this.data.name,
        email: this.data.email,
        cellphone: this.data.cellphone,
        document: this.data.document,
        client_statistics: this.client_statistics,
        proposal_id: proposal_id,
        bump_product_id: bump_product_id,
        bump_amount: bump_amount,
        paypal: paypal,
        zipcode: this.data.zipcode
          ? this.data.zipcode.replace(/[-]/g, "")
          : null,
        street: this.data.street,
        number: this.data.number,
        complement: this.data.complement,
        neighborhood: this.data.neighborhood,
        city: this.data.city,
        state: this.data.state,
        uuid: this.capture.uuid,
        upsell_id: this.upsell_id,
        country_code: this.country_code,
      };

      if (this.$route.params.hash) {
        data.offer_hash = this.$route.params.hash;
        data.products[0].product_offer = this.$route.params.hash;
      }

      // Check if there's affiliate with this product
      if (this.affiliate_id != null) {
        data.affiliate_id = this.affiliate_id;
      }

      // cupom
      if (this.cupom_checkout && this.cupom_valid) {
        data.products[0].coupon = this.cupom_checkout.toUpperCase();
      }

      // Check if there's meta tags
      if (
        typeof this.metas != "undefined" &&
        Object.keys(this.metas).length > 0
      ) {
        data.metas = this.metas;
      }

      // set currency conversion data
      data.rate = this.rate;

      // Registrando log paypal
      this.dataLog = Object.assign({}, data);

      return await servicePayment.create(data);
    },
    buildTicket: async function (
      product_type,
      product_id,
      amount,
      proposal_id,
      bump_product_id,
      bump_amount
    ) {
      var data = {
        recaptcha: this.captcha || 'error',
        method: this.method,
        language: this.$i18n.locale,
        total:
          this.getInstallments(this.installments_boleto) *
          this.installments_boleto,
        product_type: product_type,
        amount: amount,
        installments:
          this.permite_parcela_boleto > 1 ? this.installments_boleto : 1,
        product_id: product_id,
        products: this.products_list,
        name: this.data.name,
        email: this.data.email,
        cellphone: this.data.cellphone,
        document: this.data.document,
        client_statistics: this.client_statistics,
        proposal_id: proposal_id,
        bump_product_id: bump_product_id,
        bump_amount: bump_amount,
        zipcode: this.data.zipcode
          ? this.data.zipcode.replace(/[-]/g, "")
          : null,
        street: this.data.street,
        number: this.data.number,
        complement: this.data.complement,
        neighborhood: this.data.neighborhood,
        city: this.data.city,
        state: this.data.state,
        uuid: this.capture.uuid,
        upsell_id: this.upsell_id,
        country_code: this.country_code,
      };

      if (this.$route.params.hash) {
        data.products[0].product_offer = this.$route.params.hash;
      }

      if (this.method === "EFT") {
        data.eft_code = this.bank_type;
      }

      if (this.is_produto_fisico) {
        data.shipping_address_zip_code = this.shipping.address.zipcode
          ? this.shipping.address.zipcode.replace(/[-]/g, "")
          : null;
        data.shipping_address_street = this.shipping.address.street;
        data.shipping_address_number = this.shipping.address.number;
        data.shipping_address_complement = this.shipping.address.complement;
        data.shipping_address_neighborhood = this.shipping.address.neighborhood;
        data.shipping_address_city = this.shipping.address.city;
        data.shipping_address_state = this.shipping.address.state;

        if (this.data.has_shipping_fee) {
          // adicionando frete ao total
          // data.total += this.shipping.amount;

          data.shipping_amount = this.shipping.amount;
          data.shipping_service_name = this.shipping.service_name;
          data.shipping_service_id = this.shipping.service_id;
          // todos dados do frete
          data.shipping_selected = JSON.stringify(this.shipping);
        }
      }

      // cupom
      if (this.cupom_checkout && this.cupom_valid) {
        data.products[0].coupon = this.cupom_checkout.toUpperCase();
      }

      // produto fisico / presente
      if (this.data.is_gift) {
        data.is_gift = this.data.is_gift;
        data.gift_message = this.data.gift_message;
      }

      // Check if there's meta tags
      if (
        typeof this.metas != "undefined" &&
        Object.keys(this.metas).length > 0
      ) {
        data.metas = this.metas;
      }

      // Check if there's affiliate with this product
      if (this.affiliate_id != null) {
        data.affiliate_id = this.affiliate_id;
      }

      // set currency conversion data
      data.rate = this.rate;

      // Registrando log boleto
      this.dataLog = Object.assign({}, data);

      return await servicePayment.create(data);
    },
    buildPix: async function (
      product_type,
      product_id,
      amount,
      proposal_id,
      bump_product_id,
      bump_amount
    ) {
      var data = {
        recaptcha: this.captcha || 'error',
        method: "PIX",
        language: this.$i18n.locale,
        total: amount,
        product_type: product_type,
        amount: amount,
        product_id: product_id,
        products: this.products_list,
        name: this.data.name,
        email: this.data.email,
        cellphone: this.data.cellphone,
        document: this.data.document,
        client_statistics: this.client_statistics,
        proposal_id: proposal_id,
        bump_product_id: bump_product_id,
        bump_amount: bump_amount,
        zipcode: this.data.zipcode
          ? this.data.zipcode.replace(/[-]/g, "")
          : null,
        street: this.data.street,
        number: this.data.number,
        complement: this.data.complement,
        neighborhood: this.data.neighborhood,
        city: this.data.city,
        state: this.data.state,
        uuid: this.capture.uuid,
        upsell_id: this.upsell_id,
        country_code: this.country_code,
      };

      if (this.$route.params.hash) {
        data.products[0].product_offer = this.$route.params.hash;
      }

      if (this.is_produto_fisico) {
        data.shipping_address_zip_code = this.shipping.address.zipcode
          ? this.shipping.address.zipcode.replace(/[-]/g, "")
          : null;
        data.shipping_address_street = this.shipping.address.street;
        data.shipping_address_number = this.shipping.address.number;
        data.shipping_address_complement = this.shipping.address.complement;
        data.shipping_address_neighborhood = this.shipping.address.neighborhood;
        data.shipping_address_city = this.shipping.address.city;
        data.shipping_address_state = this.shipping.address.state;

        if (this.data.has_shipping_fee) {
          // adicionando frete ao total
          data.total += this.shipping.amount;

          data.shipping_amount = this.shipping.amount;
          data.shipping_service_name = this.shipping.service_name;
          data.shipping_service_id = this.shipping.service_id;
          // todos dados do frete
          data.shipping_selected = JSON.stringify(this.shipping);
        }
      }

      // cupom
      if (this.cupom_checkout && this.cupom_valid) {
        data.products[0].coupon = this.cupom_checkout.toUpperCase();
      }

      // produto fisico / presente
      if (this.data.is_gift) {
        data.is_gift = this.data.is_gift;
        data.gift_message = this.data.gift_message;
      }
      // Check if there's meta tags
      if (
        typeof this.metas != "undefined" &&
        Object.keys(this.metas).length > 0
      ) {
        data.metas = this.metas;
      }

      // Check if there's affiliate with this product
      if (this.affiliate_id != null) {
        data.affiliate_id = this.affiliate_id;
      }

      // set currency conversion data
      data.rate = this.rate;

      // Registrando log pix
      this.dataLog = Object.assign({}, data);

      return await servicePayment.create(data);
    },
    getProduct(slug, pais = 'BR') {
      return new Promise((resolve) => {
        let data = { id: slug };

        if (this.$route.params.hash) {
          data.id = slug + "/offer/" + this.$route.params.hash;
        }

        if (pais) data.id = data.id + "?country=" + pais;

        serviceCheckout
          .readAll(data)
          .then((response) => {
            const token_header = {
              "controller-token-": response.headers["controller-token-"],
              "requestray-token-": response.headers["requestray-token-"],
              "firewall-token-": response.headers["firewall-token-"],
              "cache-token-": response.headers["cache-token-"],
              "trans-token-": response.headers["trans-token-"],
            };

            this.$store.commit("UPDATE_TOKEN", token_header);
            return JSON.parse(response.data);
          })
          .then((response) => {
            if (this.countryGlobal !== "BR" &&
              response.data &&
              response.checkout_payment &&
              response.data.method &&
              response.data.method.indexOf("CREDIT_CARD") >= 0) {
              this.loadStripe();
            }

            // recreate paypal link with currency and correct token
            if (response.data.type !== "SUBSCRIPTION") {
              let client_id;
              if (process.env.NODE_ENV !== "production") {
                if (this.countryGlobal !== "BR") {
                  client_id = process.env.PAYPAL_CLIENT_ID_INTERNATIONAL;
                } else {
                  client_id = process.env.PAYPAL_CLIENT_ID_NATIONAL;
                }
              } else {
                if (this.countryGlobal !== "BR") {
                  client_id = process.env.PAYPAL_CLIENT_ID_INTERNATIONAL;
                } else {
                  client_id = process.env.PAYPAL_CLIENT_ID_NATIONAL;
                }
              }

              // Verifica se o elemento com o ID "paypal_id" existe
              const paypalId = document.getElementById("paypal_id");
              if (paypalId) {
                // Se existir, remove o elemento
                paypalId.remove();
              }
              let script = document.createElement("script");
              script.id = "paypal_id";
              if (
                response.data &&
                response.checkout_payment &&
                response.data.method &&
                response.data.method.indexOf("PAYPAL") >= 0
              ) {
                if (response.checkout_payment.paypal) {
                  script.src =
                    "https://www.paypal.com/sdk/js?client-id=" +
                    client_id +
                    `&currency=${response.checkout_payment.paypal.currency}&disable-funding=credit,card,mercadopago`;

                  document.body.appendChild(script);

                  // get paypal data
                  this.paypal.amount = response.checkout_payment.paypal.amount;
                  this.paypal.original_amount =
                    response.checkout_payment.paypal.amount;
                  this.paypal.currency =
                    response.checkout_payment.paypal.currency;
                  this.paypal.symbol_currency =
                    response.checkout_payment.paypal.symbol_currency;
                }
              }
            }

            this.checkoutPayment = response.checkout_payment;
            if (
              this.checkoutPayment &&
              this.checkoutPayment.data &&
              this.checkoutPayment.data.amount
            ) {
              response.data.amount = this.checkoutPayment.data.amount;
              this.mountedProduct(response.data, response.type);
            }
            if (!this.$store.state.mounted) {
              this.mountedProduct(response.data, response.type);
            }


            // set local variabel with currency conversion data
            this.rate = {
              target_currency: response.checkout_payment.data.to,
              base_currency: response.checkout_payment.data.from,
              token: response.checkout_payment.token,
            };
            this.currency = response.checkout_payment.base_currency;
            this.currency_id = response.checkout_payment.base_currency_id;
            this.name = (response.data.seller.company && response.data.seller.company.fantasy_name !== '') ? response.data.seller.company.fantasy_name : response.data.seller.name;
            this.sellersDomains.push(response.domains);

          })
          .then(() => resolve(true))
          .catch((err) => {
            console.error(err);
            resolve(true);
            this.removePreload(true);
          });
      });
    },
    getProposal(id_proposta) {
      serviceProposal
        .readAll({ id: id_proposta })
        .then((response) => {
          const token_header = {
            "controller-token-": response.headers["controller-token-"],
            "requestray-token-": response.headers["requestray-token-"],
            "firewall-token-": response.headers["firewall-token-"],
            "cache-token-": response.headers["cache-token-"],
            "trans-token-": response.headers["trans-token-"],
          };

          this.$store.commit("UPDATE_TOKEN", token_header);
          return JSON.parse(response.data);
        })
        .then((response) => {
          if (response.name) {
            if (!this.$store.state.mounted) {
              this.mountedProduct(response, "PROPOSAL");
            }
          } else {
            document.querySelector(".carregando").classList.add("erro", "prop");
          }
        })
        .catch((err) => {
          console.error(err);
          document.querySelector(".carregando").classList.add("erro", "prop");
        });
    },
    mountedProduct(product, type) {
      const seller = this.normalizeString(
        product.seller.company
          ? product.seller.company.fantasy_name || product.seller.company.name
          : product.seller.name
      );

      window.dataLayer?.push({
        event: "checkout",
        eventCategory: `${seller}:enhanced-ecommerce`,
        eventAction: "checkout",
        eventLabel: undefined,
        noInteraction: 1,
        ecommerce: {
          checkout: {
            actionField: {
              step: 2,
            },
            products: [
              {
                name: this.normalizeString(product.name),
                id: product.id,
                price: this.checkoutPayment.price,
                brand: seller,
                category: this.normalizeString(product.category.name),
                variant: undefined,
                quantity: 1,
              },
            ],
          },
        },
      });
      window.dataLayer?.push({
        event: "begin-checkout",
        ecommerce: {
          affiliation: this.affiliate_id || this.$route.query.a_id || undefined,
          value: this.checkoutPayment.price,
          items: [
            {
              item_name: this.normalizeString(product.name),
              item_id: product.id,
              price: this.checkoutPayment.price,
              item_brand: seller,
            },
          ],
        },
      });
      // rodapé
      this.has_greenn_me = document.URL.includes("https://pay.greenn.me");

      this.$store.commit("UPDATE_MOUNTED", true);
      this.product_type = type;
      this.product = product;

      this.payment_method = this.product.method.split(",");

      this.amount = this.product.amount;

      this.currency_id = this.product.currency_id;

      // cupom de desconto
      this.permite_cupom =
        this.product_type == "COMMON" &&
          this.product.format !== "PHYSICALPRODUCT"
          ? this.product.allowed_coupon
          : false; // proposta nao tem cupom de desconto

      if (this.permite_cupom && this.cupom_checkout) {
        this.$refs.Cupom.id_product =
          this.product.product_id || this.product.id;
        // this.$refs.Cupom.checkCupom(this.product.amount);
        setTimeout(() => {
          document.querySelector(".collapse-cupom").click();
          this.$refs.Cupom.cupom_active = true;
          this.$refs.Cupom.cupom = this.cupom_checkout;

          setTimeout(() => {
            document.querySelector(".btn-cupom").click();
          });
        });
      }

      if (this.product_type == "COMMON") {
        // validando status changed
        if (this.product.status == "CHANGED") {
          this.product.status = "APPROVED";
        }

        this.original_amount = this.product.amount;

        document.title = `${this.product.name} |  Voomp Pay`;

        // juros vendedor
        this.sem_juros = this.product.no_interest_installments;

        // produto fisico
        this.is_produto_fisico =
          this.product.format == "PHYSICALPRODUCT" ? true : false;

        this.data.has_shipping_fee = this.product.has_shipping_fee;

        if (
          (this.product.format == "PHYSICALPRODUCT" &&
            !this.product.in_stock) ||
          !this.product.is_active
        ) {
          this.product.status = "DISAPPROVED";
        }

        this.products_list = [];

        this.products_list.push({
          product_id: this.product.id || +this.$route.params.product,
          proposal_id: +this.$route.query.prop_id || null,
        });

        // if (this.product.status != "APPROVED") {
        //   this.error_message =
        //     "Este produto não está disponível para pagamento.";
        //   this.charge_error = true;
        // }

        this.product.banner_checkout = null;

        var product_id = this.product.id;
        var seller_id = this.product.seller_id;
        this.capture.seller_id = this.product.seller_id;

        // permite parcelamento de boleto
        this.permite_parcela_boleto = this.product.max_boleto_installments
          ? this.product.max_boleto_installments
          : 0;

        // permite parcelamento de assinatura
        this.permite_parcela_assinatura = this.product
          .max_subscription_installments
          ? this.product.max_subscription_installments
          : 0;

        // metodos de pagamento
        // this.product.method = this.product.method
        //   ? this.product.method
        //   : "CREDIT_CARD,PIX,BOLETO,PAYPAL,TWO_CREDIT_CARDS";
        this.product.method = this.product.method
          ? this.product.method
            .split(",")
            .filter(
              (m) =>
                m === "BOLETO" ||
                m === "CREDIT_CARD" ||
                m === "PIX" ||
                m === "PAYPAL"
            )
            .join(",")
          : "CREDIT_CARD,BOLETO,PIX,PAYPAL";

        if (this.product.format && this.product.has_shipping_fee) {
          const method = this.product.method.split(",");
          const index = method.indexOf("PAYPAL");
          if (index > -1) {
            method.splice(index, 1);
          }

          this.product.method = method.toString();
          this.permite_parcela_boleto = false;
        }

        if (
          this.product.method.includes("CREDIT_CARD") ||
          this.product.method.includes("ALL")
        ) {
          this.method = "CREDIT_CARD";
          this.$nextTick(() => {
            try {
              document.querySelector(".CREDIT_CARD").click();
            } catch (error) {
              const splitMethod = this.product.method.split(",")[0];
              document.querySelector(`.${splitMethod}`).click();
            }
          });
        } else {
          this.$nextTick(() => {
            try {
              const splitMethod = this.product.method.split(",")[0];
              document.querySelector(`.${splitMethod}`).click();
            } catch (error) {
              document.querySelector(".CREDIT_CARD").click();
            }
          });
        }

        if (
          this.product.type == "SUBSCRIPTION" &&
          this.product.period > 30 &&
          this.permite_parcela_assinatura > 1
        ) {
          this.installments = this.product.max_subscription_installments;
        }

        if (this.product.type == "SUBSCRIPTION" && this.product.period == 30) {
          this.installments = 1;
        }

        // quantidade de parcelas
        if (this.product.type == "TRANSACTION") {
          this.product.max_installments = this.product.max_installments || 12;
          this.installments = this.product.max_installments;
        }

        // parcelas fixas
        if (this.product.fixed_installments && this.gateway !== 'stripe') {
          this.parcela_fixa =
            this.product.fixed_installments || this.bump.fixed_installments;
          this.installments =
            this.product.fixed_installments || this.bump.fixed_installments;
        }

        if (this.product.status_product === "CHANGED") {
          this.product.status_product = "APPROVED";
        }

        if (this.product.status_offer === "PENDING") {
          this.product.status_offer = "APPROVED";
        }

        if (
          this.product.status_product != "APPROVED" ||
          this.product.status_offer != "APPROVED" ||
          this.product.is_active === 0
        ) {
          this.error_message =
            "Este produto não está disponível para pagamento.";
          this.charge_error = true;

          this.themeCheckout.theme = "light";
        }

        if (this.product.pre_selected_installment) {
          this.installments = this.product.pre_selected_installment;
        }

        // this.setSocialProve(this.product);
      } else if (this.product_type == "PROPOSAL") {
        // validando status changed
        if (this.product.product.status == "CHANGED") {
          this.product.product.status = "APPROVED";
        }

        this.original_amount = this.product.product.amount;
        document.title = `${this.product.product.name} | Voomp Pay`;

        // juros vendedor
        this.sem_juros = this.product.no_interest_installments;

        // produto fisico
        this.is_produto_fisico =
          this.product.product.format == "PHYSICALPRODUCT" ? true : false;

        this.data.has_shipping_fee = this.product.product.has_shipping_fee;
        if (
          (this.product.product.format == "PHYSICALPRODUCT" &&
            !this.product.product.in_stock) ||
          !this.product.product.is_active
        ) {
          this.product.product.status = "DISAPPROVED";
        }

        this.products_list = [];

        this.products_list.push({
          product_id: this.product.product.id || +this.$route.params.product,
          proposal_id: +this.$route.query.prop_id || null,
        });

        this.product.product.banner_checkout = null;

        if (this.product.product.status_product === "CHANGED") {
          this.product.product.status_product = "APPROVED";
        }

        if (this.product.product.status_offer === "PENDING") {
          this.product.product.status_offer = "APPROVED";
        }

        if (
          this.product.product.status_product != "APPROVED" ||
          this.product.product.status_offer != "APPROVED" ||
          this.product.product.is_active === 0
        ) {
          this.error_message =
            "Este produto não está disponível para pagamento.";
          this.charge_error = true;
          this.themeCheckout.theme = "light";
        }

        if (this.product.product.status_product != "APPROVED") {
          this.error_message =
            "Este produto não está disponível para pagamento.";
          this.charge_error = true;
          this.themeCheckout.theme = "light";
        }

        if (this.product.product.status_offer != "APPROVED") {
          this.error_message =
            "Este produto não está disponível para pagamento.";
          this.charge_error = true;
          this.themeCheckout.theme = "light";
        }

        product_id = this.product.product.id;
        seller_id = this.product.product.seller_id;
        this.capture.seller_id = this.product.product.seller_id;
        if (this.product.product.type == "SUBSCRIPTION") {
          this.installments = 1;
        }

        // permite parcelamento de boleto
        this.permite_parcela_boleto = this.product.product
          .max_boleto_installments
          ? this.product.product.max_boleto_installments
          : 0;
        // this.setSocialProve(this.product.product);

        // permite parcelamento de assinatura
        this.permite_parcela_assinatura = this.product.product
          .max_subscription_installments
          ? this.product.product.max_subscription_installments
          : 0;

        this.product.product.method = "CREDIT_CARD,BOLETO,PIX";

        if (
          this.product.product.format &&
          this.product.product.has_shipping_fee
        ) {
          const method = this.product.product.method.split(",");
          const index = method.indexOf("PAYPAL");

          method.splice(index, 1);
          if (index > -1) {
            method.splice(index, 1);
          }

          this.product.product.method = method.toString();

          this.permite_parcela_boleto = false;
        }

        if (
          this.product.product.method.includes("CREDIT_CARD") ||
          this.product.product.method.includes("ALL")
        ) {
          this.method = "CREDIT_CARD";
        }
        this.$nextTick(() => {
          const splitMethod = this.product.product.method.split(",")[0];
          document.querySelector(`.${splitMethod}`).click();
        });

        if (
          this.permite_parcela_assinatura > 1 &&
          this.product.product.period > 30 &&
          this.product.product.type == "SUBSCRIPTION"
        ) {
          this.installments = this.product.product.max_subscription_installments;
        }

        if (
          this.product.product.type == "SUBSCRIPTION" &&
          this.product.product.period == 30
        ) {
          this.installments = 1;
        }

        // quantidade de parcelas
        if (this.product.product.type == "TRANSACTION") {
          this.product.product.max_installments =
            this.product.product.max_installments || 12;
          this.installments = this.product.product.max_installments;
        }

        // parcelas fixas
        if (this.product.product.fixed_installments && this.gateway !== 'stripe') {
          this.parcela_fixa = this.product.product.fixed_installments;
          this.installments = this.product.product.fixed_installments;
        }

        if (this.product.product.pre_selected_installment) {
          this.installments = this.product.product.pre_selected_installment;
        }
      }

      // produto fisico
      this.data.billing_shipping_same_address = this.is_produto_fisico;

      this.products_client_statistics = [
        ...this.products_list,
        ...this.products_client_statistics,
      ];

      this.affiliate_id =
        +Cookies.get("affiliate_" + product_id) || +this.$route.query.a_id;

      this.loadBump();
      this.setClientStatistics();

      // Load pixels
      this.getMetrics(product_id);

      this.getSellerSettings(seller_id);
      // Save client statistics

      // setando os dados de captura
      if (this.product_type == "PROPOSAL") {
        this.capture.product_id = this.product.product.id;
      } else {
        this.capture.product_id = this.product.id;
      }
      this.capture.uuid = localStorage.getItem(
        `${this.capture.product_id}_user_uuid`
      );
      if (!this.data.isValidToken && this.capture.uuid) {
        this.fetchCapture(this.capture);
      }
      this.payment_methods = this.product.method.split(",");
      if (this.product_type == "COMMON") {
        if (this.product.type === "SUBSCRIPTION") {
          this.max_installments = this.product.fixed_installments ?? this.product.max_subscription_installments;

          if (this.product.fixed_installments && this.gateway !== 'stripe') {
            this.installments = this.product.fixed_installments;
          }
        } else {
          this.max_installments =
            this.product.fixed_installments ?? this.product.max_installments;
        }
      }

      // valida Bump
      setTimeout(() => {
        if (this.bump) {
          if (
            this.bump.status !== "APPROVED" ||
            this.bump.status_offer !== "APPROVED" ||
            this.bump.status_product !== "APPROVED" ||
            !this.bump.is_active
          ) {
            this.bump_error = true;
            this.charge_error = true;
            this.error_message = "Produto em processo de análise";
            this.themeCheckout.theme = "light";
          }
          // check if bump has some payment method in common with product
          const productMethods = this.product.method.split(",");
          const bumpMethods = this.bump.method.split(",");
          const commonMethods = productMethods.filter((method) =>
            bumpMethods.includes(method)
          );

          this.payment_methods =
            commonMethods.length > 0 ? commonMethods : ["CREDIT_CARD"];
          this.method = this.payment_methods[0];

        }
      }, 500);

      if (this.gateway === 'stripe') this.installments = 1;
      this.removePreload();
    },
    setSocialProve(product) {
      if (product.notify_views && product.views >= product.notify_views) {
        let random = parseInt(Math.random() * 100) % 20; // secounds
        let vm = this;
        setTimeout(function () {
          vm.$bvToast.toast(
            product.views + " pessoas visualizaram este produto.",
            {
              title: "Visualizações",
              variant: "info",
              autoHideDelay: 5000,
              appendToast: true,
            }
          );
        }, random * 1000);
      }
      if (
        product.notify_purchases &&
        product.purchases >= product.notify_purchases
      ) {
        let random = parseInt(Math.random() * 100) % 20; // secounds
        let vm = this;
        setTimeout(function () {
          vm.$bvToast.toast(
            product.purchases + " pessoas compraram este produto.",
            {
              title: "Compras",
              variant: "success",
              autoHideDelay: 5000,
              appendToast: true,
            }
          );
        }, random * 1000);
      }

      if (product.notify_amount && product.quantity <= product.notify_amount) {
        let random = parseInt(Math.random() * 100) % 20; // secounds
        let vm = this;
        setTimeout(function () {
          vm.$bvToast.toast(
            "Somente " + product.quantity + " produtos restantes.",
            {
              title: "Quantidade",
              variant: "warning",
              autoHideDelay: 5000,
              appendToast: true,
            }
          );
        }, random * 1000);
      }
    },
    loadBump(country_code = null) {

      const b_product_id = this.$route.query.b_id || this.$route.query.b_id_1

      let code = country_code !== null ? country_code : this.countryGlobal;
      if (
        typeof b_product_id != "undefined"
        && b_product_id
        && b_product_id != this.$route.params.product
      ) {
        this.getBump(b_product_id, code);
      }
    },
    getBump(slug, pais = 'BR') {
      if (!slug || !pais) return;

      const query = this.$route.query;

      const b_product_id = query.b_id || query.b_id_1

      if (typeof slug == "object") {
        this.products_client_statistics = [];
        for (let b in b_product_id) {
          this.products_client_statistics.push({
            product_id: + b_product_id[b],
          });
        }
        return;
      }

      let data = { id: slug };

      if (this.b_offer && typeof b_product_id == "string") {
        data.id = slug + "/offer/" + this.b_offer;
      }

      if (pais) data.id = data.id + "?country=" + pais;

      serviceProduct
        .read(data)
        .then((response) => {
          this.bump = response.data;
          if (
            response.checkout_payment &&
            response.checkout_payment.data &&
            response.checkout_payment.data.amount
          ) {
            response.data.amount = response.checkout_payment.data.amount;
          }

          response.data.paypal = response.checkout_payment.paypal;
          this.bump_list = [];
          if (this.product.id !== response.data.id) {
            this.bump_list.push(response.data);
          }
        })
        .catch((err) => console.error(err))
        .finally(() => {
          let array = [];
          if (this.queryUrl.b_id.length > 0 && this.bump_list.length > 0) {
            if (Array.isArray(this.queryUrl.b_id)) {
              this.queryUrl.b_id.forEach((queryItem) => {
                this.bump_list.forEach((bumpItem) => {
                  if (parseInt(queryItem) === bumpItem.id) array.push(bumpItem);
                });
              });
            } else {
              this.bump_list.forEach((bumpItem) => {
                if (parseInt(this.queryUrl.b_id) === bumpItem.id)
                  array.push(bumpItem);
              });
            }
          }
          this.bump_list = array;
        });
    },
    getSellerSettings(user_id) {
      this.sellerSettingsLoading = true;
      serviceSettings
        .read({ id: user_id })
        .then((response) => {
          response.forEach((element) => {
            if (element.key == "BUY_BUTTON_TEXT")
              this.buy_button_text = element.value;
            else if (
              element.key === "MONTHLY_SELLING_INTEREST_ASSUMED_BY_SELLER" &&
              element.value !== null
            )
              this.monthly_interest = parseFloat(element.value);
          });
          this.sellerSettingsLoading = false;
        })
        .catch((err) => console.error(err));
    },
    getGlobalSettings() {
      serviceGlobalSettings
        .search({ keys: ["PAGARME_ANTIFRAUDE", "MONTHLY_INTEREST"] })
        .then((response) => {
          response.forEach((element) => {
            if (element.key == "PAGARME_ANTIFRAUDE") {
              this.is_antifraude = element.value == "ENABLED" ? true : false;
            }
            if (
              element.key == "MONTHLY_INTEREST" &&
              this.monthly_interest === 0
            ) {
              this.monthly_interest = parseFloat(element.value);
            }
          });

          this.countryGlobal = [...response].find((item) => item.country);
          this.countryGlobal = this.countryGlobal
            ? this.countryGlobal.country
            : "BR";
        })
        .catch((err) => {
          this.countryGlobal = "BR";
          console.error(err);
        })
        .finally(async () => {
          const { token } = this.$route.query;
          if (typeof token != "undefined") {
            await this.fetchToken(token);
          }

          await this.setBrowserLocaleCode()
        });
    },
    async getMetrics(product_id) {
      let data = { id: product_id };

      if (this.affiliate_id) data.id = data.id + "?a_id=" + this.affiliate_id;

      const pixels =
        this.product_type == "COMMON"
          ? this.product.pixels
          : this.product.product.pixels;

      const hasTagManager =
        pixels && pixels.length
          ? pixels.filter((item) => item.type == "GOOGLETAGMANAGER")
          : [];

      // fluxo tagmanager manual
      if (hasTagManager.length) {
        hasTagManager.forEach((item) => {
          (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
          })(window, document, "script", "dataLayer", item.pixel_id);
        });

        // enviando o evento de checkout para o tagmanager
        this.onCheckoutEvent(
          this.product_type == "COMMON" ? this.product : this.product.product
        );
      }

      if (pixels.length) {

        const email = this.data.email;
        const ip_address = this.ip_address;
        const user_agent = navigator.userAgent;
        const name = this.data.name;
        const fbp = this.getCookie('_fbp');
        const fbc = this.getCookie('_fbc');
        const cellphone = this.data.cellphone;
        const city = this.data.city;
        const state = this.data.state;
        const zipcode = this.data.zipcode;
        const external_id = this.product.seller.id;

        window.pixel.handleEvent(
          "view",
          product_id,
          this.affiliate_id,
          this.method,
          this.amount,
          undefined,
          email,
          ip_address,
          user_agent,
          fbp,
          name,
          fbc,
          cellphone,
          city,
          state,
          zipcode,
          external_id
        );

        if (this.debugPixel) {
          window.pixel.handleEvent(
            "conversion",
            product_id,
            this.affiliate_id,
            this.method,
            this.amount,
            undefined,
            email,
            ip_address,
            user_agent,
            fbp,
            name,
            fbc,
            cellphone,
            city,
            state,
            zipcode,
            external_id
          );
        }
      }
    },
    
    setClientStatistics() {
      var parser = new UAParser();
      let result = parser.getResult();

      let data = {
        device_type: result.device_type,
        device_vendor: result.device_vendor,
        engine: result.engine.name,
        browser: result.browser.name,
        os: result.os.name,
        cpu: result.cpu.architecture,
        ua: result.ua,
        affiliate_id: this.affiliate_id ? this.affiliate_id : null,
        products: this.products_client_statistics,
      };

      if (this.product_type == "COMMON") {
        data.product_id = this.product.id;
        data.seller_id = this.product.seller_id;
      } else if (this.product_type == "PROPOSAL") {
        data.product_id = this.product.product.id;
        data.proposal_id = this.product.id;
        data.seller_id = this.product.product.seller_id;
      }

      serviceClientStatistics
        .create(data)
        .then((response) => {
          if (response.length > 1) {
            this.client_statistics = [...response].map((item) => item.id);
          } else this.client_statistics = [response[0].id];
        })
        .catch((err) => console.error(err));
    },
    getBanks() {
      serviceGateway
        .create({ country: "CO" }, "/banks")
        .then((response) => {
          this.external_banks = response;
          this.bank_type = response[0].code;
        })
        .catch((err) => console.error(err));
    },
    showBtn(metodo) {
      if (metodo === "EFT") {
        this.getBanks();
      }
      this.clickTab(metodo);
      this.btn_paypal = false;
    },
    async validateForm() {
      if (this.btn_paypal == true && this.gateway !== 'stripe') {
        this.submit = true;
        // validando com a função
        if (await this.validateAllForm()) {
          if (
            document.getElementsByClassName("paypal-buttons-context-iframe")
              .length == 0
          ) {
            this.renderPaypal();
          }
          this.paypal_true = true;
        } else {
          this.paypal_true = false;
        }
      }
    },
    renderPaypal(check = false) {
      if (this.gateway === 'stripe') return;
      this.data.cellphone = this.results_tel.formattedNumber;
      this.loaded = true;
      this.btn_paypal = true;
      this.clickTab("PAYPAL");
      if (
        document.getElementsByClassName("paypal-buttons-context-iframe")
          .length == 0 &&
        this.paypal_true == true
      ) {
        window.paypal
          .Buttons({
            locale: "pt_BR",
            style: {
              size: "responsive",
              color: "black",
              label: "buynow",
              branding: true,
            },
            onClick: (data, actions) => {
              if (check !== "check") {
                try {
                  this.$refs.Captcha.setCaptcha();
                  return;
                } catch (e) {
                  console.log(e);
                }
              }
              actions.reject();
              this.submit = true;
              this.$validator.validateAll().then(async (result) => {
                if (result) {
                  return actions.resolve();
                } else {
                  actions.close();
                }
              });
            },
            createOrder: (data, actions) => {
              const purchaseList = [];
              purchaseList.push({
                reference_id: this.product.id,
                description: this.product.name,
                amount: {
                  value:
                    this.method === "PAYPAL" ? this.paypal.amount : this.amount,
                  currency_code:
                    this.method === "PAYPAL" ? this.paypal.currency : "USD",
                },
              });
              if (this.bump && this.bump.checkbox && this.method === "PAYPAL") {
                purchaseList.push({
                  reference_id: this.bump_list[0].id,
                  description: this.bump_list[0].name,
                  amount: {
                    value: this.bump_list[0].amount,
                    currency_code: this.paypal.currency,
                  },
                });
              }
              return actions.order.create({
                purchase_units: purchaseList,
                application_context: {
                  shipping_preference: "NO_SHIPPING",
                },
              });
            },
            onApprove: async (data, actions) => {
              this.loading = true;
              // This function captures the funds from the transaction.
              let paypal = await actions.order
                .capture()
                .then(function (details) {
                  return details;
                });
              let product_id, amount, proposal_id, bump_amount, bump_product_id;
              amount = this.product.amount;
              if (this.product_type == "COMMON") {
                product_id = this.product.id;
              } else if (this.product_type == "PROPOSAL") {
                product_id = this.product.product.id;
                proposal_id = this.product.id;
              }
              if (this.data.bump) {
                bump_amount = this.bump.amount;
                bump_product_id = this.bump.id;
              }
              let response = await this.paymentPayPal(
                this.product_type,
                product_id,
                amount,
                proposal_id,
                bump_product_id,
                bump_amount,
                paypal
              );

              if (response.sales.length) {
                this.loading = false;
                this.preload = false;
                if (
                  (response.sales[0].success && !response.sales[0].code) ||
                  response.sales[0].status == "delayed"
                ) {
                  Cookies.remove("affiliate");
                  let query = {
                    s_id:
                      response.sales[0].status == "delayed"
                        ? "delayed"
                        : response.sales[0].sale_id, // id da venda
                  };
                  if (response.sales[0].token) {
                    query.token = response.sales[0].token;
                  }

                  query = Object.assign(this.$route.query, query);
                  this.formatPageThankYou(response.sales);

                  let chc = "";
                  if (
                    response.sales &&
                    response.sales.length &&
                    response.sales[0].chc
                  )
                    chc = "?chc=" + response.sales[0].chc;
                  const seller = this.normalizeString(
                    this.product.seller.company
                      ? this.product.seller.company.fantasy_name ||
                      this.product.seller.company.name
                      : this.product.seller.name
                  );
                  const product_name = this.normalizeString(this.product.name);

                  const items = [
                    {
                      item_name: product_name,
                      item_id: this.product.id,
                      price: this.product.amount,
                      item_brand: seller,
                    },
                  ];

                  if (this.bump && this.bump.checkbox) {
                    const bump_name = this.normalizeString(this.bump.name);
                    items.push({
                      item_name: bump_name,
                      item_id: this.bump.id,
                      price: this.bump.amount,
                      item_brand: seller,
                    });
                  }

                  window.dataLayer?.push({
                    event: "purchase",
                    ecommerce: {
                      transaction_id: response.sales[0].sale_id,
                      affiliation: this.affiliate_id,
                      value: this.totalToPay,
                      currency: this.filterCurrency(),
                      items,
                      customer: {
                        email: this.data.email,
                        phone: this.data.cellphone,
                      },
                      payment: {
                        opcao_de_pagamento: this.method,
                        parcelamento: this.installments,
                        tipo_cobranca: response.sales[0].is_smart_sale ? 'venda_inteligente' : 'sem_venda_inteligente'
                      }
                    },
                  });

                  let pixelData = {
                    ...this.data,
                    ip_address: this.ip_address,
                    external_id: this.product.seller.id
                  };

                  localStorage.setItem('pixelData', JSON.stringify(pixelData));

                  await this.$router.push({
                    path: `/${this.product.id}/obrigado` + chc,
                    query: query,
                    params: {
                      id_product: this.product.id,
                      name_product: this.product.name,
                      valor: this.amount,
                      trial:
                        this.product_type == "COMMON"
                          ? this.product.trial
                          : this.product.product.trial,
                      thank_you_page:
                        response.sales[0].product.custom_thank_you_page ||
                        this.page_thanks_response,
                      isCheckout: true,
                      methodCheckout: "PAYPAL",
                      // response
                      dados_response: response,
                    },
                  });
                } else this.paymentError(response.sales[0]);
              } else if (response.reason) this.resetTokens();
              else this.paymentError(response.sales);
            },
            onError: (err) => {
              console.error(err);
              this.paymentError("PayPal");
            },
          })
          .render(this.$refs.paypal);
      }
      setTimeout(() => this.validateForm(), 1000);
    },
    removePreload(erro = false) {
      if (!erro) {
        try {
          if (this.product) {
            this.preload = false;
            this.loading = false;
            document.querySelector("body").classList.remove("preload");
          } else {
            document.querySelector(".carregando").classList.add("erro");
          }
        } catch {
          this.preload = false;
          this.loading = false;
          document.querySelector("body").classList.remove("preload");
        }
      } else {
        setTimeout(() => {
          document.querySelector(".carregando").classList.add("erro");
        });
      }
    },
    validateSelectNotFixedInstallments() {
      if (
        !this.parcela_fixa ||
        this.countryGlobal !== "BR"
      ) {
        return true;
      } else return false;
    },
    showAddress() {
      return this.is_antifraude ||
        (this.product_type === "PROPOSAL" &&
          this.product.product.is_checkout_address) ||
        (this.product_type === "COMMON" && this.product.is_checkout_address) ||
        (this.products_list.length > 1 &&
          this.bump_list.some((b) => {
            if (
              (this.product_type === "PROPOSAL" &&
                b.product.is_checkout_address) ||
              (this.product_type === "COMMON" && b.is_checkout_address)
            )
              return true;
          }))
        ? true
        : false;
    },
    async loadStripeJs() {
      return await import("@stripe/stripe-js")
    },
    async loadHeadStripeJs() {
      let sc = 0;
      var scripts = document.head.getElementsByTagName("script");
      for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].src == "https://js.stripe.com/v3") {
          sc++;
        }
      }
      if (sc == 0) {
        let stripeScript = document.createElement('script')
        stripeScript.setAttribute('src', 'https://js.stripe.com/v3')
        stripeScript.setAttribute('type', "txt/script")
        document.head.appendChild(stripeScript)
      }
    },
    async loadStripe() {
      // Set the connected Stripe Account on which the source should be created
      const { loadStripe } = await this.loadStripeJs();
      let lang = await this.$i18n.locale ?? 'pt';

      this.stripe.load = await loadStripe(
        process.env.VUE_APP_STRIPE_PUBLIC_KEY, {
        locale: lang
      });
    },
    async mountStripeCard() {
      this.loading = true;
      setTimeout(async () => {
        await this.loadHeadStripeJs();
      }, 500);
      this.loading = false;

      setTimeout(async () => {
        if (this.gateway === 'stripe') {
          // Style Object documentation here: https://stripe.com/docs/js/appendix/style
          const elements = await this.stripe.load.elements({
            // Usando a opção placeholder para alterar o texto do campo "CEP"
            placeholder: {
              postalCode: 'Zipcode',
            }
          });

          const style = {
            base: {
              iconColor: this.themeCheckout.theme === 'light' ? '#333' : '#ccc',
              color: this.themeCheckout.theme === 'light' ? '#333' : '#ccc',
              backgroundColor: this.themeCheckout.theme === 'light' ? '#ffffff' : '#1a1c23',
              fontWeight: 400,
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '15px',
              fontSmoothing: 'antialiased',

              ':-webkit-autofill': {
                color: '#28a745',
              },
              '::placeholder': {
                color: this.themeCheckout.theme === 'light' ? '#333' : '#ccc',
              },
            },
            invalid: {
              iconColor: '#dc3545',
              color: '#dc3545',
            },
          };

          this.stripe.card = await elements.create("card", { style, hidePostalCode: true });
          this.stripe.card.mount("#card-stripe");
        } else {
          this.destroyStripeCard();
        }
      }, 500);
    },
    destroyStripeCard() {
      if (this.stripe.card) {
        this.stripe.card.destroy();
        this.stripe.card = null;
      }
    },
    async createStripePaymentMethod() {
      const { paymentMethod, error } = await this.stripe.load.createPaymentMethod(
        "card",
        this.stripe.card
      );
      if (await error) {
        // handle error here
        console.log('Stripe Error', error, error.message);
        this.error_message = "Falha no processamento do Cartão de Crédito, tente novamente ou entre em contato.";

        // notificação
        this.$bvModal.show("alert-modal");
        return false;
      } else {
        return await paymentMethod;
      }

    },
    async setBrowserLocaleCode() {
      if (this.data.isValidToken) {
        this.countryGlobal = this.data.country_code;
      } else if (this.akamaiCountry) {
        this.countryGlobal = await this.akamai_country_code;
      } else {
        this.getBrowserLocaleCode();
        this.countryGlobal = this.browser_country_code;
      }

      if (this.countryGlobal !== "BR") {
        if (this.payment_methods && this.payment_methods.indexOf("CREDIT_CARD") >= 0) {
          await this.loadStripe();
        }

        EventBus.$emit("atualizaPais", { country_code: this.countryGlobal });
        this.setLocale(this.countryGlobal);
      }
    },

    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return '';
    },
    async fetchToken(token) {
      try {
        const data = await serviceUpsell.read(token);

        // token
        this.data.isValidToken = true;

        // name
        this.data.name = data.name;

        // email
        this.data.email = data.email;

        // cellphone
        this.data.cellphone = data.cellphone;
        this.yourValue = data.cellphone;

        // document
        this.data.document = data.document;

        // country_code
        this.data.country_code = data.country_code;

      } catch (error) {
        this.data.isValidToken = false;
        console.error('Invalid token!', token);
      }
    },

    getQueryUrl() {
      let query = this.$route.query;

      this.queryUrl = Object.assign({}, this.$route.query);

      this.queryUrl.b_id = this.queryUrl.b_id || this.queryUrl.b_id_1

      if (typeof query.cupom != "undefined") {
        this.cupom_checkout = query.cupom;
        delete query.cupom;
      }

      if (typeof query.b != "undefined") {
        this.business = true;
        delete query.b;

        // script jivochat
        const jivoScript = document.createElement("script");
        jivoScript.setAttribute(
          "src",
          "//code.jivosite.com/widget/" + this.themeCheckout.jivochat_id
        );
        jivoScript.async = true;
        document.head.appendChild(jivoScript);
      }

      if (typeof query.upsell_id != "undefined") {
        this.upsell_id = +query.upsell_id;
      }

      if (typeof query.debugPixel != "undefined") {
        this.debugPixel = query.debugPixel == "true" ? true : false;
        delete query.debugPixel;
      }

      if (typeof query.b_offer != "undefined") {
        this.b_offer = query.b_offer;
        delete query.b_offer;
      } else if (typeof query.b_offer_1 != "undefined") {
        this.b_offer = query.b_offer_1;
        delete query.b_offer_1;
      } 

      if (typeof query.fn != "undefined") {
        this.data.name = query.fn;
        delete query.fn;
      }

      if (typeof query.em != "undefined") {
        this.data.email = query.em;
        delete query.em;
      }

      if (typeof query.ph != "undefined") {
        this.data.cellphone = query.ph;
        delete query.ph;
      }

      if (typeof query.document != "undefined") {
        this.data.document = query.document;
        delete query.document;
      }

      this.metas = query;

      const slug = this.$route.params.product;

      if (slug && slug != "undefined" && !query.prop_id && !query.ch_id) {
        this.getProduct(slug).then(() => {
          this.isCorrectDomain();
        });
      } else if (typeof query.prop_id != "undefined") {
        this.getProposal(query.prop_id);
      } else if (typeof query.ch_id != "undefined") {
        this.getThemeCheckout(slug, query.ch_id);
      } else this.removePreload(true);
    }
  },
  mounted() {
    document.querySelector("body").classList.add("preload");

    this.preload = true;

    // last_seen // definido como 60 segundos
    // setInterval(() => this.saveDataUser(), 1000 * 240);

    this.getQueryUrl();

    this.requestAkamaiLocale();

    this.getGlobalSettings();
  },
  created() {

    window.addEventListener("resize", this.handleResize);

    this.handleResize();

    localStorage.setItem("location", 'BR');

    EventBus.$on("atualizaPais", (data) => {

      this.countryGlobal = data.country_code;

      this.getProduct(
        this.product.id ?? this.$route.params.product,
        data.country_code
      );

      this.preload = true;

      if (data.country_code != "BR") {
        this.etapa_total = 2;
        // selecionando o primeiro método
        if (this.method == "BOLETO") {
          document.querySelector(".nav-link").click();
        }
      } else {
        if (this.possui_endereco) {
          this.etapa_total = 3;
        } else this.etapa_total = 2;
      }

      setTimeout(() => {
        this.preload = false;
      }, 1000);
    });
  },
};
</script>

<style scoped lang="scss">
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.vue-country-select {
  height: 54px;
  min-height: 54px;
  border: 1px solid #e4e4ec !important;
}

.vue-country-select:hover {
  border: 1px solid rgb(0, 228, 160) !important;
  background-color: #fff;
}

::v-deep .input-tel__input {
  cursor: text !important;
}

::v-deep .input-tel__label {
  cursor: text !important;
}

.btn-paypal {
  height: 55px;
  background-color: #000;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  text-transform: none;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-paypal img {
  margin-right: 15px;
}

.icon-lock {
  color: var(--main-color);
  filter: brightness(0.9);
}

.badge-success,
.badge-info {
  padding: 10px 15px;
  font-weight: 600;
  background-color: rgba(65, 137, 230, 0.15);
  color: #3483fa;
  margin-bottom: 20px;
}

.badge-info {
  margin: 0;
  width: 100%;
}

.Product-trial {
  white-space: pre-line;
  text-align: left;
  line-height: 1.5;
}

.etapas {
  max-width: 100%;
  margin: 10px auto 20px auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  //
  position: fixed;
  top: 12px;
  right: 0;
  z-index: 888;
}

.etapas a,
.btn-voltar-step {
  padding: 8px;
  font-weight: 600;
  color: var(--text-color);
  border-radius: 5px;
  font-size: 13px;
  display: flex;
  align-items: center;
  margin-top: -25px;
  margin-bottom: 15px;
}

.btn-voltar-step {
  margin-top: -10px;
  margin-bottom: 0;
}

.btn-voltar-step img {
  transform: rotate(90deg);
  filter: invert(50%);
  margin-right: 10px;
}

.btn-voltar-step:hover {
  text-decoration: none;
}

.etapas p {
  margin: 0;
  font-weight: 600;
  color: #333;
}

/* etapas item */
.icon-etapa {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--transparent);
  display: inline-block;
}

.icon-etapa.target {
  background: var(--transparent-color);
}

.icon-etapa.complete {
  background: var(--main-color) !important;
}

.icon-etapa+.icon-etapa {
  margin-left: 12px;
}

// bump erro
.bumpInfo.noBump::before {
  content: "";
  position: absolute;
  right: 20px;
  top: 20px;
  border-radius: 3px;

  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  background: url("../assets/img/icon/block.svg") no-repeat center center;
}

.cupom-mobile {
  padding: 0 20px;
}

// presente
.gift-content {
  padding: 0 20px;
  margin-bottom: 30px;
}

.padding-checkout {
  padding-top: 3rem;
}

.padding-checkout.mobile {
  padding-top: 1.5rem;
}

.padding-checkout.escassez {
  padding-top: 5rem;
}

.padding-checkout.mobile.escassez {
  padding-top: 4.5rem;
}

.padding-checkout.mobile.escassez.thumb {
  padding-top: 1rem;
}

.is-stick {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9;
}

.column-fixed {
  position: sticky;

  @media screen and (max-width: 768px) {
    position: relative;
    top: 0;
  }

  top: 6rem;
}

.btn-wpp {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  right: 40px;
  background-color: #25d366;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-wpp:hover {
  transform: scale(1.1);
}

.input-es {
  display: flex;
}

.input-es #ES {
  width: 63px;
  border-radius: 5px 0px 0px 5px;
}

.amout-obs {
  color: #999;
  font-size: 0.9rem;
}

.Product-price_2 {
  display: inline-block;
  align-items: center;
  flex-wrap: wrap;
}

.Product-subscription-period {
  margin-left: 4px;
}

.stripe-input-light {
  background-color: #ffffff;
  border: solid 1px #e4e4ec;
}

.stripe-input-dark {
  background-color: #1a1c23;
  border: solid 1px #414249;
}
</style>